{
  "Linecker.Portal.Service.AuthenticationService.LearningSuite.NoOnboardingCoursesAvailableError": "No onboarding courses are available for your locations.",
  "Linecker.Portal.Service.AuthenticationService.LearningSuite.LineckerEmployeeSsoNotAllowedError": "Linecker employees sign in to the onboarding platform with their own password, not via Lipp Portal.",
  "Linecker.Portal.Service.AuthenticationService.LearningSuite.TestAccountsOnlyOutsideProductionError": "In this test environment, signing in to the onboarding platform is only possible with test accounts (@linecker.at, @lipp.cloud).",
  "Linecker.Portal.Service.AuthenticationService.Oidc.OidcInvalidAuthorizationRequestError": "The sign-in request is invalid.",
  "Linecker.Portal.Service.AuthenticationService.Oidc.Mcp.McpInvalidAuthorizationRequestError": "The request of the AI application is invalid or has expired. Please restart the connection in the application.",
  "Linecker.Portal.Service.AuthenticationService.Oidc.Mcp.McpConnectedAppNotFoundError": "This connection no longer exists.",
  "Linecker.Shared.Abstractions.Result.Messages.GenericExceptionError": "Something went wrong.",
  "Linecker.Shared.Abstractions.Result.Messages.Portal.Permissions.UserNotPermittedToAccessEnterpriseError": "The user has no permission to access enterprise {0}!",
  "Linecker.Shared.Abstractions.Result.Messages.Permissions.NotPermittedError": "The user has no permission for this action!",
  "Linecker.Lipp.Connect.POS.SystemManagement.Messages.ErrorMessages.CannotDeactivateLastActiveVoucherTypeError": "The last active voucher type cannot be deactivated.",
  "Lipp.Abstractions.Messages.NoFreeIntegrationSlotsMessage": "No base subscription of this station has a free integration slot.",
  "Lipp.Abstractions.Messages.NoFreeExtensionSlotsMessage": "No base subscription of this station has a free extension slot.",
  "Lipp.Abstractions.Messages.ModuleFamilyMismatchMessage": "This module belongs to a different base subscription.",
  "Lipp.Abstractions.Messages.ModuleKindMismatchMessage": "This module does not fit this slot type.",
  "Lipp.Abstractions.Messages.IntegrationSlotsInUseMessage": "{0} slots are in use, {1} requested. Release integrations first.",
  "Lipp.Abstractions.Messages.ExtensionSlotsInUseMessage": "{0} extension slots are in use, {1} requested.",
  "Lipp.Abstractions.Messages.PmsActiveRoomsExceedMessage": "The PMS has {0} active rooms. Please deactivate rooms there first, then reduce to {1}.",
  "Lipp.Abstractions.Messages.PmsDashboardInvalidRequestMessage": "The PMS dashboard request is invalid.",
  "Lipp.Abstractions.Messages.PmsUnreachableMessage": "The PMS is currently unreachable, so the room count cannot be reduced.",
  "Lipp.Abstractions.Messages.StationNotFoundMessage": "The station with ID {0} was not found.",
  "Lipp.Abstractions.Messages.SubscriptionNotFoundMessage": "The subscription for station {0} and module \"{1}\" was not found.",
  "Lipp.Abstractions.Messages.TooManyPreparedLippPOSMessage": "Station {0} already has the maximum number of prepared subscriptions (one per interval group).",
  "Messages": {
    "HttpError": {
      "0": "No connection could be established.",
      "204": "[204] No Content",
      "400": "[400] Bad Request",
      "401": "[401] Unauthorized",
      "403": "[403] Forbidden",
      "404": "[404] Not Found",
      "405": "[405] Method not allowed",
      "408": "[408] Request Timeout",
      "415": "[415] Unsupported Media Type",
      "499": "[499] Client Closed Request",
      "500": "[500] Internal Server Error",
      "502": "[502] Bad Gateway",
      "503": "[503] Service Unavailable",
      "504": "[504] Gateway Timeout"
    },
    "CustomError": {
      "NoModuleSubscribed": "No module is subscribed.",
      "GzipFailed": "The Gzip method failed.",
      "UngzipFailed": "The Ungzip method failed.",
      "NoUserLoggedIn": "No user logged in.",
      "SelectedStationIdNotSet": "SelectedStationId has not been set.",
      "NoRoomPlanSettingsFound": "No room plan settings found.",
      "UnknownError": "Something went wrong."
    },
    "GraphQL": {
      "Workstation": {
        "NumberTaken": "Number already taken."
      },
      "User": {
        "PinTaken": "Code already taken.",
        "NotFoundById": "Could not find user.",
        "NoUsersFound": "No users found."
      },
      "MailAccount": {
        "CannotFindKeyOrSalt": "Cannot find key or salt to encrypt password.",
        "NotFoundById": "Could not find mail account."
      },
      "MailTemplate": {
        "NotFoundById": "Could not find mail template."
      },
      "Department": {
        "NotFoundById": "Could not find department.",
        "NoDepartmentsFound": "No departments found."
      },
      "Setting": {
        "NotFoundById": "Could not find setting.",
        "DefaultSettingNotFound": "Could not find default setting."
      },
      "BookingCancellationReason": {
        "NotFoundById": "Could not find cancellation reason.",
        "DefaultSettingNotFound": "Cannot find setting for default cancellation reason.",
        "NoCancellationReasonsFound": "No cancellation reasons found."
      },
      "Course": {
        "NotFoundById": "Could not find course.",
        "NoCoursesFound": "No courses found."
      },
      "Table": {
        "NotFoundById": "Could not find table.",
        "NumberTaken": "Number already taken.",
        "RetailDepartmentNotFound": "Cannot find retail department.",
        "HasOpenBookings": "Table \"{0}\" has open bookings and cannot become a requisition table. Please invoice them first.",
        "HasOpenRequisition": "Requisition table \"{0}\" has an open requisition. Please create or clear it first."
      },
      "PaymentMethod": {
        "NotFoundById": "Could not find payment method."
      },
      "Macro": {
        "NotFoundById": "Could not find macro.",
        "NoMacrosFound": "No macros found.",
        "AssignmentsNotSupported": "Assigning revenue groups, commodity groups and articles requires Lipp POS {0} or newer."
      },
      "NumberRange": {
        "NotFoundById": "Could not find number range."
      },
      "Customer": {
        "NotFoundById": "Could not find customer.",
        "NumberRangeNotFound": "Could not find number range for customers.",
        "ProfileImageNotFound": "Could not find image."
      },
      "CommodityGroup": {
        "NotFoundById": "Could not find commodity group.",
        "NoCommodityGroupsFound": "No commodity groups found.",
        "ArticlesStillAssigned": "Could not deactivate commodity group because articles are still assigned.",
        "CannotDeactivateTipOrDiscount": "Could not deactivate commodity group because it is required for tip or discount."
      },
      "CommunicationService": {
        "NotFoundById": "Could not find communication service."
      },
      "Article": {
        "NotFoundById": "Could not find article.",
        "NumberTaken": "Article No. already taken.",
        "BarcodeTaken": "Barcode {0} already taken.",
        "PricelistNotFound": "Cannot find price list for article.",
        "DefaultPricelistNotFound": "Cannot find default price list.",
        "AssignedCommodityGroupNotActive": "Could not activate article because the assigned commodity group {0} is not active.",
        "CannotDeactivateTipOrDiscount": "Could not deactivate article because it is required for tip or discount.",
        "WeightTareNegative": "The tare of an article sold by weight must not be negative.",
        "WeightArticleInPackage": "The article is part of the article package {0} and therefore cannot be sold by weight. Please remove it from the package first."
      },
      "Printer": {
        "NotFoundById": "Could not find printer.",
        "NoPrintersFound": "No printers found.",
        "ArticlesStillAssigned": "Could not delete printer because articles are still assigned.",
        "WorkstationsStillAssigned": "Could not delete printer because workstations are still assigned.",
        "PrinterRedirectionsStillAssigned": "Could not delete printer because printer redirections or additional prints are still assigned."
      },
      "Interface": {
        "NotFoundById": "Could not find integration.",
        "NotFoundByName": "Could not find integration.",
        "NoComSvcAssigned": "No communication service was assigned yet.",
        "ComPortTaken": "COM port {0} is already used by the active integration '{1}'."
      },
      "InterfaceSetting": {
        "NotFoundById": "Could not find setting."
      },
      "PermissionRole": {
        "NotFoundById": "Could not find permission role.",
        "UsersStillAssigned": "Could not delete permission role because users are still assigned."
      },
      "CrossStation": {
        "NotWritten": "Not written because another location failed.",
        "InvalidRequest": "Exactly one article must be passed for creating or editing.",
        "NumberMissing": "Please enter an article number.",
        "ArticleNotInAllStations": "Article {0} does not exist identically in all locations ({1}).",
        "NoDefaultPricelist": "{0} has no active default price list.",
        "NumberTaken": "Article number {0} is already taken in {1}.",
        "BarcodeTaken": "Barcode {0} is already taken in {1}.",
        "WeightArticleInPackage": "Article {0} is part of a package in {1} and cannot be sold by weight there.",
        "PackagePartIsWeightArticle": "Article {0} is sold by weight in {1} and cannot be part of a package there.",
        "DefaultPriceMissing": "Article {0} has no price in the default price list in {1}.",
        "ImageMissing": "The image file of article {0} is missing in {1}.",
        "CommodityGroupMissing": "Commodity group {0} does not exist in {1} (or not uniquely with this tax rate and revenue group).",
        "CommodityGroupInactive": "Commodity group {1} is inactive in {0}; the article cannot be activated there.",
        "PackageGroupLocked": "In {0}, the selection group \"{1}\" contains the component \"{2}\", which does not exist in all locations. The group therefore cannot be removed or renamed.",
        "FullSyncRunning": "A full synchronization of the POS is running in {0}; master data is locked there until it has finished.",
        "ArticleMissing": "The article no longer exists in {0}.",
        "NumberDuplicate": "Article number {0} is used more than once in {1}.",
        "NoStations": "No location was selected.",
        "PosVersionTooOld": "Only locations with Lipp POS {0} or later can be edited across enterprises: {1}.",
        "LayoutProfileMissing": "The layout group no longer exists in {0}.",
        "LayoutProfileMissingOrDuplicate": "The layout group \"{0}\" does not exist in {1} (or exists more than once).",
        "LayoutProfileNameMissing": "The layout group needs a name.",
        "LayoutProfileDuplicate": "The layout group \"{0}\" exists more than once in {1}.",
        "LayoutProfileExists": "The layout group \"{0}\" already exists in all selected locations."
      },
      "CrossStationUsers": {
        "UserMissing": "User {0} no longer exists in the selected locations.",
        "NameNotUnique": "User {0} exists more than once in {1}. Please rename one of them there first.",
        "PermissionRoleMissing": "The permission role no longer exists in {0}. Please choose another one.",
        "PinTaken": "The PIN of {0} is already used by another user in {1}. Please create {0} there on the location's page with a different PIN.",
        "InvalidRequest": "A location of the assignment is not selected. Please reload."
      },
      "LayoutProfile": {
        "NotFoundById": "Could not find layout profile.",
        "WorkstationsStillAssigned": "Layout profile '{0}' cannot be deleted because it is still assigned to the following workstations: {1}. Please assign a different layout profile to the workstation first.",
        "UsersStillAssigned": "Layout profile '{0}' cannot be deleted because it is still assigned to the following users: {1}.",
        "CannotDeleteLast": "The last layout profile cannot be deleted. At least one layout profile must remain."
      },
      "PriceList": {
        "NotFoundById": "Could not find price list.",
        "PricesStillAssigned": "Could not delete price list because prices are still assigned."
      },
      "BookingLock": {
        "NotFoundById": "Could not find booking lock.",
        "UsersStillAssigned": "Could not delete booking lock because users are still assigned."
      },
      "Team": {
        "NotFoundById": "Could not find team.",
        "UsersStillAssigned": "Could not delete team because users are still assigned."
      }
    },
    "Authentication": {
      "ResetPasswordEmailSent": "Email for resetting your password has been sent.",
      "PasswordHasBeenReset": "Your password has been changed successfully.",
      "InterfaceUserStationNotFoundError": "A station with the code {0} could not be found.",
      "NoLoginTokenError": "The user with the email address {0} had no login token created.",
      "PasswordPolicyRequirementsNotMetError": "The password does not meet the password policy requirements.",
      "UserAlreadyConfirmedError": "The user is already confirmed.",
      "UserCannotChangePasswordError": "The user with identifier {0} is not allowed to change the password.",
      "UserChangePasswordOldPasswordIncorrectError": "The provided current user password is not correct.",
      "UserConfirmationConfirmationTokenInvalidError": "The provided confirmation token is invalid.",
      "UserConfirmationNoConfirmationTokenProvidedError": "No confirmation token was provided.",
      "UserNotActiveError": "The user with the email address {0} is not activated.",
      "UserNotAllowedToLoginError": "The user with the email address {0} is not allowed to login.",
      "UserNotAuthorizedError": "The user with the email address {0} is not authorized to login.",
      "UserNotConfirmedError": "The user with the email address {0} has not yet been confirmed.",
      "UserNotFoundByLoginNameError": "A user with the email address {0} could not be found.",
      "UserNotInterfaceUserForStation": "The provided user is not an interface user for the provided station.",
      "UserResetPasswordNoResetTokenProvidedError": "No reset token was provided.",
      "UserResetPasswordResetTokenInvalidError": "The provided reset token is invalid.",
      "UserRegistered": "User has been successfully confirmed."
    },
    "CoreDataService": {
      "Taxes": {
        "TaxNotFoundByIdError": "A tax with id {0} could not be found."
      },
      "TextTemplates": {
        "DefaultTextTemplateCannotBeDeletedError": "The text template with id {0} cannot be deleted as it is a default text template."
      }
    },
    "InvoicingService": {
      "InvalidCreateInvoiceForStationModuleOrderTokenError": "The provided token was incorrect.",
      "InvalidSetInvoicePdfGenerationStateTokenError": "The provided token was incorrect.",
      "LineckerInvoiceFileNotFoundByLineckerInvoiceFileIdError": "An invoice file with id {0} could not be found.",
      "LineckerInvoiceFileNotYetGeneratedError": "The invoice file has not yet been generated.",
      "LineckerInvoiceHeaderNotFoundByIdError": "The invoice header with id {0} could not be found.",
      "StationModuleNotFoundByIdError": "The station module with id {0} could not be found.",
      "StationModuleNotFoundByStationModuleOrderIdError": "<<OBSOLETE>>",
      "StationModuleOrderIsNotReadyForBillingWarning": "<<OBSOLETE>>",
      "LineckerInvoiceHeaderAlreadyFullyCancelledError": "The invoice with id {0} has already been fully cancelled.",
      "LineckerInvoiceHeaderAmountToCancelToBigError": "The gross amount to cancel {0} for the invoice with id is too big.",
      "CreateCancellationInvoiceNoAssociatedPaymentFoundError": "No associated payment for the invoice with id {0} has been found.",
      "LineckerInvoiceHeaderIsCurrentlyExportingToPdfError": "The invoice with id {0} is currently being exported to PDF.",
      "LineckerInvoiceHeaderIsCurrentlyBeingSentPerEmailError": "The PDF file of invoice with id {0} is currently being sent via email."
    },
    "LicensingService": {
      "InvalidAddStationModuleTransactionLogTokenError": "The provided token was invalid.",
      "InvalidSetStationModuleStateTokenError": "The provided token is invalid.",
      "InvalidSetSubscriptionStateTokenError": "The provided token for setting the subscription state was incorrect.",
      "StationModuleNotFoundByIdError": "The station module with id {0} could not be found.",
      "StationModuleOrders.InvalidSetStationModuleOrderStateTokenError": "The provided token for setting the station module order state was incorrect.",
      "StationModuleOrders.StationModuleOrderNotFoundByIdError": "The station module order with id {0} could not be found.",
      "SubscriptionPriceLevelDetailNotFoundByIdError": "The subscription price level detail with id {0} could not be found.",
      "SubscriptionPriceLevelDetailNotInUserSubscriptionPriceLevel": "The provided subscription price level detail with id {0} does not belong to the user's subscription price level with id {1}.",
      "SubscriptionPriceLevelNotFoundByIdError": "The subscription price level with id {0} could not be found.",
      "TrialNotAvailableError": "There is either no trial available or the trial has already been used.",
      "ModuleAlreadyActivatedError": "This Module has already been activated!",
      "StationModulePaymentLandingPageNotFoundError": "The page could not be found!",
      "StationModulePaymentLandingPageAlreadyConfirmedError": "The payment for module has already been confirmed!",
      "StationModulePaymentLandingPageNotFoundByUrlError": "The page could not be found!",
      "StationModulePaymentLandingPageInactiveError": "The page is no longer active!",
      "NoPaymentMethodsDefinedForEnterpriseError": "The enterprise with ID {0} and Stripe customer no {1} has no payment methods defined!",
      "NoPaymentMethodsDefinedForStationIdError": "The station with ID {0} has no payment methods defined via its enterprise!",
      "PaymentMethodNotAvailableError": "The payment method {0} is not available. It either doesn't exist or is outdated.",
      "ActivateStationModuleHasPaymentMethodsDefinedError": "The station with ID {0} has payment methods defined via its enterprise! Please provide one to activate the module!",
      "ActivateStationModuleMultipeDTOsDefinedError": "You defined mutiple activation DTOs in the {nameof(ActivateStationModuleDTO)}. This is not valid. Only one of them may be defined when activating / changing a module!",
      "PaymentMethodExpiredError": "The payment method has expired and cannot be used.",
      "GetFreshdeskCustomerError": "Customer is not available in Freshdesk. Please check!"
    },
    "LippVoucherService": {
      "InitialLippVoucherBookingCannotBeUndoneError": "The initial booking of a voucher cannot be undone.",
      "InvalidCreateLippVoucherTokenError": "The provided token was invalid.",
      "InvalidDeactivateLippVoucherTokenError": "The provided token was invalid.",
      "InvalidGetLippVoucherTokenError": "The provided token was invalid.",
      "InvalidSetLippVoucherPdfGenerationStatusTokenError": "The provided token was incorrect.",
      "InvalidSetLippVoucherSendStatusTokenError": "The provided token was incorrect.",
      "LippVoucherAlreadyBilledError": "This voucher has already been billed and thus cannot be deactivated.",
      "LippVoucherBlockedByOtherUserError": "The voucher {0} is currently blocked by another user.",
      "LippVoucherBookingIsAlreadyUndoneError": "The booking with transaction id {0} has already been undone.",
      "LippVoucherBookingNotFoundByIdentifierAndTransactionIdError": "A booking with the identifier {0} and transaction id {1} could not be found.",
      "LippVoucherFileNotFoundByLippVoucherFileIdError": "A voucher file with id {0} could not be found.",
      "LippVoucherHasNoRestAmountError": "The voucher {0} has no rest amount.",
      "LippVoucherInsufficientRestAmountError": "The voucher {0} does not have a sufficient rest amount.",
      "LippVoucherNotActiveError": "The voucher {0} is not active. Reason: {1}.",
      "LippVoucherNotFoundByIdentifierError": "A voucher with the identifier {0} could not be found.",
      "LippVoucherNotFoundByIdError": "A voucher with id {0} could not be found.",
      "LippVoucherToCancelIsInactiveError": "The voucher to cancel is inactive (Reason: {0}) and can therefore not be cancelled.",
      "LippVoucherToCancelNotFoundByIdError": "The voucher to cancel with id {0} could not be found."
    },
    "MessagingService": {
      "BadRequestError": "The SMS provider returned a bad request! (400)",
      "FromNameTooLongError": "From name is too long. Only 11 characters are allowed!"
    },
    "NumberRangeService": {
      "InvalidChangeReservationStateTokenError": "The provided token was invalid.",
      "InvalidGetNumberWithTokenError": "The provided token was invalid.",
      "NumberRangeCannotBeDeletedHasDependentDataError": "The number range with id {0} cannot be deleted as it has dependent data.",
      "NumberRangeJournalCannotFreeAlreadyFixedError": "The number range journal with the id {0} has already been fixated and thus cannot be freed."
    },
    "PaymentsService": {
      "InvalidCancelSubscriptionForStationModuleTokenError": "The provided token is invalid.",
      "NoModulesForPurchaseDefinedError": "There were no modules defined for purchase.",
      "Stripe": {
        "StationIdAssociatedWithStripeSessionIdNotFoundError": "The Stripe session's station id could not be determined.",
        "StripeSessionIdNotFoundError": "The Stripe session id could not be determined.",
        "NoCustomerIdDefinedInEnterpriseError": "There is no Stripe customer id defined for the enterprise with id {0}.",
        "UnknownPaymentMethodError": "The provided payment method {0} is either unknown or not supported."
      },
      "CannotSetDefaultPaymentMethodCreditCardExpiresIn30DaysOrLessError": "Default payment method must be valid for at least 30 days.",
      "NoDefaultPaymentMethodDefinedError": "There is no default payment method defined for the enterprise with id {0}.",
      "PaymentProviderPaymentMethodNotFoundByIdError": "The payment method with id {0} could not be found for payment provider {1}.",
      "PaymentProviderPaymentMethodAlreadyExpiredError": "The payment method with id {0} for payment provider {1} is already expired.",
      "CannotDeleteDefaultPaymentMethodError": "The default payment method cannot be deleted.",
      "UpdateExistingPaymentMethodTokenCurrentlyReplacingError": "The process to update an existing payment method for the provided token {0} is currently being executed.",
      "UpdateExistingPaymentMethodTokenNotFoundError": "The provided token {0} to update an existing payment method could not be found.",
      "UpdateExistingPaymentMethodTokenAlreadyReplacedError": "The provided token {0} was already used to replace the existing payment method.",
      "PaymentInfoIdNotAssociatedWithCustomerIdError": "The payment method with id {0} is not associated with the payment provider's customer with id {1}."
    },
    "ProtocolService": {
      "InvalidGetProtocolEntriesTokenError": "The provided token was incorrect."
    },
    "ReportingService": {
      "RenderLineckerInvoiceCurrentlyBlockedByAnotherProcess": "The RenderLineckerInvoice methods is currently blocked by another process."
    },
    "RoomReservationService": {
      "NoSearchParametersDefinedError": "The provided search parameters were all empty."
    },
    "Shared": {
      "CustomFieldDefinitionNotFoundError": "No CustomFieldDefinition with id {0} found!",
      "DefaultValueDatatypeNotValidError": "The provided default value does not match with the selected data type!",
      "InvalidVatIdLengthError": "The provided VAT Id has to contain at least 9 characters!",
      "InvalidVatIdStartError": "The VAT Id has to start with 2 letters!",
      "ModuleNotFoundByIdError": "No module with id {0} found!",
      "NoTokenProvidedError": "No token was provided, although one is required for this operation.",
      "Settings": {
        "LevelMustBeGreaterThanZeroError": "The Level must be greater than 0."
      },
      "Validation": {
        "ValidationError": "N/A"
      },
      "Messaging": {
        "Mailer": {
          "NoRecipientDefinedError": "No recipient was defined.",
          "NoSubjectDefinedError": "No subject was defined."
        }
      }
    },
    "SignalRGatewayService": {
      "LinkedRoomReservationNotFoundBySourceId": "Could not find the linked room reservation with source id {0}.",
      "ReservationGroupNotFoundBySourceId": "Could not find reservation group with source id {0}.",
      "RoomCategoryNotDefinedError": "No room category was defined for room with source id {0}",
      "RoomCategoryNotFoundError": "The room category with source id {0} could not be found.",
      "RoomCleaningStateNotFoundError": "The room cleaning state with source id {0} could not be found.",
      "RoomNotDefinedForReservationError": "No room was defined for reservation with source id {0}",
      "RoomNotDefinedForRoomLockError": "No room was defined for room lock with source id {0}",
      "RoomNotFoundForReservationBySourceIdError": "Could not find room with source id {0}.",
      "RoomNotFoundForRoomLockBySourceIdError": "Could not find room with source id {0}."
    },
    "TableReservationService": {
      "AssignedTableDoesNotExistError": "The table with ID {0} does not exist!",
      "AssignedTablesDoNotExistError": "The assigned tables do not exist!",
      "DepartmentNotFoundByIdError": "An department with id {0} could not be found.",
      "ExceedingTheMaximumNumberOfPersonsError": "Exceeding the maximum number of persons!",
      "FallingBelowTheMinimumNumberOfPersonsError": "Falling below the minimum number of persons!",
      "InvalidTableReservationPaymentStatusTokenError": "The provided token was invalid.",
      "NoOvercrowdingAllowedError": "No overcrowding allowed. Table(s) do not have enough seats!",
      "TableAvailableCheckNotInOpeningHoursError": "The requested time period is outside the Station's opening hours.",
      "TableIsAlreadyBookedError": "A selected table is already reserved in this period!",
      "TableIsNotActiveError": "The table with id {0} is not active or not available for reservation!",
      "TableNotFoundByIdError": "A table with id {0} could not be found.",
      "TableReservationAutoConfirmNotAllPaxAssignedWarning": "Not all pax in table reservation with id {0} could not be automaticalled assigned to a table. Pax still to assign: {1}.",
      "TableReservationCustomerInformationNotFoundError": "Customerinformation with id: {0} not found!",
      "TableReservationIsInThePastError": "The table reservation is in the past!",
      "TableReservationNotFoundByIdError": "A tablereservation with id {0} could not be found.",
      "TableReservationNotInOpeningHoursError": "Tablereservation is not in opening hours!",
      "TableReservationNotInOpeningHoursOfDepartmentError": "Tablereservation is not in opening hours of Department {0}!",
      "TableReservationSnippetNotFoundError": "No tablereservation widget found for station id {0}",
      "TableReservationSnippetNotFoundForSnippetIdError": "No tablereservation widget found for widget id {0}",
      "TableSeatsExceededError": "Table does not have enough seats!"
    },
    "GenericExceptionAsWarning": "N/A",
    "GenericExceptionError": "N/A",
    "Licenses": {
      "ProvidedModuleNotLicensedError": "The provided module {0} is either not licensed or has the wrong license count!"
    },
    "Permissions": {
      "NotPermittedError": "The user has no permission for this action!",
      "UserNotPermittedToAccessEnterpriseError": "The user has no permission to access enterprise {0}!"
    }
  },
  "Portal": {
    "Messages": {
      "ClientsService": {
        "EnterpriseNotFoundByIdError": "An enterprise with id {0} could not be found.",
        "EnterpriseWithStationOverviewToDateLessThanFromDateError": "The provided to date is less than the from date.",
        "NoStationIdsDefinedError": "There were no station IDs defined.",
        "StationBusinessHolidayNotFoundByIdError": "A station business holiday definition with id {0} could not be found.",
        "StationBusinessHolidayToDateLessThanFromDateError": "The to date is less than the from date.",
        "StationBusinessHourNotFoundByIdError": "A station business hour definition with id {0} could not be found.",
        "StationNotFoundByIdError": "A station with id {0} could not be found.",
        "StationNotFoundByStationCodeError": "A station with the code {0} could not be found.",
        "StationTimePlanHasNoTimePlansDefinedInfo": "The station with id {0} has no timeplans defined.",
        "StationTimePlanNotDeletableDueToDependentDataError": "The time plan with id {0} cannot be deleted due to dependent data: Departments: {1}, Settings: {2}, TableReservationCustomerInformation: {3}",
        "StationTimePlanNotFoundByIdError": "A station timeplan definition with id {0} could not be found.",
        "StationTimePlanPeriodDayNotFoundByIdError": "A station timeplan period day definition with id {0} could not be found.",
        "StationTimePlanPeriodNotFoundByIdError": "A station timeplan period definition with id {0} could not be found.",
        "TransferStationStationAlreadyAssignedToTargetEnterpriseIdError": "The station with id {0} is already assigned to enterprise with id {1}",
        "UserGroupHasUsersAssignedError": "The user group with id {0} has users assigned to it.",
        "UserGroupNotFoundByIdError": "A user group with id {0} could not be found.",
        "UserNotFoundByIdError": "A user with id {0} could not be found.",
        "UserNotFoundByLoginNameError": "A user with the identifier {0} could not be found.",
        "UserNotFoundError": "The user could not be found.",
        "UserNotPermittedForAnyOfProvidedStationIdsError": "The user has no permission for any of the provided station IDs.",
        "UserWithLoginNameAlreadyExistsError": "The user with the login name {0} already exists!",
        "LineckerCustomerNoAlreadyInUseWarning": "The customer number is already in use in {0} other enterprises: <ul>{1}</ul>Please check if the mutliple use is really ok! The data has been saved anyway.",
        "StripeCustomerNoAlreadyInUseWarning": "The stripe customer number is already in use in {0} other enterprises: <ul>{1}</ul>Please check if the mutliple use is really ok! The data has been saved anyway."
      },
      "FileService": {
        "FileNotFoundError": "A file with the id {0} could not be found.",
        "InvalidGetFilesWithActionTokenError": "The provided token was incorrect.",
        "InvalidGetFileWithActionTokenError": "The provided token was incorrect."
      },
      "MessagingService": {
        "MessagingTokenInvalidError": "The provided messaging token is invalid.",
        "InvalidSmtpConfigurationError": "The SMTP configuration is not correct."
      }
    }
  },
  "Errors": {
    "Required": "Please fill in the field.",
    "BelowMinimum": "The entered value is too small.",
    "InvalidEmail": "Please enter a valid email.",
    "InvalidUrl": "Please enter a valid URL.",
    "InvalidVatId": "Please enter a valid VAT id.",
    "CountryAndVatIdNotMatching": "The country and VAT id are not matching.",
    "EmailNotUnique": "The email is already taken.",
    "PasswordsNotMatching": "The passwords are not matching.",
    "PasswordDoesNotMeetRequirements": "The password must be at least 8 characters long, contain an upper and lower case letter and a number.",
    "MultiInput": {
      "Duplicate": "This entry already exists.",
      "NaN": "Please enter a valid number."
    },
    "UnknownError": "Something went wrong."
  },
  "FatalError": {
    "LoadingApiInfo": "API info could not be loaded",
    "LoadingCountries": "Countries could not be loaded",
    "LoadingCurrencies": "Currencies could not be loaded",
    "LoadingSalutations": "Salutations could not be loaded",
    "LoadingUser": "User could not be loaded",
    "LoadingSettings": "Settings could not be loaded",
    "LoadingPermissions": "Permissions could not be loaded",
    "LoadingPartnerEnterprise": "Partner enterprise could not be loaded",
    "LoadingSelectedEnterprise": "Selected enterprise could not be loaded",
    "LoadingEnterprises": "Enterprises could not be loaded",
    "SignalRNotConnected": "Not connected to the server. Please reload the page."
  },
  "Authentication": {
    "Login": {
      "Title": "Login",
      "Email": "Email",
      "Password": "Password",
      "ForgotPassword": "Forgot Password?",
      "Login": "Login",
      "PasswordExpiredInfo": {
        "Title": "Password expired",
        "Description": "The password for the email <b>{0}</b> must be changed."
      }
    },
    "ForgotPassword": {
      "Title": "Forgot Password?",
      "Info": "Please enter your email to reset your password.",
      "Email": "Email",
      "BackToLogin": "Back to login",
      "ResetPassword": "Reset Password"
    },
    "ChangePassword": {
      "Title": "Change password",
      "Email": "Email",
      "NewPassword": "New password",
      "RepeatNewPassword": "Repeat new password",
      "Change": "Change",
      "BackToLogin": "Back to login"
    },
    "RegisterUser": {
      "Title": "Confirm registration",
      "Firstname": "First name",
      "Lastname": "Last name",
      "Password": "Password",
      "RepeatPassword": "Repeat password",
      "Confirm": "Confirm"
    },
    "SessionExpired": "Session expired"
  },
  "InfoPage": {
    "BackToLippPortal": "Back to Lipp Portal"
  },
  "ConfirmRegistration": {
    "Successful": {
      "Title": "Your registration has been confirmed successfully.",
      "Description": "You will be automatically redirected to the Lipp Portal shortly..."
    },
    "Failed": {
      "Title": "Unfortunately, we could not confirm your registration."
    }
  },
  "Maintenance": {
    "Title": "We'll be back soon!",
    "Description": "Lipp Portal is currently undergoing maintenance...",
    "ReloadPage": "Reload page"
  },
  "Error": {
    "Title": "Something went wrong.",
    "Description": "Please try again.",
    "ReloadPage": "Reload page"
  },
  "Payment": {
    "Failed": {
      "Title": "Unfortunately, your payment has failed.",
      "Description": "You will be automatically redirected to the Lipp Portal shortly...",
      "BackToLippPortal": "Back to Lipp Portal"
    },
    "Successful": {
      "Title": "Thank you! Your payment was successful.",
      "Description": "You will be automatically redirected to the Lipp Portal shortly...",
      "BackToLippPortal": "Back to Lipp Portal"
    },
    "Pay": {
      "ErrorLoading": "Payment link could not be loaded"
    },
    "Confirm": {
      "Title": "We are pleased that you have chosen a Lipp product!",
      "Description": "You're ready in just a few steps. *net prices*",
      "Subscribe": "Subscribe",
      "Order": "Order",
      "SelectPaymentInterval": "Select payment interval",
      "SelectPaymentMethod": "Select payment method",
      "Policy": "I have read and agree to the <a href='https://www.linecker.at/datenschutzerklaerung/' target='_blank'>privacy policy</a> & <a href='https://www.linecker.at/agb/' target='_blank'>terms and conditions</a>.",
      "Costs": "Costs",
      "Total": "Total",
      "ErrorLoading": "Could not load module",
      "PaymentFailed": "Payment failed",
      "PaymentNotCompleted": "The Payment has not been completed.",
      "3DSConfirmationFailed": "The 3DS confirmation for the payment has failed.",
      "Test": "Test {0}",
      "TrialUntil": "Trial until {0}",
      "TrialInfo": "At the end of the trial period, the subscription will be started and the data you have already entered will be retained.",
      "Start": "Start",
      "Devices": "Devices",
      "LippCare": "Lipp Care (All-in-carefree)",
      "Aliquotation": {
        "Title": "Increase {0}x {1} to {2}x {3}",
        "Costs": "Costs aliquot",
        "LippCareTitle": "Increase Lipp Care"
      },
      "Reduction": {
        "Title": "Reduce {0}x {1} to {2}x {3}",
        "Costs": "Costs"
      }
    },
    "ConfirmationMail": "Email (confirmation link)"
  },
  "Invoices": {
    "Title": "Invoices",
    "Partner": "Partner",
    "CustomerNumber": "Customer no.",
    "InvoiceNumber": "Invoice number",
    "InvoiceDate": "Invoice date",
    "PaidAtUTC": "Direct debit date",
    "PaymentReference": "Payment reference",
    "Enterprise": "Enterprise",
    "Station": "Station",
    "Subscription": "Subscription",
    "Amount": "Amount",
    "ErrorOpening": "Invoice could not be opened",
    "ErrorDownloading": "Invoice could not be downloaded",
    "SendEmail": {
      "Title": "Send invoice by email",
      "Recipient": "Recipient",
      "Success": {
        "Title": "Sent invoice",
        "Description": "The invoice has been sent to <b>{0}</b> by email."
      },
      "Error": "Invoice could not be sent",
      "And": "and"
    },
    "PdfNotGeneratedTooltip": "Invoice is being generated...",
    "ContextMenu": {
      "Correct": "Correct billing address",
      "Credit": "Create credit note",
      "Cancel": "Cancel completely",
      "Stripe": "Stripe record"
    },
    "ErrorGettingStripeUrl": "Could not get Stripe record",
    "StripeLinkNotAvailable": "The link to Stripe is not available.",
    "MonthlyReport": "Monthly report",
    "ErrorDownloadingMonthlyReport": "Could not download monthly report",
    "NoDataInThisPeriod": "No data available in this period.",
    "BMDExport": "BMD export",
    "ErrorDownloadingBMDExport": "Could not download BMD export"
  },
  "Profile": {
    "Title": "Profile settings",
    "RemoveProfileImage": "Remove profile image",
    "Email": "Email",
    "FirstName": "First name",
    "LastName": "Last name",
    "Language": "Language",
    "CurrentPassword": "Current password",
    "NewPassword": "New password",
    "RepeatNewPassword": "Repeat new password",
    "Theme": {
      "Title": "Theme",
      "Browser": "Browser",
      "Light": "Light",
      "Dark": "Dark"
    },
    "SuccessChanging": {
      "Title": "Changed user",
      "Description": "The user <b>{0}</b> has been changed successfully."
    },
    "ErrorChanging": "User could not be changed",
    "ConnectedApps": {
      "Title": "Connected applications",
      "Description": "Applications such as ChatGPT or Claude that you have given access to your Lipp Portal. Disconnecting takes effect immediately.",
      "None": "No connected applications.",
      "ConnectedSince": "connected since {0}",
      "LastUsed": "last used {0}",
      "Revoke": "Disconnect",
      "Revoked": {
        "Title": "Disconnected",
        "Description": "<b>{0}</b> no longer has access to your Lipp Portal."
      },
      "RevokeError": "Could not disconnect the application",
      "LoadError": "The connected applications could not be loaded.",
      "Retry": "Reload"
    },
    "McpUrl": {
      "Title": "Address for AI applications (MCP server)",
      "Copy": "Copy",
      "Copied": "Address copied",
      "CopyError": "Address could not be copied",
      "Description": "Enter this address in ChatGPT, Claude or another AI application as an MCP server. When connecting for the first time, you sign in with your Lipp Portal account and grant access; the application then appears in the list above."
    }
  },
  "Header": {
    "Profile": {
      "User": "User",
      "ProfileSettings": "Profile settings",
      "Invoices": "Invoices",
      "Logout": "Logout"
    },
    "Help": {
      "Title": "Help",
      "Tutorials": "Tutorials",
      "TutorialsError": "Tutorials could not be opened",
      "Updates": "Updates"
    }
  },
  "Sidebar": {
    "Dashboard": "Dashboard",
    "Enterprises": "Enterprises",
    "Users": "Users",
    "Marketplace": "Marketplace",
    "SearchStationsPlaceholder": "Search stations...",
    "CrossEnterprise": {
      "Long": "Cross-Enterprise",
      "Short": "CE"
    },
    "Modules": {
      "Statistics": "Statistics",
      "TableReservation": "Table reservation",
      "RoomPlan": "Room plan",
      "CloudBackup": "Cloud backup",
      "LippBon": "Lipp Bon",
      "DigitalReceipt": "Digital receipt",
      "LippCare": "Lipp Care",
      "LippPOS": "Lipp POS",
      "LippPMS": "Lipp PMS",
      "Vouchers": "Voucher management"
    },
    "FooterDialog": {
      "Name": "Linecker GmbH",
      "Sales": "Advice & Sales",
      "PosSupport": "POS support",
      "HotelSupport": "Hotel support",
      "Accounting": "Accounting",
      "T&C": "T&C",
      "PrivacyPolicy": "Privacy Policy"
    }
  },
  "Dashboard": {
    "TotalProfit": {
      "Title": "Total Profit",
      "Monthly": "Monthly",
      "Yearly": "Yearly",
      "ErrorLoading": "Total Profit could not be loaded"
    },
    "Actives": {
      "Title": "Actives",
      "Enterprises": "Active Enterprises",
      "Stations": "Active Stations",
      "Users": "Active Users",
      "OccupiedCloudStorage": "Occupied Cloud Store",
      "ErrorLoading": "Actives could not be loaded"
    },
    "Facts": {
      "Title": "Facts",
      "ActivatedModules": "Activated Modules",
      "DeactivatedModules": "Deactivated Modules",
      "LoginsLippPortal": "Logins Lipp Website",
      "LoginsLippApp": "Logins Lipp App",
      "ErrorLoading": "Facts could not be loaded"
    },
    "ActivatedModules": {
      "Title": "Activated Modules",
      "Count": "Count",
      "Enterprises": "Enterprises",
      "CountMonthly": "Count monthly",
      "SumMonthly": "Sum monthly",
      "CountYearly": "Count yearly",
      "SumYearly": "Sum yearly",
      "SumMonthlyOfAllModules": "Sum monthly of all modules",
      "Total": "Total",
      "AllPartners": "All partners",
      "AllPaymentMethods": "All payment methods",
      "ErrorLoading": "Activated modules could not be loaded",
      "ErrorLoadingPartners": "Partner enterprises could not be loaded"
    },
    "CustomModules": {
      "Title": "Custom Modules",
      "Count": "Count",
      "Enterprises": "Enterprises",
      "CountMonthly": "Count monthly",
      "CostsMonthly": "Costs monthly",
      "SumMonthly": "Sum monthly",
      "CountYearly": "Count yearly",
      "CostsYearly": "Costs yearly",
      "SumYearly": "Sum yearly",
      "SumMonthlyOfAllModules": "Sum monthly of all modules (profit)",
      "Total": "Total",
      "ErrorLoading": "Custom Modules could not be loaded"
    }
  },
  "Modules": {
    "Overview": {
      "Title": "Modules",
      "Module": "Module",
      "ErrorLoadingModules": "Could not load modules",
      "Activated": "Activated",
      "NoModulesActivated": "No modules activated.",
      "NotActivated": "Not activated",
      "CancelModules": "Cancel modules",
      "ErrorLoadingCancelableModules": "Could not load cancelable modules",
      "ErrorStartingTrial": "Could not start trial",
      "ErrorRedirectingToCheckout": "Could not redirect to checkout",
      "ErrorLoadingPaymentMethods": "Could not load payment methods",
      "AddPaymentMethod": "Please add a <u>payment method</u>!"
    },
    "Shop": {
      "Title": "Shop",
      "Tooltip": "Available soon!"
    },
    "Log": {
      "Title": "Log",
      "ModuleName": "Module name",
      "Description": "Description",
      "InternalNotes": "Internal notes",
      "User": "User",
      "DateTime": "Date/Time"
    },
    "TableReservation": {
      "Title": "Table reservation",
      "Description": "Achieve optimal utilization of your tables through reservations. Including booking widget for your website."
    },
    "RoomPlan": {
      "Title": "Hotel package",
      "Description": "Live statistics, room plan, searching reservations & blocking rooms."
    },
    "LippBon": {
      "Title": "Lipp Bon",
      "Description": "Hybrid cash register app <br> Wi-Fi, mobile internet and offline in one app.",
      "Description1": "Hybrid cash register app",
      "Description2": "Wi-Fi, mobile internet and offline",
      "Description3": "in one app.",
      "Tooltip": "Offline booking is possible, but a connection to the cash desk is required for billing (cash, invoice, PMS transfer, etc.).",
      "GPtom": {
        "Title": "Genius mobile pay",
        "Description": "Combined with Lipp Bon, NFC card payments can be processed directly via the Android smartphone."
      },
      "Incert": {
        "Title": "Incert",
        "Description": "Redeem vouchers using the Lipp Bon (hybrid voucher app) via Incert."
      },
      "POSit": {
        "Title": "POSit",
        "Description": "Combined with Lipp Bon, NFC card payments can be processed directly via the Android smartphone."
      }
    },
    "LippPMS": {
      "Title": "Lipp PMS",
      "Description": "Hotel software for your business. Cloud backup, tutorial videos, customer service and initial installation included.",
      "Room": {
        "Title": "Room",
        "Description": "Per room in Lipp PMS."
      },
      "IntegrationSlot": {
        "Title": "Integration slot",
        "Description": "One place for an interface in Lipp PMS."
      },
      "LippPos": {
        "Title": "Lipp POS",
        "Description": "Lipp PMS and Lipp POS work hand in hand: checked-in guests can be charged at the POS right away, restaurant bills go straight to the room. Included."
      },
      "ManualRegistration": {
        "Title": "Manual guest registration",
        "Description": "Registration forms are created and numbered as usual, printed and signed by the guest – without an electronic registration office. Included."
      },
      "FeratelRegistration": {
        "Title": "feratel guest registration",
        "Description": "Lipp PMS sends guest registrations to feratel automatically."
      },
      "CardXperts": {
        "Title": "cardXperts guest registration",
        "Description": "Registration forms as a file for cardXissue."
      },
      "ExternalPos": {
        "Title": "Third-party POS",
        "Description": "Connect a POS from another vendor via the open partner interface: it sees who is in house and posts restaurant bills to the room."
      },
      "Incert": {
        "Title": "Incert",
        "Description": "Redeem Incert vouchers and value cards directly on the invoice and top up cards in daily business."
      },
      "SmartnessRevenue": {
        "Title": "Smartness",
        "Description": "Lipp PMS sends room categories, allotments and reservations to Smartness and takes over the prices and minimum stays calculated there."
      },
      "SaltoSpace": {
        "Title": "Salto Space",
        "Description": "Access cards are encoded for the reservation and automatically invalidated on check-out, cancellation or room change. Connected via the Lipp PMS Connector on site."
      },
      "ZvtTerminal": {
        "Title": "ZVT payment terminal",
        "Description": "Card payment on invoices and deposits via a ZVT terminal on site, connected via the Lipp PMS Connector."
      },
      "SixTimTerminal": {
        "Title": "SIX TIM",
        "Description": "Worldline/SIX payment terminals (TIM protocol) for card payments on invoices and deposits, including the terminal's end-of-day closing. Connected via the Lipp PMS Connector on site."
      },
      "Fias": {
        "Title": "FIAS",
        "Description": "Connect the telephone system and door lock system on site (e.g. Loxone) via the FIAS protocol. Connected via the Lipp PMS Connector."
      },
      "AlpineBits": {
        "Title": "AlpineBits",
        "Description": "Open standard of the channel managers in the Alps: Lipp PMS sends allotments and prices and fetches bookings automatically."
      },
      "Vioma": {
        "Title": "vioma",
        "Description": "Lipp PMS sends availability, prices and restrictions to the vioma Clearing Station and fetches bookings automatically."
      },
      "Interalp": {
        "Title": "Interalp",
        "Description": "Lipp PMS sends allotments to Interalp and fetches prices and reservations from there."
      },
      "Dirs21": {
        "Title": "DIRS21",
        "Description": "Channel manager and booking engine: Lipp PMS sends availability, prices and restrictions and fetches reservations automatically."
      },
      "FeratelChannel": {
        "Title": "feratel Deskline",
        "Description": "Channel manager of the tourism destinations: Lipp PMS sends availability, prices and restrictions and fetches bookings automatically."
      },
      "CapCorn": {
        "Title": "CapCorn",
        "Description": "Booking engine and channel manager: Lipp PMS sends availability and restrictions and fetches bookings – right away when CapCorn reports a new one."
      },
      "Seekda": {
        "Title": "seekda",
        "Description": "Channel manager and booking engine by seekda."
      },
      "Channex": {
        "Title": "Channex (Booking.com)",
        "Description": "Channel manager Channex, starting with Booking.com: Lipp PMS sends availability, prices and restrictions and fetches bookings automatically."
      },
      "Websline": {
        "Title": "Websline",
        "Description": "Website and booking engine by Websline: bookings, payments and online pre-check-in go straight into Lipp PMS, Websline vouchers are redeemed on the invoice."
      },
      "Guestnet": {
        "Title": "Guestnet",
        "Description": "Digital guest directory: guests see their stay, check in online, charge to their room, pay and check out on their own once the balance is settled."
      },
      "Brandnamic": {
        "Title": "Brandnamic",
        "Description": "Guest relations and marketing: Lipp PMS passes offers and reservations to Brandnamic, which creates the correspondence with the guest. With the Brandnamic voucher app, vouchers are also redeemed on the invoice."
      },
      "Reguest": {
        "Title": "Re:Guest",
        "Description": "Inquiries, offers and guest communication: Re:Guest fetches room types, rate plans and availability from Lipp PMS and sends accepted reservations straight into Lipp PMS."
      },
      "KunLeiSys": {
        "Title": "KunLeiSys",
        "Description": "Guest club with loyalty points, guest levels and vouchers: points and level are shown in the guest file, points and vouchers are redeemed on the invoice."
      },
      "Trakklab": {
        "Title": "trakklab",
        "Description": "Call management and caller identification: trakklab recognizes who is calling based on the guests and reservations from Lipp PMS."
      },
      "BmdExport": {
        "Title": "BMD",
        "Description": "Export the invoices of a period as a BMD file for your tax advisor. BMD and DATEV are mutually exclusive."
      },
      "DatevExport": {
        "Title": "DATEV",
        "Description": "Export the invoices of a period as a DATEV posting batch for your tax advisor. BMD and DATEV are mutually exclusive."
      },
      "ExtensionSlot": {
        "Title": "Extension slot",
        "Description": "One place for an extension in Lipp PMS."
      },
      "WebsiteBooking": {
        "Title": "Booking on your own website",
        "Description": "Guests book commission-free directly on your website, and the reservation goes straight into Lipp PMS."
      },
      "Seminarplan": {
        "Title": "Seminar management",
        "Description": "Seminar rooms in a weekly plan with recurring sessions, catering per session and equipment. Set up in Lipp PMS."
      },
      "RevenueManagement": {
        "Title": "Revenue Management",
        "Description": "Occupancy, average rate and RevPAR at a glance, room prices adjusted to demand with your own rules. Set up in Lipp PMS."
      },
      "Newsletter": {
        "Title": "Newsletter",
        "Description": "Newsletters to guests who gave consent, with audiences from the guest file, building blocks in your house colours and sending at the right time. Set up in Lipp PMS."
      }
    },
    "LippPOS": {
      "Title": "Lipp POS",
      "Description": "With Lipp POS cash register software, managing your business has never been easier — it's intuitive, cloud-based, and compliant with legal requirements.",
      "BMD": {
        "Title": "BMD",
        "Description": "Export of booking data for further processing in BMD."
      },
      "DATEV": {
        "Title": "DATEV",
        "Description": "Export of booking data for further processing in DATEV."
      },
      "AidaX": {
        "Title": "AIDA.x",
        "Description": "Lipp POS automatically transfers PMS transfers and all relevant sales to the hotel software AIDA.x - for a smooth process between the cash register and reception."
      },
      "Eucasoft": {
        "Title": "Eucasoft",
        "Description": "Lipp POS automatically transfers PMS transfers and all relevant sales to the Eucasoft hotel software - for a smooth process between the cash register and reception."
      },
      "AsaASCII": {
        "Title": "ASA Ascii",
        "Description": "Lipp POS automatically transfers PMS transfers to the hotel software via the ASA Ascii interface - for a smooth process between the cash register and reception."
      },
      "Sihot": {
        "Title": "SIHOT",
        "Description": "Lipp POS automatically transfers PMS transfers and all relevant revenues to the SIHOT hotel software - for a smooth process between the cash register and reception."
      },
      "Scale": {
        "Title": "Scale",
        "Description": "Connects counter scales via the Checkout Dialog 06 protocol. Weight and price are determined on the scale and taken straight into the booking – no retyping."
      },
      "BookIn": {
        "Title": "book-in",
        "Description": "Lipp POS automatically transfers PMS transfers to the book-in hotel software - for a smooth process between the cash register and reception."
      },
      "Apaleo": {
        "Title": "Apaleo",
        "Description": "Lipp POS automatically transfers PMS transfers to the Apaleo hotel software - for a smooth process between the cash register and reception."
      },
      "FoodNotify": {
        "Title": "FoodNotify",
        "Description": "Lipp POS automatically transfers articles and sales to the FoodNotify inventory management system - for an accurate cost of goods without double entry."
      },
      "EProtocol": {
        "Title": "E-Protokoll",
        "Description": "Integration with dispensing systems via the classic E-Protokoll (serial or TCP). Bookings flow into Lipp POS and credits are pushed back to the dispenser."
      },
      "Cascade3": {
        "Title": "Cascade 3 (Hart++ / Hart 96)",
        "Description": "Integration with dispensing systems via the Cascade3 protocol (Hart++ / Hart 96, serial or TCP). Bookings flow into Lipp POS and credits are pushed back to the dispenser."
      },
      "Smartschank": {
        "Title": "Smartschank",
        "Description": "Connects Dirmeier Smartschank dispensing systems. Booking a drink creates a credit that the guest redeems at the device using their tag (customer ID). Choose per system: credits in the manufacturer cloud (SelfserviceCash, shared across branches) or straight to a device on the LAN."
      },
        "Tbt": {
        "Title": "TBT",
        "Description": "Integration with TBT dispensing systems (serial or TCP, multi-drop). Bookings flow into Lipp POS and credits are pushed back to the dispenser."
      },
      "Incert": {
        "Title": "Incert",
        "Description": "Redeem Incert vouchers directly at the Lipp POS."
      },
      "Websline": {
        "Title": "Websline",
        "Description": "Redeem Websline vouchers directly at the Lipp POS."
      },
      "GruberVMPS": {
        "Title": "Gruber VMPS",
        "Description": "Connection to dispensing systems via the Gruber VMPS protocol (UDP). Dispensing operations run directly through the Lipp POS.",
        "SchankSettings": {
          "Title": "Dispenser settings"
        },
        "Tabs": {
          "Systems": "Dispensing systems",
          "Articles": "Dispenser articles"
        },
        "Deactivate": {
          "Button": "Deactivate integration",
          "Error": "Dispensing integration could not be deactivated"
        },
        "Systems": {
          "Title": "Dispensing Systems",
          "Empty": "No dispensing systems configured yet."
        },
        "System": {
          "Add": "Dispensing system",
          "Articles": "Articles",
          "Field": {
            "Name": "Name",
            "IPAddress": "IP address",
            "Port": "Port",
            "Protocol": "Protocol",
            "IsActive": "Active",
            "Assignment": "Assignment",
            "CommunicationServer": "Communication server"
          },
          "Saved": {
            "Title": "Dispensing system saved",
            "Error": "Could not save dispensing system"
          },
          "Delete": {
            "Confirm": "Really delete dispensing system \"{0}\"?",
            "Error": "Could not delete dispensing system"
          }
        },
        "Articles": {
          "Title": "Article mappings",
          "Empty": "No articles mapped yet.",
          "NoSystems": "Create a dispensing system first before mapping articles.",
          "SystemSelector": "Dispensing system:",
          "OnlyAssigned": "Show only assigned",
          "AllArticlesEmpty": "No articles available."
        },
        "Article": {
          "Add": "Add article",
          "Field": {
            "ArticleId": "Article ID",
            "ArticleNumber": "Dispenser article number",
            "Mode": "Mode",
            "Name": "Name",
            "Number": "Article no.",
            "CommodityGroup": "Commodity group",
            "DispenserArticleNumber": "Dispenser article no.",
            "DispenserArticleNumberPlaceholder": "Article no."
          },
          "Mode": {
            "Debit": "Debit",
            "Credit": "Credit",
            "Both": "Both"
          },
          "Saved": {
            "Error": "Could not save article mapping"
          },
          "Delete": {
            "Confirm": "Really delete this article mapping?",
            "Error": "Could not delete article mapping"
          }
        }
      },
      "RKSV": {
        "Title": "RKSV 2017"
      },
      "Additional": {
        "Title": "Lipp POS (additional)"
      },
      "IntegrationSlot": {
        "Title": "Integration Slot"
      },
      "ExtensionSlot": {
        "Title": "Extension Slot"
      },
      "CashJournal": {
        "Title": "Cash Journal",
        "Description": "Cash receipts are recorded automatically; you can add expenses, use handy templates, and export your data with just one click."
      },
      "VoucherManagement": {
        "Title": "Voucher Management",
        "Description": "Easily create, redeem, and manage vouchers directly in the POS system."
      },
      "TimeTracking": {
        "Title": "Time Tracking",
        "Description": "Employees clock work and break times directly at the POS system. Time tracking types are managed in the portal, and entries can be viewed and exported at any time."
      },
      "WarehouseManagement": {
        "Title": "Warehouse Management",
        "Description": "Manage stock levels, goods receipts, transfers, recipes, and suppliers - directly in the portal."
      },
      "DeliveryNotes": {
        "Title": "Delivery Note Management",
        "Description": "With Delivery Note Management you hand out goods against a delivery note and bill them later – optionally combining several delivery notes of the same customer into one invoice. Returns are recorded directly on the delivery note."
      },
      "NotifcationCenter": {
        "Title": "Message Center",
        "Description": "With the Message Center you send messages to all or selected employees – immediately, at a set time or recurring. The message appears to the user as a notice and is confirmed with OK."
      },
      "BonusSystem": {
        "Title": "Bonus system",
        "Description": "A customer account with balance and points for every customer – no card, just the customer number. Top up in advance or settle afterwards, and pay with it at the till and on the handheld."
      },
      "TableReservation": {
        "Title": "Table reservation",
        "Description": "Achieve optimal utilization of your tables through reservations. Including booking widget for your website."
      },
      "OpenItems": {
        "Title": "Open Items Management",
        "Description": "With Open Items Management you keep track of all invoices that haven't been settled yet – you instantly see which amounts are still open."
      },
      "DigitalReceipt": {
        "Title": "Digital Receipt",
        "Description": "Guests scan the invoice via QR code. Additional guest ratings for the stay. Saves costs on thermal paper & printers. All digital receipts remain accessible for 30 days after invoice creation."
      },
      "CustomerDisplay2L": {
        "Title": "Customer display, 2 lines",
        "Description": "Display of items and invoice amounts - for a simple, transparent customer experience."
      },
      "CashDrawer": {
        "Title": "Cash drawer",
        "Description": "The POS system automatically opens the cash drawer when certain payment methods are selected."
      },
      "WaiterKey": {
        "Title": "Addimat waiter lock",
        "Description": "Employees can quickly and securely authenticate themselves using a waiter key on the Addimat waiter lock."
      },
      "Keycard": {
        "Title": "Card reader",
        "Description": "Register cards at the reader and use them as customer, credit or staff cards — top up, pay with them and collect points."
      },
      "GPtom": {
        "Title": "Genius mobile pay",
        "Description": "Combined with Lipp POS, NFC card payments can be processed directly via the Android or iOS smartphone."
      },
      "POSit": {
        "Title": "POSit",
        "Description": "Combined with Lipp POS, NFC card payments can be processed directly via the Android or iOS smartphone."
      },
      "LippPay": {
        "Title": "Lipp Pay",
        "Description": "Combined with Lipp POS, NFC card payments can be processed directly via the Android or iOS smartphone."
      },
      "PayOne": {
        "Title": "PAYONE",
        "Description": "Combined with Lipp POS, NFC card payments can be processed with PAYONE Tap on Mobile directly via the Android smartphone."
      },
      "VRPayMe": {
        "Title": "VR PayMe",
        "Description": "Combined with Lipp POS, NFC card payments can be processed with VR PayMe directly via the Android smartphone."
      },
      "Nexi": {
        "Title": "Nexi",
        "Description": "Combined with Lipp POS, NFC card payments can be processed with Nexi SoftPOS directly via the Android smartphone."
      },
      "CustomerDisplay": {
        "Title": "Customer display",
        "Description": "Display of items, invoice amounts and advertising content - for a modern, transparent customer experience."
      },
      "ZVT": {
        "Title": "ZVT payment terminal",
        "Description": "Communication between Lipp POS and connected payment terminals for automated payment processing."
      },
      "SixTIM": {
        "Title": "SIX TIM",
        "Description": "Connect Worldline/SIX payment terminals (TIM protocol) directly to the POS – payment, refund, tip and automatic end-of-day."
      },
      "AsaSoap": {
        "Title": "ASA-SOAP",
        "Description": "Integration with the ASA Hotel Cloud-PMS (SOAP)."
      }
    },
    "Reporting": {
      "AidaTouch": {
        "Title": "Reporting",
        "Description": "Live statistics of the cash register software - available anytime & anywhere."
      }
    },
    "Messaging": {
      "SMS": {
        "Title": "SMS notifications",
        "Description": "Notifications for guests via SMS."
      }
    },
    "CloudBackupPOS": {
      "Title": "Cloud backup",
      "Description": "For maximum reliability, selected files of your POS software are encrypted and backed up to the decentralized cloud."
    },
    "CloudBackupPMS": {
      "Title": "Cloud backup",
      "Description": "For maximum reliability, selected files of your PMS software are encrypted and backed up to the decentralized cloud."
    },
    "DigitalReceipt": {
      "Title": "Digital receipt",
      "Description": "Invoice is scanned by the guest (QR code). Additional guest rating for the stay. Saves costs in the purchase of thermal paper & printer → no paper chaos. All digital receipts can be retrieved 30 days after invoicing."
    },
    "ERegistrationWPrecheckin": {
      "Title": "e-Registration WITH Pre-Checkin",
      "Description": "Request for registration data will be sent to the guest electronically before arrival. Last-minute guests can fill in the registration data directly at reception via tablet. The data is stored digitally via the PMS interface for the next 7 years.<br><i class=\"fas fa-triangle-exclamation\"></i><span><i>Tablet not included in the price!</i></span>"
    },
    "ERegistrationWOPrecheckin": {
      "Title": "e-Registration WITHOUT Pre-Checkin",
      "Description": "Guests can fill in the registration data directly at reception via tablet. The data is stored digitally via the PMS interface for the next 7 years.<br><i class=\"fas fa-triangle-exclamation\"></i><span><i>Tablet not included in the price!</i></span>"
    },
    "CustomModule": {
      "POS": {
        "Title": "POS"
      },
      "PMS": {
        "Title": "PMS"
      },
      "Misc": {
        "Title": "Misc"
      }
    },
    "Support": {
      "Report": {
        "Title": "Special report",
        "Description": "We will create a custom report for you, tailored to your preferences."
      },
      "Training": {
        "Title": "Remote training",
        "Description": "We try to answer all your questions & concerns and specifically address your training needs."
      },
      "ExtHardware": {
        "Title": "Setting up external hardware",
        "Description": "Even if the device is not from us, we try to integrate it into our system for you."
      },
      "SysCheck": {
        "Title": "System check",
        "Description": "Through a thorough examination, we try to eliminate any risks/threats to your system.",
        "Description1": "Through a thorough examination",
        "Description2": ", we try to eliminate any risks/threats to your system.",
        "Tooltip": {
          "Item1": "Check data backups and backup copies",
          "Item2": "Check data capture logs",
          "Item3": "Check Windows for errors",
          "Item4": "Check the hard drive for errors",
          "Item5": "Windows Updates",
          "Item6": "Delete temporary files",
          "Item7": "Defragment the hard drive",
          "Item8": "Update Teamviewer",
          "Item9": "Update cash register software (free)",
          "Item10": "Update Orderman software (free)"
        }
      },
      "TseStick": {
        "Title": "Technical safety device (TSE)",
        "Description": "Safety device for Germany. Storage capacity & validity of the certificate for 5 years.",
        "Description1": "Safety device for Germany",
        "Description2": "Storage capacity & validity of the certificate for 5 years"
      },
      "SetUpBottleDeposit": {
        "Title": "Set up bottle deposit",
        "Description": "We will add the deposit system to your desired items."
      },
      "RKSV": {
        "Title": "RKSV 2017",
        "Description": "Choose between Basic, Advanced or Premium for the Cash Register Security Ordinance 2017.",
        "Basic": {
          "Title": "RKSV Basic",
          "Description": "Up to 10,000 signatures / year"
        },
        "Advanced": {
          "Title": "RKSV Advanced",
          "Description": "Up to 30,000 signatures / year"
        },
        "Premium": {
          "Title": "RKSV Premium",
          "Description": "Unlimited signatures"
        }
      }
    },
    "Custom": {
      "Title": "Custom",
      "AIDATouch": {
        "Title": "Support AIDA-Touch"
      },
      "AIDAx": {
        "Title": "Support AIDA.x"
      },
      "Software": {
        "Title": "Software Rental"
      },
      "MaintenanceSoftware": {
        "Title": "Software Rental incl. Support"
      }
    },
    "Units": {
      "Hour": "Hour",
      "SMS": "SMS",
      "Report": "Report",
      "POS": "POS",
      "Device": "Device",
      "5Years": "5 Years",
      "Station": "Station"
    },
    "POS": {
      "Title": "POS"
    },
    "PMS": {
      "Title": "PMS"
    },
    "Misc": {
      "Title": "Misc"
    },
    "LippCare": {
      "Title": "Lipp Care",
      "Description": "Everything included, no unexpected additional costs - travel, labor, and repairs included."
    }
  },
  "QuickDateRanges": {
    "Today": "Today",
    "Yesterday": "Yesterday",
    "CurrentWeek": "Current week",
    "CurrentMonth": "Current month",
    "CurrentYear": "Current year",
    "LastWeek": "Last week",
    "LastMonth": "Last month",
    "LastYear": "Last year",
    "LastDays": "Last {0} days",
    "Total": "Total",
    "Custom": "Custom"
  },
  "Options": {
    "Save": "Save",
    "Discard": "Discard",
    "Send": "Send",
    "Create": "Create",
    "Edit": "Bearbeiten",
    "Change": "Change",
    "Deactivate": "Deactivate",
    "Activate": "Activate",
    "Synchronize": "Synchronize",
    "Next": "Next",
    "Back": "Back",
    "Delete": "Delete",
    "Remove": "Remove",
    "Reset": "Reset",
    "Start": "Start",
    "Select": "Select",
    "Add": "Add",
    "Update": "Update",
    "Yes": "Yes",
    "No": "No",
    "Replace": "Replace",
    "Confirm": "Confirm",
    "Cancel": "Cancel",
    "Close": "Close"
  },
  "Enterprises": {
    "Title": "Enterprises",
    "Partner": "Partner",
    "CustomerNumber": "Customer no.",
    "EnterpriseName": "Enterprise name",
    "Street": "Street",
    "ZipCode": "Zip code",
    "City": "City",
    "Country": "Country",
    "CreatedOn": "Created on",
    "ActiveInactive": "Active/Inactive",
    "Enterprise": "Enterprise",
    "ActivatedEnterprise": {
      "Success": {
        "Title": "Activated enterprise",
        "Description": "The enterprise <b>{0}</b> has been activated successfully."
      },
      "Error": "Could not activate enterprise"
    },
    "ErrorLoadingEnterprise": "Could not load enterprise",
    "CannotDeactivatePartnerEnterprise": "Partner enterprises cannot be deactivated!"
  },
  "TableReservation": {
    "Title": "Reservations",
    "Reservation": "Reservation",
    "List": {
      "ReservationNumber": "Res. No.",
      "FirstName": "First name",
      "LastName": "Last name",
      "Date": "Date",
      "From": "From",
      "To": "To",
      "Pax": "Pax",
      "PhoneNumber": "Phone",
      "Note": "Note",
      "GuestNote": "Guest note",
      "InternalNote": "Internal note",
      "Status": {
        "Waiting": "Waiting",
        "Confirmed": "Confirmed",
        "Rejected": "Rejected",
        "Canceled": "Canceled"
      },
      "PaymentStatus": {
        "Title": "Payment status",
        "Due": "Due",
        "Paid": "Paid",
        "PaymentFailed": "Failed",
        "PaymentDataDeposited": "Payment data deposited"
      },
      "Tables": "Tables"
    },
    "Overview": {
      "Department": "Department",
      "Table": "Table",
      "Seats": "Seats",
      "ErrorLoadingTables": "Could not load tables",
      "ErrorLoadingReservation": "Could not load reservation",
      "ErrorLoadingReservations": "Could not load reservations",
      "ErrorLoadingSettings": "Could not load settings",
      "ErrorLoadingCustomFields": "Could not load custom fields",
      "InternalNote": "Internal note",
      "GuestNote": "Guest note",
      "CreatedInfo": "Created by / on",
      "ModifiedInfo": "Changed by / on",
      "LockDragAxis": "Restrict moving to one direction",
      "CheckIn": {
        "Success": {
          "Title": "Check-in successful",
          "Description": "The reservation with the reservation number <b>{0}</b> has been checked in."
        },
        "Error": "Check-in failed"
      }
    },
    "ContextMenu": {
      "Edit": "Edit reservation",
      "ChangeColor": "Change reservation color",
      "CheckIn": "Check-in",
      "Cancel": "Cancel"
    },
    "DepartmentsAndTables": "Departments & Tables",
    "Reports": {
      "Title": "Reports",
      "Selection": {
        "Title": "Selection",
        "Type": "Type",
        "Types": {
          "ReservationList": "Reservation list",
          "PlaceCards": "Place cards"
        },
        "Period": "Period",
        "DateFrom": "Date from",
        "DateTo": "Date to",
        "Reports": "Reports",
        "Print": "Print"
      },
      "Criteria": {
        "Title": "Criteria",
        "Select": "Select criteria",
        "Save": "Save criteria",
        "Delete": "Delete criteria",
        "Criterion": {
          "Departments": {
            "Title": "Departments"
          },
          "Status": {
            "Title": "Status",
            "Waiting": "Waiting",
            "Accepted": "Accepted",
            "Rejected": "Rejected",
            "Cancelled": "Cancelled"
          }
        }
      },
      "Preview": {
        "Title": "Preview",
        "ReportDesigner": "Report Designer",
        "PreviewInfo": "You can generate a preview for your selection/criteria.",
        "Preview": "Preview"
      },
      "ErrorLoadingReports": "Could not load reports",
      "ErrorLoadingPreview": "Could not load preview",
      "ErrorPrinting": "Could not print report",
      "ErrorDownloading": "Could not download report",
      "ErrorLoadingReportDesigner": "Could not load report designer"
    },
    "Settings": {
      "Title": "Settings",
      "BasicSettings": {
        "Title": "Basic Settings",
        "MinimumNumberOfPersons": "Minimum number of persons",
        "MaximumNumberOfPersons": "Maximum number of persons",
        "LeadTime": "Lead time reservation (hours)",
        "DefaultReservationPeriod": "Default reservation period (minutes)",
        "ReservationHours": "Reservation hours",
        "CheckInColor": "Check-in color",
        "AutomaticRejectionWhenFullyBooked": "Automatic rejection when fully booked",
        "AutomaticConfirmationWhenFree": "Automatic confirmation when free",
        "SuggestAlternativeDatesAutomatically": "Suggest alternative dates automatically",
        "DaysIntoTheFuture": "Day(s) into the future",
        "SyncTablesAndDepartmentsFromCashSystem": "Synchronize departments/tables from POS system",
        "PaymentMethods": {
          "Title": "Payment method",
          "PaymentRequired": "Payment required",
          "DepositPaymentData": "Deposit payment data"
        },
        "UrlAfterFailedPayment": "URL after failed payment",
        "PaymentFailedUrl": "https://your-domain.com/payment-failed",
        "UrlAfterSuccessfulPayment": "URL after successful payment",
        "PaymentSuccessfulUrl": "https://your-domain.com/payment-successful",
        "RefundAsVoucher": "Refund as voucher",
        "VoucherPerPax": "Voucher per pax",
        "SendAutomatically": "Send auotmatically",
        "AvailablePaymentMethods": {
          "Title": "Available payment methods",
          "Card": "Credit card",
          "SepaDebit": "SEPA debit"
        },
        "SuccessChanging": {
          "Title": "Changed basic settings",
          "Description": "The basic settings have been changed successfully."
        },
        "ErrorChanging": "Could not change basic settings",
        "SuccessSynchronizing": {
          "Title": "Initiated synchronisation",
          "Description": "The synchronisation of the departments/tables from the POS has been successfully initiated."
        },
        "ErrorSynchronizing": "Synchronisation failed",
        "DataSyncedByPOS": "Data is synchronized by the POS system!"
      },
      "Departments": {
        "Title": "Departments",
        "Department": "Department",
        "Name": "Name",
        "TimePlan": "Time plan",
        "Available": "Available",
        "ActiveInactive": "Active/Inactive",
        "IsOneTimeSlotBooking": "One-time slot booking",
        "ErrorChanging": "Could not change department",
        "Activated": {
          "Success": {
            "Title": "Activated department",
            "Description": "The department <b>{0}</b> has been activated successfully."
          },
          "Error": "Could not activate department"
        }
      },
      "Tables": {
        "Title": "Tables",
        "Table": "Table",
        "Name": "Table number / Name",
        "Seats": "Seats",
        "Department": "Department",
        "Available": "Available",
        "ActiveInactive": "Active/Inactive",
        "ErrorChangingIsAvailable": "Could not change availability",
        "Activated": {
          "Success": {
            "Title": "Activated table",
            "Description": "The table <b>{0}</b> has been activated successfully."
          },
          "Error": "Could not activate table"
        }
      },
      "Snippet": {
        "Title": "Widget for your own website",
        "WidgetInfo": "To display the widget on your website, you have to embed the following code:",
        "Script": "Script",
        "ScriptCopied": "Script copied",
        "Widget": "Widget",
        "WidgetCopied": "Widget copied",
        "PredefinedValuesInfo": "Predefined values can be optionally set with the following function:",
        "FunctionCopied": "Function copied",
        "NameOfVariable": "VARIABLE",
        "Value": "VALUE",
        "NumberOfPersons": "Number of persons",
        "DateTime": "Date/Time",
        "Name": "Name",
        "Email": "Email",
        "PhoneNumber": "Phone number",
        "Message": "Message",
        "German": "German",
        "English": "English",
        "French": "French",
        "Headline": "Headline",
        "ButtonText": "Button text",
        "InfoText": "Info text",
        "ConfirmationText": "Confirmation text",
        "WidgetField": "Widget field",
        "Display": "Display",
        "Required": "Required",
        "Colors": "Widget colors",
        "WidgetBackgroundColor": "Widget - Background",
        "WidgetTextColor": "Widget - Text",
        "ButtonBackgroundColor": "Button - Background",
        "ButtonTextColor": "Button - Text",
        "ButtonBorderColor": "Button - Border",
        "ButtonHoverBackgroundColor": "Button (Highlight) - Background",
        "ButtonHoverTextColor": "Button (Highlight) - Text",
        "ButtonHoverBorderColor": "Button (Highlight) - Border",
        "InputBackgroundColor": "Input - Background",
        "InputTextColor": "Input - Text",
        "InputPlaceholderTextColor": "Input (Platzhalter) - Text",
        "ErrorTextColor": "Error - Text",
        "LoadingSpinnerColor": "Loading animation",
        "Preview": "Preview",
        "ErrorLoading": "Could not load widget",
        "SuccessChanging": {
          "Title": "Changed widget",
          "Description": "The widget has been changed successfully."
        },
        "ErrorChanging": "Could not change widget"
      },
      "CustomFields": {
        "Title": "Custom fields",
        "CustomField": "Custom field",
        "FieldType": "Field type",
        "FieldTypes": {
          "String": "Text",
          "Number": "Number",
          "Date": "Date/Time",
          "Selection": "Dropdown",
          "CheckBox": "Checkbox",
          "MultiSelect": "Multiselect"
        },
        "Name": "Name",
        "DefaultValue": "Default value",
        "RequiredInLipp": "Required in Portal",
        "DisplayInWidget": "Display in Widget",
        "RequiredInWidget": "Required in Widget",
        "ActiveInactive": "Active/Inactive",
        "ErrorChangingIsMandatory": "Could not change required field",
        "Email": "Email",
        "PhoneNumber": "Phone number",
        "Message": "Message",
        "EmailDefault": "Your Email Address",
        "PhoneNumberDefault": "Your Phone Number",
        "MessageDefault": "Do you have any additional remarks?",
        "Activated": {
          "Success": {
            "Title": "Activated custom field",
            "Description": "The custom field <b>{0}</b> has been activated successfully."
          },
          "Error": "Could not activate custom field"
        }
      },
      "CustomerInformation": {
        "Title": "Customer information",
        "Singular": "Customer information",
        "Type": "Type",
        "Types": {
          "Info": "Info",
          "Warning": "Warning"
        },
        "Text": "Text",
        "TimePlan": "Time plan"
      },
      "QuickLink": {
        "Title": "Quick links",
        "List": "Link reservation list",
        "Overview": "Link reservation overview",
        "ErrorLoading": "Could not load quick links",
        "ErrorCreating": "Could not refresh quick links"
      }
    },
    "ReservationReceived": {
      "Title": "Table reservation received",
      "Description": "Reservation of <b>{0} (#{1})</b> received for enterprise <b>{2}</b> (<b>{3}</b>)."
    }
  },
  "LippBon": {
    "Workstations": {
      "Title": "Workstations",
      "AmountSelected": "{0} selected",
      "WorkstationNumber": "WS-No.",
      "AppVersion": "App version",
      "LastSync": "Last sync",
      "OnOff": "On/Off"
    },
    "Settings": {
      "Title": "Settings",
      "SendToSelectedWorkStations": "Send to selected WS",
      "General": {
        "Title": "General",
        "ShowArticlesInOneColumn": "Show articles in one column",
        "ShowQRCodeOnBeltPrinterOrderReceipt": "Show QR code on belt printer order receipts",
        "HideArticlePackageDetails": "Hide article package details",
        "TipPopupForGuests": "Tip selection for guests (for NFC card payment & PMS transfer)"
      },
      "PrinterNumbers": {
        "Title": "Printer numbers to print on belt printer"
      },
      "CardPayment": {
        "Title": "Card payment",
        "GpTom": {
          "Title": "Genius mobile pay by Global Payments",
          "InUse": "{0} of {1} in use",
          "DisabledText": "Selected workstations exceed number of licenses",
          "ManageLicenses": "Manage licenses"
        },
        "PosIt": {
          "Title": "POSit by Hobex",
          "InUse": "{0} of {1} in use",
          "DisabledText": "Selected workstations exceed number of licenses",
          "ManageLicenses": "Manage licenses"
        }
      },
      "LoggingLevel": "Logging level",
      "SuccessChanging": {
        "Title": "Changed Lipp Bon settings",
        "Description": "The settings of the selected workstations have been changed successfully."
      },
      "ErrorChanging": "Lipp Bon settings could not be changed"
    },
    "Log": {
      "Title": "Log",
      "WorkstationNumber": "WS-No.",
      "Description": "Description",
      "Type": "Type",
      "Types": {
        "Mobile": "Mobile",
        "Web": "Web"
      },
      "User": "User",
      "DateTime": "Date/Time"
    }
  },
  "CloudBackup": {
    "Title": "Cloud backup",
    "Log": "Log",
    "LatestBackupAgo": "latest backup {0} ago",
    "LatestBackupOn": "latest backup on {0}",
    "OccupiedStorage": "occupied cloud storage: {0}",
    "ErrorDownloading": "Could not download files",
    "ErrorDownloadingLog": "Could not download log",
    "ErrorLoadingInfo": "Could not load information",
    "CannotDownloadLogTooltip": "The cloudbackup client is offline, therefore the log cannot be downloaded."
  },
  "Reports": {
    "TableReservation": {
      "List": {
        "Default": "Table reservation list A4",
        "WithNotes": "Table reservation list incl. notes A4"
      },
      "TableCards": {
        "Default": "Place card A4",
        "A4": {
          "TwoReservations": "Place card A4 (2 reservations)"
        },
        "A5": "Place card A5"
      }
    }
  },
  "StationSettings": {
    "EmailDispatch": {
      "Title": "Email dispatch",
      "SenderName": "Sender name",
      "SenderEmail": "Sender email",
      "ReplyEmail": "Reply email",
      "Host": "Outgoing mail server (SMTP)",
      "Port": "Port",
      "UseSSL": "Use SSL",
      "Username": "Username",
      "Password": "Password",
      "ErrorLoading": "Email dispatch could not be loaded",
      "SuccessChanging": {
        "Title": "Changed email dispatch",
        "Description": "The settings of email dispatch have been changed successfully."
      },
      "ErrorChanging": "Email dispatch could not be changed",
      "TestEmail": {
        "Title": "Test email",
        "Recipient": "Recipient",
        "Message": "Message",
        "Success": {
          "Title": "Sent test email",
          "Description": "The test email has been sent to <b>{0}</b>."
        },
        "Error": {
          "Title": "Test email could not be sent"
        }
      }
    },
    "TextTemplates": {
      "Title": "Text templates",
      "Type": "Type",
      "Types": {
        "None": " ",
        "Internal": "Internal",
        "Customer": "Customer",
        "Guest": "Guest"
      },
      "Category": "Category",
      "Categories": {
        "1": "Table reservation",
        "2": "Vouchers",
        "9999": "Misc"
      },
      "Name": "Name",
      "Description": "Description",
      "NotificationType": "Notification type",
      "NotificationTypes": {
        "None": " ",
        "Email": "Email",
        "SMS": "SMS"
      },
      "Notification": "Notification",
      "SmsNotificationCheckboxDisiabledTooltip": "For this notification, \"SMS notifications\" has to be subscribed first.",
      "ErrorChangingSendNotification": "Could not change notification"
    },
    "Schedules": {
      "Title": "Schedules",
      "OpeningHours": "Opening hours",
      "CreateOpeningHours": "Create opening hours",
      "EditOpeningHours": "Edit opening hours",
      "ClosingDays": "Closing days",
      "CreateClosingDays": "Create closing days",
      "EditClosingDays": "Edit closing days",
      "SpecialDays": "Special days",
      "CreateSpecialDays": "Create special days",
      "EditSpecialDays": "Edit special days",
      "Name": "Name",
      "Description": "Description",
      "Periods": "Periods",
      "From": "From",
      "To": "To",
      "Weekday": "Weekday",
      "Weekdays": {
        "General": "General",
        "Monday": "Monday",
        "Tuesday": "Tuesday",
        "Wednesday": "Wednesday",
        "Thursday": "Thursday",
        "Friday": "Friday",
        "Saturday": "Saturday",
        "Sunday": "Sunday"
      },
      "FullDay": "full-day",
      "ApplyToOpeningHours": "Apply to opening hours",
      "PeriodOrDayEmpty": "Please fill in all fields in the periods.",
      "NoLinkedScheduleSelected": "Please select a schedule",
      "Created": {
        "Success": {
          "Title": "Created schedule",
          "Description": "The schedule <b>{0}</b> has been created successfully."
        },
        "Error": "Could not create schedule"
      },
      "Changed": {
        "Success": {
          "Title": "Changed schedule",
          "Description": "The schedule <b>{0}</b> has been changed successfully."
        },
        "Error": "Could not change schedule"
      },
      "ClosingDaysOrSpecialDaysWarning": "There are closing days or special days in the selected period!",
      "ErrorLoadingOpeningHoursSchedules": "Could not lode schedules",
      "ApplyToSchedule": "Apply to schedule"
    },
    "DeactivateStation": "Deactivate station"
  },
  "PdfViewer": {
    "AutomaticZoom": "Automatic",
    "ActualSize": "Actual Size",
    "PageFit": "Page Fit",
    "PageWidth": "Page Width"
  },
  "EnterpriseSettings": {
    "Title": "Enterprise settings",
    "Stations": {
      "Title": "Stations",
      "Station": "Station",
      "OnOff": "On/Off",
      "Type": "Type",
      "Name": "Name",
      "StationCode": "Station code",
      "SystemPassword": "System password",
      "SoftwareVersion": "Software version",
      "ActiveInactive": "Active/Inactive",
      "CopiedStationCode": "Copied station code",
      "CopiedSystemPassword": "Copied system password",
      "Types": {
        "Hotel": "Hotel",
        "Restaurant": "Gastronomy",
        "Retail": "Retail"
      },
      "ErrorLoadingStation": "Could not load station <b>{0}</b>"
    },
    "EnterpriseData": {
      "Title": "Enterprise data",
      "EnterpriseName": "Enterprise name",
      "VatId": "VAT id",
      "Street": "Street",
      "Zip": "ZIP",
      "City": "City",
      "Country": "Country",
      "Currency": "Currency",
      "CustomerId": "Customer id",
      "StripeCustomerId": "Stripe customer id",
      "PhoneNumber": "Phone number",
      "Email": "Email",
      "Website": "Website",
      "Logo": "Logo",
      "ErrorLoading": "Enterprise data could not be loaded",
      "SuccessChanging": {
        "Title": "Changed enterprise data",
        "Description": "The enterprise data has been changed successfully."
      },
      "ErrorChanging": "Enterprise data could not be changed",
      "PaymentViaHogast": "Payment via Hogast",
      "HogastCompany": "Member of",
      "HogastCustomerId": "Hogast customer id",
      "DemoEnterprise": "Demo enterprise",
      "AccountSheet": {
        "Button": "Account statement",
        "Success": {
          "Title": "Account statement exported",
          "Description": "The account statement was downloaded as PDF."
        },
        "Error": "Failed to create account statement",
        "NoDataInPeriod": "No invoices found in the selected period."
      }
    },
    "BillingAddress": {
      "Title": "Different billing address",
      "Salutation": "Salutation",
      "CompanyName": "Company name",
      "VatId": "VAT id",
      "Street": "Street",
      "Zip": "ZIP",
      "City": "City",
      "Country": "Country",
      "TitleLabel": "Title",
      "FirstName": "First name",
      "LastName": "Last name",
      "Email": "Email billing",
      "ErrorLoading": "Different billing address could not be loaded",
      "SuccessChanging": {
        "Title": "Changed different billing address",
        "Description": "The different billing address has been changed successfully."
      },
      "ErrorChanging": "Different billing address could not be changed"
    },
    "Permissions": {
      "Title": "Permissions",
      "Categories": "Categories",
      "PermissionDetails": "Permission details",
      "Stations": "Stations",
      "CannotDoThisWithoutSavingTooltip": "Save changes to execute this action.",
      "UserGroups": {
        "Title": "User groups",
        "UserGroup": "User group",
        "Staff": "Staff",
        "Admins": "Admins"
      },
      "Users": {
        "Title": "Users",
        "User": "User"
      },
      "ClientsService": {
        "Title": "Core data",
        "IsStationAdmin": "Station admin",
        "ReadStation": "Read station"
      },
      "RoomPlanService": {
        "Title": "Hotel package",
        "ReadReservations": "Read reservations",
        "BlockRooms": "Block rooms",
        "ReadStationPmsStatistics": "Read statistics"
      },
      "TableReservationService": {
        "Title": "Table reservation",
        "ReadTableReservation": "Read reservations",
        "CreateTableReservation": "Create reservations",
        "EditTableReservationStatus": "Edit reservations",
        "ReadTableReservationSettings": "Read settings",
        "EditTableReservationSettings": "Edit settings",
        "ReportingOpenReport": "Read reports",
        "ReportingEditReport": "Edit reports"
      },
      "LippBon": {
        "Title": "Lipp Bon",
        "ReadLippBon": "Read settings"
      },
      "LippPOS": {
        "Title": "Lipp POS",
        "ListsAndInvoicesOnly": "Lists & invoices only"
      },
      "PosStatistics": {
        "Title": "Reporting",
        "ReadStationStatistics": "Read statistics"
      },
      "FileService": {
        "Title": "Digital receipt",
        "ReadDigitalReceiptsRatings": "Read feedback",
        "ReadDigitalReceiptsInvoices": "Read invoices"
      },
      "ErrorLoading": "Permissions could not be loaded",
      "SuccessChanging": {
        "Title": "Changed permissions",
        "Description": "The permissions have been changed successfully."
      },
      "ErrorChanging": "Permissions could not be changed"
    },
    "UserAdministration": {
      "Title": "User administration",
      "User": "User",
      "Email": "Email",
      "Confirmed": "Confirmed",
      "NotConfirmed": "Not confirmed",
      "SendConfirmationLink": {
        "Title": "Send confirmation link",
        "Success": {
          "Title": "Email sent",
          "Description": "Email for confirming user <b>{0}</b> has been sent."
        },
        "Error": "Email could not be sent"
      },
      "ResetPassword": {
        "Title": "Reset password",
        "Success": {
          "Title": "Email sent",
          "Description": "Email for resetting the password for the user <b>{0}</b> has been sent."
        },
        "Error": "Password could not be reset"
      },
      "ChangeIsEnterpriseAdmin": {
        "Error": "Enterprise admin could not be changed"
      },
      "Name": "Name",
      "EnterpriseAdmin": "Enterprise admin",
      "Language": "Language"
    },
    "DeactivateEnterprise": {
      "Button": "Deactivate enterprise",
      "Dialog": {
        "Text1": "Do you really want to deactivate the enterprise <b>{0}</b>?",
        "Text2": "The content of deactivated enterprises (e.g. stations, subscriptions, etc.) can no longer be accessed!",
        "Text3": "All subscriptions of all stations of the enterprise will be cancelled. Subscriptions with an active commitment end when the commitment expires and are billed until then.",
        "Success": {
          "Title": "Deactivated enterprise",
          "Description": "The enterprise <b>{0}</b> has been deactivated successfully."
        },
        "Error": {
          "Title": "Could not deactivate enterprise"
        }
      }
    },
    "ActivatedStation": {
      "Success": {
        "Title": "Activated station",
        "Description": "The station <b>{0}</b> has been activated successfully."
      },
      "Error": "Could not activate station"
    },
    "DeactivateStationDialog": {
      "Title": "Deactivate station",
      "Text1": "Do you really want to deactivate the station <b>{0}</b>?",
      "Text2": "The content of deactivated stations (e.g. subscriptions, schedules, etc.) can no longer be accessed!",
      "Text3": "All subscriptions of the station will be cancelled. Subscriptions with an active commitment end when the commitment expires and are billed until then.",
      "Success": {
        "Title": "Deactivated station",
        "Description": "The station <b>{0}</b> has been deactivated successfully."
      },
      "Error": {
        "Title": "Could not deactivate station"
      }
    },
    "UserDialog": {
      "AddUser": "Add user",
      "EditUser": "Edit user",
      "Email": "Email",
      "Language": "Language",
      "Password": "Password",
      "RepeatPassword": "Repeat password",
      "FirstName": "First name",
      "LastName": "Last name",
      "Station": "Station",
      "UserGroup": "User group",
      "EnterpriseAdmin": "Enterprise admin",
      "ErrorLoadingUser": "User could not be loaded",
      "ErrorLoadingUserGroups": "User groups could not be loaded",
      "Create": {
        "Success": {
          "Title": "Created user",
          "Description": "The user <b>{0}</b> has been created successfully."
        },
        "Error": "Could not create user"
      },
      "Assign": {
        "Info": "User already exists and is therefore being assigned.",
        "ErrorInfo": "User already exists.",
        "Success": {
          "Title": "Assigned user",
          "Description": "The user <b>{0}</b> has been assigned successfully."
        },
        "Error": "Could not assign user"
      },
      "Change": {
        "Success": {
          "Title": "Changed user",
          "Description": "The user <b>{0}</b> has been changed successfully."
        },
        "Error": "Could not change user"
      }
    },
    "UserGroupDialog": {
      "Title": {
        "Create": "Create user group",
        "Edit": "Edit user group"
      },
      "Name": "Name",
      "Create": {
        "Success": {
          "Title": "Created user group",
          "Description": "The user group <b>{0}</b> has been created successfully."
        },
        "Error": "Could not create user group"
      },
      "Change": {
        "Success": {
          "Title": "Changed user group",
          "Description": "The user group <b>{0}</b> has been changed successfully."
        },
        "Error": "Could not change user group"
      }
    },
    "DeleteUserGroupDialog": {
      "Title": "Delete user group",
      "Description": "Do you really want to delete the user group <b>{0}</b>?",
      "Success": {
        "Title": "Deleted user group",
        "Description": "The user group <b>{0}</b> has been deleted successfully."
      },
      "Error": {
        "Title": "Could not delete user group"
      }
    },
    "RemoveUserDialog": {
      "Title": "Remove user",
      "Description": "Do you really want to remove the user <b>{0}</b> from the enterprise <b>{1}</b>?",
      "Success": {
        "Title": "Removed user",
        "Description": "The user <b>{0}</b> has been successfully removed from the enterprise <b>{1}</b>."
      },
      "Error": "Could not remove user"
    },
    "StationDialog": {
      "Title": {
        "Create": "Create station",
        "Edit": "Edit station"
      },
      "Name": "Name",
      "Type": "Type",
      "Types": {
        "Hotel": "Hotel",
        "Restaurant": "Restaurant",
        "Retail": "Retail"
      },
      "SuccessCreating": {
        "Title": "Created station",
        "Description": "The station <b>{0}</b> has been created successfully."
      },
      "ErrorCreating": "Could not create station",
      "SuccessChanging": {
        "Title": "Changed station",
        "Description": "The station <b>{0}</b> has been changed successfully."
      },
      "ErrorChanging": "Could not change station"
    },
    "AdminUser": {
      "Title": "Admin user",
      "Create": {
        "Title": "Create admin user",
        "Email": "Email",
        "Password": "Password",
        "RepeatPassword": "Repeat password",
        "FirstName": "First name",
        "LastName": "Last name",
        "Language": "Language",
        "UserMustBeAssigned": "User already exists and therefore must be assigned."
      },
      "Assign": {
        "Title": "Assign admin user",
        "SearchUser": "Search name/email..."
      },
      "EmptyMessage": "An admin user must be assigned or created."
    }
  },
  "VatId": {
    "Error": {
      "Title": "VAT id could not be validated"
    }
  },
  "CreateEnterpriseDialog": {
    "Title": "Create enterprise",
    "Success": {
      "Title": "Created enterprise",
      "Description": "The enterprise <b>{0}</b> has been created successfully."
    },
    "Error": "Could not create enterprise",
    "ErrorLoadingAssignableUsers": "Assignable users could not be loaded"
  },
  "Empty": {
    "AppAndWebSolutions": "App & Web Solutions",
    "ByLinecker": "by Linecker"
  },
  "UniqueUserEmailInput": {
    "ErrorLoading": "Email could not be checked"
  },
  "Languages": {
    "German": "German",
    "English": "English",
    "Short": {
      "de": "German",
      "en": "English"
    }
  },
  "TextTemplateDialog": {
    "ErrorLoadingTextTemplates": "Could not load text template",
    "ErrorLoadingPlaceholders": "Could not load placeholders",
    "ErrorChangingTextTemplates": "Could not change text template",
    "SuccessChangingTextTemplates": {
      "Title": "Changed text template",
      "Description": "The text template <b>{0}</b> has been changed successfully."
    }
  },
  "ResetTextTemplateDialog": {
    "Title": "Reset text template",
    "Description": "Do you really want to reset the text template <b>{0}</b> to its default value?",
    "Success": {
      "Title": "Reset text template",
      "Description": "The text template <b>{0}</b> has been reset successfully."
    },
    "Error": "Could not reset text template"
  },
  "DeleteScheduleDialog": {
    "Title": "Delete schedule",
    "Description": "Do you really want to delete the schedule <b>{0}</b>?",
    "Success": {
      "Title": "Deleted schedule",
      "Description": "The schedule <b>{0}</b> has been deleted successfully."
    },
    "Error": "Could not delete schedule"
  },
  "DepartmentDialog": {
    "Title": {
      "Create": "Create department",
      "Edit": "Edit department"
    },
    "Name": "Name",
    "Schedule": "Schedule",
    "Available": "Available",
    "OneTimeSlotBooking": "One-time slot booking",
    "Create": {
      "Success": {
        "Title": "Created department",
        "Description": "The department <b>{0}</b> has been created successfully."
      },
      "Error": "Could not create department"
    },
    "Edit": {
      "Success": {
        "Title": "Changed department",
        "Description": "The department <b>{0}</b> has been changed successfully."
      },
      "Error": "Could not change department"
    }
  },
  "DeactivateDepartmentDialog": {
    "Title": "Deactivate department",
    "Description": "Do you really want to deactivate the department <b>{0}</b>?",
    "Success": {
      "Title": "Deactivated department",
      "Description": "The department <b>{0}</b> has been deactivated successfully."
    },
    "Error": "Could not deactivate department"
  },
  "TableDialog": {
    "Title": {
      "Create": "Create table",
      "Edit": "Edit table"
    },
    "Name": "Table number / Name",
    "Seats": "Seats",
    "Department": "Department",
    "AdditionalSeats": "Additional seats (overcrowding)",
    "Available": "Available",
    "Create": {
      "Success": {
        "Title": "Created table",
        "Description": "The table <b>{0}</b> has been created successfully."
      },
      "Error": "Could not table department"
    },
    "Edit": {
      "Success": {
        "Title": "Changed table",
        "Description": "The table <b>{0}</b> has been changed successfully."
      },
      "Error": "Could not change table"
    }
  },
  "DeactivateTableDialog": {
    "Title": "Deactivate table",
    "Description": "Do you really want to deactivate the table <b>{0}</b>?",
    "Success": {
      "Title": "Deactivated table",
      "Description": "The table <b>{0}</b> has been deactivated successfully."
    },
    "Error": "Could not deactivate table"
  },
  "SsoAuthorize": {
    "ErrorTitle": "Sign-in not possible"
  },
  "OAuthConsent": {
    "Title": "{0} wants to access your Lipp Portal",
    "RedirectHost": "Access goes to {0}",
    "LoopbackWarning": "The application runs on this device (localhost). Only allow access if you have just started the connection yourself.",
    "Account": "Signed in as",
    "Permissions": "The application may",
    "Scopes": {
      "Read": "read data you see in the Lipp Portal: revenue, invoices, articles, cash book, register status, table reservations, subscriptions and the invoices from Linecker",
      "NoWrite": "not change, book or delete anything"
    },
    "LineckerAccount": "With your Linecker account, access is read-only. Only use it with your company account of Claude or ChatGPT, not with a private account.",
    "RevokeInfo": "You can disconnect at any time in your profile settings under “Connected applications”.",
    "Allow": "Allow access",
    "Deny": "Deny",
    "ErrorTitle": "Connection not possible",
    "Framed": "This page can only be opened directly in the browser, not embedded in another page."
  },
  "Statistics": {
    "POS": {
      "ErrorLoadingOnlineStatus": "Could not load online status",
      "Overview": {
        "Title": "Overview",
        "Billed": "Billed",
        "Open": "Open",
        "Total": "Total",
        "ErrorLoading": "Could not load overview"
      },
      "MonthlyOverview": {
        "Title": "Monthly overview",
        "ErrorLoading": "Could not load monthly overview"
      },
      "DetailedStatistics": {
        "Title": "Detailed statistics",
        "ErrorLoading": "Could not load detailed statistics",
        "CommodityGroups": {
          "Title": "Commodity groups",
          "Billed": "Billed",
          "Open": "Open",
          "Total": "Total",
          "Sum": "Sum"
        },
        "Users": {
          "Title": "Users"
        },
        "PaymentMethods": {
          "Title": "Payment methods",
          "PerPaymentMethod": "per PM",
          "PerInvoice": "per invoice",
          "Total": "Total"
        }
      },
      "Reports": {
        "Title": "Reports",
        "EmptyMessage": "Np reports",
        "OfflineMessage": "Reports can only be loaded when the POS is online.",
        "ErrorLoading": "Could not load reports",
        "ErrorLoadingReport": "Could not load report"
      }
    },
    "PMS": {
      "ErrorLoadingOnlineStatus": "Could not load online status",
      "Overview": {
        "Title": "Overview",
        "OccupancyRate": "Occupancy rate",
        "OvernightStays": "Overnight stays",
        "Billed": "Billed",
        "Open": "Open",
        "Total": "Total",
        "ErrorLoading": "Could not load overview"
      },
      "MonthlyOverview": {
        "Title": "Monthly overview",
        "ErrorLoading": "Could not load monthly overview"
      },
      "DetailedStatistics": {
        "Title": "Detailed statistics",
        "ErrorLoading": "Could not load detailed statistics",
        "Guests": {
          "Title": "Guests",
          "Arrival": "Arrival",
          "Inhouse": "Inhouse",
          "Departure": "Departure",
          "PaxRooms": "PAX / Rooms",
          "PerGuest": "per guest",
          "Total": "Total",
          "Guests": "Guests",
          "Groups": "Groups",
          "RoomPax": "Room (PAX)",
          "GuestName": "Guest name",
          "Group": "Group",
          "Pax": "PAX",
          "Rooms": "Rooms"
        },
        "CommodityGroups": {
          "Title": "Commodity groups",
          "InvoiceJournal": "Invoice journal",
          "SalesReport": "Sales report",
          "Invoices": "Invoices",
          "PerInvoice": "per invoice",
          "Total": "Total",
          "PerDay": "per day"
        },
        "Channels": {
          "Title": "Channels",
          "NumberOfBookings": "Number of bookings",
          "PerChannel": "per channel",
          "Total": "Total"
        },
        "PaymentMethods": {
          "Title": "Payment methods",
          "PerPaymentMethod": "per PM",
          "PerInvoice": "per invoice",
          "Total": "Total"
        }
      }
    }
  },
  "Stations": {
    "Modules": {
      "Title": "Module overview",
      "Module": "Module",
      "Activated": "Activated",
      "NotActivated": "Not activated",
      "Modules": "Modules",
      "Trial": "Trial",
      "StartTrial": "Start trial",
      "Subscribe": "Subscribe",
      "Order": "Order",
      "ChangeLicenceQuantity": "Change licence quantity",
      "ChangeLicenceQuantityDisabledTooltip": "To change the licence quantity, the module must fist be canceled and licenced again",
      "EditModule": "Edit module",
      "Settings": "Settings",
      "Licence": "Licence",
      "Licences": "Licences",
      "Day": "Day",
      "Week": "Week",
      "Month": "Month",
      "Year": "Year",
      "TrialUntil": "Trial until {0}",
      "AvailableUntil": "{0}x {1} available until {2}",
      "CancelSubscription": "Cancel module(s)",
      "Cancel": "Cancel",
      "Warning": "Warning!",
      "WarningText": "Contents of cancelled modules can no longer be accessed!",
      "CanceledOn": "on {0}",
      "DeactivationOn": "Deactivation on {0}",
      "ActivationOn": "Activation on {0}",
      "CertificateExpiresOn": "Certificate expires on {0}",
      "PaymentPending": "Payment pending",
      "WaitingForPaymentReceipt": "Waiting for payment receipt",
      "NoModulesActivated": "No modules have been activated yet.",
      "AllModulesActivated": "All modules have already been activated.",
      "AddPaymentMethodTooltip": "Please add a payment method!",
      "SwitchToManualPayment": "Switch to manual payment",
      "StartPayment": "Start payment",
      "SwitchedToManualPayment": {
        "Success": {
          "Title": "Switched payment",
          "Description": "The payment has been sucessfully switched to manual payment."
        },
        "Error": "Could not switch payment"
      },
      "StartTrialDialog": {
        "Title": "Test {0}",
        "Description1": "Do you want to activate <b>{0}</b> for free until <b>{1}</b>?",
        "Description2": "After the trial period expires, the subscription will be started and the data you have already entered will be kept."
      },
      "SubscriptionDialog": {
        "PaymentIntervals": {
          "Title": "Choose payment interval",
          "Monthly": "monthly",
          "OneYearInAdvance": "yearly",
          "YearsCommitment": "yearly ({0}-year commitment)",
          "Seasonal": "seasonal",
          "MonthPerDevice": "month per device",
          "YearPerDevice": "year per device",
          "YearsPerDevice": "year per device",
          "OneTime": "one time"
        },
        "MonthSingular": "month",
        "MonthPlural": "months",
        "Save": "Save {0} yearly!",
        "ToCheckout": "To checkout",
        "CheckoutProcess": "Checkout process",
        "SelectAmount": "Select amount",
        "DiscountFrom": "from {0}",
        "ReadPrivacyPolicy": "I have read and agree to the <a href='https://www.linecker.at/datenschutzerklaerung/' target='_blank'>privacy policy</a>.",
        "ReadTermsAndConditions": "I agree with the <a href='https://www.linecker.at/agb/' target='_blank'>terms and conditions</a>.",
        "PaymentLink": "Payment link",
        "PaymentStart": "Payment start"
      },
      "LippBonDisabledToolTip": "For the administration of Lipp Bon licenses please contact our sales department +43 7755 20 995-70 / verkauf@linecker.at",
      "CreateModuleDialog": {
        "Title": "Create module",
        "ModuleName": "Module name",
        "ModuleDescription": "Module description",
        "InternalNotes": "Internal notes",
        "MiscellaneousModule": "Category \"miscellaneous module\"",
        "PaymentInterval": {
          "Title": "Payment interval",
          "Monthly": "Monthly",
          "Yearly": "Yearly"
        },
        "Price": "Price (net)",
        "PaymentStart": "Payment start",
        "Costs": "Costs",
        "CostsPerMonth": "Costs / month",
        "CostsPerYear": "Costs / year",
        "Profit": "Profit"
      },
      "EditModuleDialog": {
        "Title": "Edit module"
      },
      "Log": {
        "Title": "Log",
        "ModuleName": "Module name",
        "Description": "Description",
        "InternalNotes": "Internal notes",
        "User": "User",
        "DateTime": "Date/Time",
        "ProtocolTypes": {
          "10000": "Misc.",
          "10010": "Invoice has been created.",
          "10019": "Invoice has been sent.",
          "10025": "Trial has been activated.",
          "10026": "Trial ends soon.",
          "10029": "Trial has ended.",
          "10040": "Payment was successful.",
          "10050": "First payment failed.",
          "10051": "Another payment failed.",
          "10059": "Payment failed finally.",
          "10060": "Module has been canceled.",
          "10070": "Module has been subscribed.",
          "10071": "Licence quantity has been changed from {0} to {1}.",
          "10072": "Module has not been paid.",
          "10073": "Module has been deactivated."
        }
      },
      "From": "from",
      "PaymentMethod": "Payment by {0}",
      "PaymentMethods": {
        "0": "Unknown",
        "1": "Credit card",
        "2": "S€PA",
        "3": "Hogast",
        "9999": "manual debit"
      },
      "AlreadyActive": "Already active",
      "Activate": "Activate",
      "Deactivate": "Deactivate",
      "ErrorTogglingIntegration": "Could not change integration",
      "ErrorTogglingExtension": "Could not change extension",
      "CardPaymentIntegrationAlreadyActive": "There is already an active integration with NFC card payment.",
      "AllLicencesInUse": "All licences already in use."
    }
  },
  "CopyToClipboard": {
    "LinkCopied": "Link copied"
  },
  "PaymentLinkDialog": {
    "Title": "Payment link"
  },
  "CustomModuleDialog": {
    "Create": "Create subscription",
    "Edit": "Edit subscription",
    "Category": "Category",
    "ModuleDescription": "Description",
    "InternalNotes": "Internal notes",
    "MiscellaneousModule": "Category \"miscellaneous\"",
    "PaymentInterval": {
      "Title": "Payment interval",
      "Monthly": "Monthly",
      "Yearly": "Yearly",
      "YearsCommitment": "Yearly ({0}-year commitment)"
    },
    "Price": "Price (net)",
    "PaymentStart": "Payment start",
    "Costs": "Costs",
    "CostsPerMonth": "Costs / month",
    "CostsPerYear": "Costs / year",
    "Profit": "Profit",
    "ErrorLoadingModule": "Could not load subscription",
    "SuccessCreating": {
      "Title": "Created subscription",
      "Description": "The subscription <b>{0}</b> has been created successfully."
    },
    "ErrorCreating": "Could not create subscription",
    "SuccessChanging": {
      "Title": "Changed subscription",
      "Description": "The subscription <b>{0}</b> has been changed successfully."
    },
    "ErrorChanging": "Could not change module"
  },
  "ModuleTrialDialog": {
    "Title": "Test {0}",
    "Description1": "Do you want to activate <b>{0}</b> for free until <b>{1}</b>?",
    "Description2": "After the trial period expires, the subscription will be started and the data you have already entered will be kept.",
    "Success": {
      "Title": "Started trial",
      "Description": "The trial for <b>{0}</b> has started successfully."
    },
    "Error": "Could not start trial"
  },
  "ModuleSubscriptionDialog": {
    "Title": {
      "Subscribe": "Subscribe {0}",
      "Order": "Order {0}",
      "ChangeLicenceQuantity": "{0} - Change licence quantity"
    },
    "PaymentIntervals": {
      "Title": "Choose payment interval",
      "Monthly": "monthly",
      "OneYearInAdvance": "yearly",
      "YearsCommitment": "yearly ({0}-year commitment)",
      "Seasonal": "seasonal",
      "MonthPerDevice": "month per device",
      "YearPerDevice": "year per device",
      "YearsPerDevice": "year per device",
      "OneTime": "one time"
    },
    "MonthSingular": "month",
    "MonthPlural": "months",
    "Save": "Save {0} yearly!",
    "ToCheckout": "To checkout",
    "CheckoutProcess": "Checkout process",
    "SelectAmount": "Select amount",
    "DiscountFrom": "from {0}",
    "PaymentLink": "Payment link",
    "ReadPrivacyPolicy": "I have read and agree to the <a href='https://www.linecker.at/datenschutzerklaerung/' target='_blank'>privacy policy</a>.",
    "ReadTermsAndConditions": "I agree with the <a href='https://www.linecker.at/agb/' target='_blank'>terms and conditions</a>.",
    "SuccessSubscribing": {
      "Title": "Subscribed <b>{0}</b>",
      "Description": "<b>{0}</b> has been subscribed successfully."
    },
    "ErrorSubscribing": "Could not subscribe <b>{0}</b>",
    "SuccessChangingLicenceQuantity": {
      "Title": "Changed licence quantity",
      "Description": "The licence quantity of <b>{0}</b> has been changed successfully."
    },
    "ErrorChangingLicenceQuantity": "Could not change licence quantity",
    "SendMail": "Send confirmation mail",
    "SentMail": {
      "Title": "Sent confirmation mail",
      "Description": "The Email with the confirmation link has been sent."
    }
  },
  "RoomPlan": {
    "Title": "Room plan",
    "BlockRoom": "Block room",
    "Room": "Room",
    "Category": "Category",
    "ErrorLoadingReservations": "Could not load reservations",
    "ErrorLoadingRooms": "Could not load rooms",
    "ErrorLoadingSettings": "Could not load settings",
    "ReservationLocked": "Reservation locked",
    "DepositState": {
      "Done": "Deposit received",
      "Outstanding": "Deposit outstanding",
      "Overdue": "Deposit overdue"
    },
    "Source": "Source: {0}",
    "Accessible": "Accessible"
  },
  "RejectReservationDialog": {
    "Title": "Reject reservation",
    "Description": "Do you want to reject the reservation of <b>{0} {1}</b> with the reservation number <b>{2}</b>?",
    "Reject": "Reject",
    "Success": {
      "Title": "Rejected reservation",
      "Description": "The reservation with the reservation number <b>{0}</b> has been rejected successfully."
    },
    "Error": "Could not reject reservation"
  },
  "CancelReservationDialog": {
    "Title": "Cancel reservation",
    "Description": "Do you want to cancel the reservation of <b>{0} {1}</b> with the reservation number <b>{2}</b>?",
    "Cancel": "Cancel",
    "Success": {
      "Title": "Canceled reservation",
      "Description": "The reservation with the reservation number <b>{0}</b> has been canceled successfully."
    },
    "Error": "Could not cancel reservation"
  },
  "ReservationColorDialog": {
    "Title": "Change reservation color",
    "Color": "Color",
    "Success": {
      "Title": "Reservation color changed",
      "Description": "The color of the reservation with the reservation number <b>{0}</b> has been changed successfully."
    },
    "Error": "Could not change reservation color"
  },
  "CloneReportDialog": {
    "Title": "Clone report",
    "Name": "Name",
    "Clone": "Clone",
    "Copy": "Copy",
    "Success": {
      "Title": "Cloned report",
      "Description": "The report <b>${0}</b> has been cloned successfully."
    },
    "Error": "Could not clone report"
  },
  "RenameReportDialog": {
    "Title": "Rename report",
    "Name": "Name",
    "Success": {
      "Title": "Renamed report",
      "Description": "The report <b>{0}</b> has been renamed successfully."
    },
    "Error": "Could not rename report"
  },
  "ResetReportDialog": {
    "Title": "Reset report",
    "Description": "Do you really want to reset the report <b>{0}</b>?",
    "Success": {
      "Title": "Reset report",
      "Description": "The report <b>{0}</b> has been reset successfully."
    },
    "Error": "Could not reset report"
  },
  "ReportDataSourcesDialog": {
    "Title": "Data sources",
    "ErrorLoading": "Could not load data sources",
    "NoData": "No data found."
  },
  "ReportCriteriaDialog": {
    "Title": "Select criteria",
    "Presets": "Presets"
  },
  "ReportPresetDialog": {
    "Title": "Save preset",
    "Name": "Name",
    "Success": {
      "Title": "Saved preset",
      "Description": "The criteria have been successfully saved as the preset <b>{0}</b>."
    },
    "Error": "Could not save preset"
  },
  "DeletePresetDialog": {
    "Title": "Delete preset",
    "Description": "Do you really want to delete the preset <b>{0}</b>?",
    "Success": {
      "Title": "Deleted preset",
      "Description": "The preset <b>{0}</b> has been deleted successfully."
    },
    "Error": "Could not delete preset"
  },
  "CustomerInformationDialog": {
    "Title": {
      "Create": "Create customer information",
      "Edit": "Edit customer information"
    },
    "Type": "Type",
    "Types": {
      "Info": "Info",
      "Warning": "Warning"
    },
    "Schedule": "Schedule",
    "Text": "Text",
    "Create": {
      "Success": {
        "Title": "Created customer information",
        "Description": "The customer information has been created successfully."
      },
      "Error": "Could not create customer information"
    },
    "Edit": {
      "Success": {
        "Title": "Changed customer information",
        "Description": "The customer information has been changed successfully."
      },
      "Error": "Could not change customer information"
    }
  },
  "DeleteCustomerInformationDialog": {
    "Title": "Delete customer information",
    "Description": "Do you really want to delete the customer information?",
    "Success": {
      "Title": "Deleted customer information",
      "Description": "The customer information has been deleted successfully."
    },
    "Error": "Could not delete customer information"
  },
  "CustomFieldDialog": {
    "Title": {
      "Create": "Create custom field",
      "Edit": "Edit custom field"
    },
    "Type": "Type",
    "Types": {
      "String": "Text",
      "Number": "Number",
      "DateTime": "Date/Time",
      "Checkbox": "Checkbox",
      "Dropdown": "Dropdown",
      "MultiSelect": "Multiselect"
    },
    "Name": "Name",
    "Description": "Description",
    "IsMandatoryInLipp": "Required in Portal",
    "DisplayInWidget": "Display in Widget",
    "IsMandatoryInWidget": "Required in Widget",
    "DefaultValue": "Default value",
    "Items": "Items",
    "Create": {
      "Success": {
        "Title": "Created custom field",
        "Description": "The custom field <b>{0}</b> has been created successfully."
      },
      "Error": "Could not create custom field"
    },
    "Edit": {
      "Success": {
        "Title": "Changed custom field",
        "Description": "The custom field <b>{0}</b> has been changed successfully."
      },
      "Error": "Could not change custom field"
    }
  },
  "DeactivateCustomFieldDialog": {
    "Title": "Deactivate custom field",
    "Description": "Do you really want to deactivate the custom field <b>{0}</b>?",
    "Success": {
      "Title": "Deactivated custom field",
      "Description": "The custom field <b>{0}</b> has been deactivated successfully."
    },
    "Error": "Could not deactivate custom field"
  },
  "TableReservationDialog": {
    "Title": {
      "Create": "Create reservation",
      "Edit": "Edit reservation"
    },
    "Pax": "PAX",
    "From": "From",
    "To": "To",
    "FirstName": "First name",
    "LastName": "Last name",
    "Email": "Email",
    "PhoneNumber": "Phone number",
    "InternalNote": "Internal note",
    "GuestNote": "Guest note",
    "ReservationColor": "Reservation color",
    "SelectedSeatsForPersons": "{0} seats for {1} persons selected",
    "AvailableTables": "Available",
    "SelectedTables": "Selected",
    "Seats": "{0} seats",
    "SearchTablesAndDepartments": "Search tables/departments...",
    "Available": "available",
    "NotAvailable": "not available",
    "24hReminder": "Reminder (24h before)",
    "Reject": "Reject",
    "Cancel": "Cancel",
    "Create": {
      "Success": {
        "Title": "Created reservation",
        "Description": "The reservation for <b>{0} (#{1})</b> has been created successfully."
      },
      "Error": "Could not create reservation"
    },
    "Edit": {
      "Success": {
        "Title": "Changed reservation",
        "Description": "The reservation of <b>{0} (#{1})</b> has been changed successfully."
      },
      "Error": "Could not create reservation"
    },
    "ErrorLoadingTables": "Could not load tables"
  },
  "SearchReservationDialog": {
    "Title": "Search reservation",
    "Name": "Name",
    "Arrival": "Arrival",
    "Departure": "Departure",
    "ReservationNumber": "Reservation number",
    "BookingNumber": "Booking number",
    "Search": "Search",
    "ErrorSearching": "Could not load search results",
    "SearchResults": "Search results",
    "ReservationNo": "Res. No.",
    "BookingNo": "Book. No.",
    "BackToSearch": "Back to search"
  },
  "BlockRoomDialog": {
    "Title": "Block rooms",
    "Arrival": "Arrival",
    "Departure": "Departure",
    "FirstName": "First name",
    "LastName": "Last name",
    "Email": "Email",
    "PhoneNumber": "Phone number",
    "Notes": "Notes",
    "Block": "Block",
    "ErrorLoadingAvailableRoomCategories": "Could not load rooms",
    "NoCategory": "No category",
    "Success": {
      "Title": "Blocked rooms",
      "Description": "The selected rooms have been blocked successfully."
    },
    "ErrorBlocking": "Could not block rooms"
  },
  "ReservationInfoDialog": {
    "ErrorLoading": "Could not load reservation info"
  },
  "DigitalReceipt": {
    "Invoices": {
      "Title": "Receipts",
      "InvoiceNumber": "Number",
      "DateTime": "Date/Time",
      "Gross": "Gross",
      "User": "User",
      "ScannedOn": "Scanned on {0}",
      "Room": "Room",
      "Signed": "Signed by the guest"
    },
    "TotalFeedback": {
      "Title": "Total feedback",
      "Rating": "{0} of {1}",
      "NoEntries": "No entries",
      "ErrorLoading": "Could not load total feedback"
    },
    "GuestFeedback": {
      "Title": "Feedback per user",
      "Name": "Name",
      "Count": "Feedback count",
      "Average": "Average"
    }
  },
  "OpenApi": {
    "Title": "Open API",
    "ApiKey": "API key",
    "Station": "Location",
    "Name": "Name",
    "NoName": "No name",
    "Key": "Key",
    "CreatedOn": "Created on",
    "CreatedBy": "Created by",
    "LastUsedOn": "Last used",
    "Never": "Never",
    "TotalCalls": "Total calls",
    "CallsLast30Days": "Calls 30 days",
    "ErrorsLast30Days": "Errors 30 days",
    "SearchPlaceholder": "Search",
    "NoKeys": "No API keys yet",
    "NoSearchResults": "No results",
    "CopyShareLink": "Copy one-time link",
    "Usage": "Usage",
    "Rename": "Rename",
    "Delete": "Delete",
    "ShareLinkCopied": "One-time link copied",
    "ShareLinkCopiedDescription": "The link is valid for 7 days and can only be opened once.",
    "Created": "API key created",
    "Renamed": "Name changed",
    "Deleted": "API key deleted",
    "DeletedDescription": "Providers using this key will be rejected within 1 minute.",
    "ErrorLoading": "API keys could not be loaded",
    "ErrorLoadingRetry": "The API keys could not be loaded. Please try again with “Refresh”.",
    "ErrorCreating": "API key could not be created",
    "ErrorRenaming": "Name could not be changed",
    "ErrorDeleting": "API key could not be deleted",
    "ErrorShareLink": "One-time link could not be created",
    "Errors": {
      "NotLineckerEmployee": "The Lipp API did not confirm that you are a Linecker employee. Only Linecker employees can manage API keys. If your login has expired, please log in again.",
      "StationRequired": "Please select a location.",
      "NameRequired": "Please enter a name.",
      "NameTooLong": "The name must not exceed 100 characters.",
      "NoLippPosRegistered": "No Lipp POS is registered at this location.",
      "KeyNotFound": "This API key no longer exists. Please refresh the list.",
      "ShareLinkFailed": "onetimesecret.com is currently unavailable. Please try again later.",
      "ShareLinkFailedAfterCreate": "The one-time link could not be created. Please try again with the copy icon.",
      "NotAvailableYet": "This feature is not yet available in Lipp Connect."
    },
    "Dialogs": {
      "Key": {
        "CreateTitle": "New API key",
        "RenameTitle": "Rename",
        "NamePlaceholder": "e.g. name of the provider",
        "CreateHint": "After creating, a one-time link to the key is copied to the clipboard."
      },
      "Usage": {
        "Title": "Usage",
        "Calls": "Calls",
        "CallsSummary": "{0} total · {1} in 30 days · {2} errors in 30 days",
        "Endpoints": "Calls per endpoint",
        "Endpoint": "Endpoint",
        "CountValue": "Calls: {0}",
        "ErrorsValue": "Errors: {0}",
        "LastCall": "Last",
        "LastCalls": "Last calls",
        "Time": "Time",
        "Status": "Status",
        "Duration": "Duration",
        "NoCalls": "This key has not been used yet.",
        "ErrorLoading": "The usage could not be loaded."
      },
      "Delete": {
        "Title": "Delete API key",
        "Question": "Delete API key “{0}” ({1}…) of location {2}?",
        "Hint": "Providers using it will be rejected within 1 minute. This cannot be undone.",
        "LippPmsHint": "This key was issued by Lipp PMS. After deleting it, Lipp PMS can no longer reach this Lipp POS."
      },
      "ShareLink": {
        "Title": "One-time link"
      }
    }
  },
  "PaymentMethods": {
    "Title": "Payment methods",
    "PaymentMethod": "Payment method",
    "StripeInfo": "The payment data is stored by <a href=\"https://stripe.com\" target=\"_blank\"><img src=\"{0}\" /></a> and NOT by Lipp Portal!",
    "Default": "Default",
    "ErrorChangingDefaultPaymentMethod": "Default payment method could not be changed",
    "Type": "Type",
    "Types": {
      "Card": "Credit card",
      "SEPA": "Bank account"
    },
    "Name": "Name of card owner",
    "ExpiryDate": "Expiry date",
    "NoExpiryDate": "No expiry date",
    "DefaultPaymentMethod30DaysInfo": "Default payment method must be valid for at least 30 days."
  },
  "Pages": {
    "Login": "Login",
    "ForgotPassword": "Forgot password?",
    "ResetPassword": "Change password",
    "Dashboard": "Dashboard",
    "Enterprises": "Enterprises",
    "Users": "Users",
    "Invoices": "Invoices",
    "Profile": "Profile settings",
    "CloudBackup": "Cloud backup",
    "DigitalReceipt": "Digital receipt",
    "LippBon": "Lipp Bon",
    "LippCare": "Lipp Care",
    "LippPOS": "Lipp POS",
    "Marketplace": "Marketplace",
    "RoomPlan": "Room plan",
    "Statistics": "Statistics",
    "TableReservation": "Table reservation",
    "EnterpriseSettings": "Enterprise settings",
    "PaymentMethods": "Payment methods",
    "OpenApi": "Open API",
    "PosDashboard": "Dashboard",
    "PmsDashboard": "Dashboard",
    "Error": "Error",
    "Download": "Download",
    "Maintenance": "Maintenance",
    "ConfirmRegistration": "Confirm registration",
    "PaymentPay": "Payment",
    "PaymentSuccessful": "Payment successful",
    "PaymentFailed": "Payment failed",
    "PaymentConfirm": "Confirm payment",
    "Payment3DS": "Payment 3DS",
    "Tutorials": "Tutorials",
    "Updates": "Updates",
    "RegisterUser": "Confirm registration",
    "CrossEnterprise": {
      "LippPOS": "Lipp POS - Cross enterprise",
      "Vouchers": "Voucher management - Cross enterprise",
      "OnlineVouchers": "Online voucher sales - Cross enterprise"
    }
  },
  "PmsDashboard": {
    "Reports": {
      "Occupancy": "Occupancy",
      "Logis": "Room revenue",
      "AdrRevpar": "Average rate & RevPAR",
      "Channels": "Booking channels",
      "Weekdays": "Weekdays",
      "Origins": "Guest countries",
      "Categories": "Room categories",
      "LeadTime": "Booking lead time",
      "StayLength": "Length of stay",
      "Pickup": "Pickup",
      "Cancellation": "Cancellation rate",
      "Today": "Today's business"
    },
    "Defaults": {
      "Mine": "My dashboard",
      "Revenue": "Revenue & occupancy",
      "Sales": "Guests & sales",
      "Reception": "Front desk today"
    },
    "Filters": {
      "Properties": "Properties",
      "Categories": "Room categories",
      "Channels": "Channels"
    },
    "Stats": {
      "Average": "Avg",
      "AveragePerSection": "Avg per section",
      "Total": "Total",
      "AverageRate": "Avg rate",
      "RevPar": "RevPAR",
      "Logis": "Room revenue",
      "Rooms": "Rooms",
      "Nights": "Guest nights",
      "Strongest": "Strongest day",
      "Weakest": "Weakest day",
      "Net": "Net",
      "PerDay": "Avg per day",
      "Cancelled": "Cancelled",
      "Bookings": "Bookings",
      "InHouse": "In house",
      "Occupancy": "Occupancy",
      "Deviation": "Deviation",
      "Guests": "Guests",
      "AverageDays": "Avg days",
      "AverageNights": "Avg nights"
    },
    "Series": {
      "Occupancy": "Occupancy"
    },
    "Tooltip": {
      "New": "Newly booked",
      "Cancelled": "Cancelled",
      "Net": "Net",
      "Rooms": "Room nights",
      "Occupancy": "Occupancy",
      "AverageRate": "Avg rate"
    },
    "Unit": {
      "Reservations": "reservations",
      "Rooms": "rooms",
      "RoomNights": "Room nights"
    },
    "Today": {
      "Arrivals": "Arrivals",
      "Departures": "Departures",
      "RoomsCleaned": "Rooms cleaned",
      "PreCheckIn": "Pre check-in",
      "FreeRooms": "Free rooms"
    },
    "States": {
      "Unreachable": "PMS unreachable",
      "NotLinked": "This property is not linked in the PMS yet",
      "CurrencyMix": "The selected properties use different currencies. Amounts are not added up.",
      "RangeTooLong": "Period too long, 366 days at most",
      "NoStation": "No property selected",
      "LoadFailed": "The figures could not be loaded",
      "UnknownReport": "Unknown report"
    },
    "Notes": {
      "NoCompareData": "No comparison data",
      "CompareTrimmed": "Comparison shortened to the same length",
      "ExcludedBookings": "{0} imported bookings without a real booking date are not included",
      "LeadTime": "Days between booking and arrival",
      "StayLength": "Nights per booking, green: week-long stay",
      "CategoryColor": "Colour by occupancy of the category"
    },
    "Pill": {
      "Last30Days": "Last 30 days"
    },
    "PreviewHint": "Figures appear after saving",
    "Thresholds": {
      "Custom": "Custom values",
      "Description": "Custom limits for green and orange, in the unit of the panel"
    },
    "NoChannel": "No channel",
    "UnknownCountry": "Not specified",
    "Other": "Other",
    "FilterLoadError": "Filters could not be loaded"
  },
  "PosDashboard": {
    "DefaultName": "My dashboard",
    "DashboardsHeading": "Dashboards",
    "AddDashboard": "Dashboard",
    "AvailableReports": "Available reports",
    "SearchReports": "Search reports...",
    "RemoveZone": "remove from dashboard?",
    "RemoveWidget": "Remove widget",
    "EmptyDashboard": "Start building your dashboard.",
    "EmptyDashboardHint": "Drag available reports from the right sidebar here.",
    "EmptyDashboardEdit": "Drag available reports from the right sidebar here.",
    "BaseLabel": "Base",
    "NoDashboard": "No dashboard selected.",
    "NoData": "No data available for the selected criteria / period",
    "NoOpenTables": "No open tables available for the selected criteria right now.",
    "TablePrefix": "Table",
    "OtherSegment": "Other",
    "Kinds": {
      "ALL": "All",
      "POS": "POS",
      "PMS": "PMS"
    },
    "NoStation": "No property selected",
    "MetricRevenue": "Revenue",
    "MetricQuantity": "Quantity",
    "LoadFailed": "Data could not be loaded.",
    "Average": "Ø",
    "Total": "Total",
    "Comparison": "Comparison",
    "Save": "Save",
    "Discard": "Discard",
    "Refresh": "Refresh",
    "Export": "Export",
    "ComparisonSeparator": "vs.",
    "SelectAll": "Select all",
    "All": "All",
    "NoFilterOptions": "No options",
    "Filters": {
      "Stations": "Businesses & locations",
      "Users": "Users",
      "Departments": "Departments",
      "ProductGroups": "Product groups"
    },
    "Locations": "Locations",
    "CopySuffix": "(copy)",
    "SaveError": "The dashboard could not be saved.",
    "SaveBlocked": "Changes are not saved because the dashboards could not be loaded. Please reload the page.",
    "LoadError": "Could not load dashboards",
    "LoadErrorDetail": "Please reload the page. Your saved dashboards remain unchanged.",
    "ExportError": "Export failed",
    "ExportErrorDetail": "The dashboard could not be exported. Please try again.",
    "Menu": {
      "Edit": "Edit",
      "Rename": "Rename",
      "Duplicate": "Duplicate",
      "Delete": "Delete"
    },
    "NameDialog": {
      "CreateTitle": "Create dashboard",
      "RenameTitle": "Rename dashboard",
      "Label": "Name",
      "Confirm": "Create",
      "ConfirmRename": "Change"
    },
    "DeleteDialog": {
      "Title": "Delete dashboard",
      "Message": "Do you really want to delete the dashboard {name}?",
      "Confirm": "Delete"
    },
    "DateRange": {
      "Today": "Today",
      "Yesterday": "Yesterday",
      "ThisWeek": "This week",
      "LastWeek": "Last week",
      "ThisMonth": "This month",
      "LastMonth": "Last month",
      "ThisYear": "This year",
      "LastYear": "Last year",
      "NoComparison": "No comparison",
      "PreviousPeriod": "Previous period",
      "PreviousYear": "Same period last year"
    },
    "Weekday": {
      "Mon": "Monday",
      "Tue": "Tuesday",
      "Wed": "Wednesday",
      "Thu": "Thursday",
      "Fri": "Friday",
      "Sat": "Saturday",
      "Sun": "Sunday"
    },
    "MonthShort": {
      "1": "Jan",
      "2": "Feb",
      "3": "Mar",
      "4": "Apr",
      "5": "May",
      "6": "Jun",
      "7": "Jul",
      "8": "Aug",
      "9": "Sep",
      "10": "Oct",
      "11": "Nov",
      "12": "Dec"
    },
    "SystemGroup": {
      "Comment": "Comment",
      "Discount": "Discount",
      "Tip": "Tip"
    },
    "DeletedArticle": "Deleted article",
    "DeletedTable": "Deleted table",
    "DeletedCommodityGroup": "Deleted commodity group",
    "DeletedUser": "Deleted user",
    "Reports": {
      "Revenue": "Revenue",
      "RevenueTrend": "Revenue trend",
      "WeekdayRevenue": "Weekdays",
      "MonthlyRevenue": "Monthly revenue",
      "DailyRevenue": "Daily revenue",
      "TopArticles": "Top articles",
      "TopUsers": "Users",
      "ProductGroups": "Product groups",
      "PaymentMethods": "Payment methods",
      "CancellationRate": "Cancellation rate",
      "OpenTables": "Currently Open Tables",
      "InvoicedArticlesDaily": "Invoiced articles per day",
      "InvoicedGroupsDaily": "Invoiced product groups per day"
    },
    "Thresholds": {
      "Title": "Personal value definition",
      "Description": "Define in percent when an article is rated good, medium or bad – relative to the highest value.",
      "DescriptionInverted": "Define in percent when a table is rated bad, medium or good – relative to the highest value.",
      "Good": "Good",
      "Medium": "Medium",
      "Bad": "Bad",
      "ValueFrom": "from",
      "BadHint": "When the value is below {0}.",
      "Save": "Save"
    },
    "OpenTableDialog": {
      "Quantity": "Qty",
      "Article": "Article",
      "Amount": "Amount",
      "Total": "Open total",
      "Empty": "There are no open items on this table.",
      "LoadFailed": "The table details could not be loaded."
    }
  },
  "DeletePaymentMethod": {
    "Title": "Delete payment method",
    "Description1": "Do you really want to delete the payment method",
    "Description2": "?",
    "Success": {
      "Title": "Deleted payment method",
      "Description": "The payment method <b>{0}</b> has been deleted successfully."
    },
    "Error": "Could not delete payment method"
  },
  "CreatePaymentMethod": {
    "Title": "Create payment method",
    "DefaultPaymentMethod": "Use as default payment method",
    "ErrorPreparing": "Could not prepare creating payment method",
    "Success": {
      "Title": "Created payment method",
      "Description": "The payment method has been created successfully."
    },
    "Error": "Could not create payment method"
  },
  "ReplacePaymentMethod": {
    "Title": "Replace payment method",
    "DefaultPaymentMethod": "Use as default payment method",
    "ErrorPreparing": "Could not prepare replacing payment method",
    "Success": {
      "Title": "Replaced payment method",
      "Description": "The payment method has been replaced successfully."
    },
    "Error": "Could not replace payment method"
  },
  "IncertSettings": {
    "Title": "Incert settings",
    "ClientId": "Client ID",
    "ClientSecret": "Client Secret",
    "ApiKey": "API Key",
    "ApiUrl": "API URL",
    "Success": {
      "Title": "Changed settings",
      "Description": "The settings of Incert have been changed successfully."
    },
    "Error": "Could not change settings",
    "ErrorLoading": "Could not load settings"
  },
  "CancelInvoiceDialog": {
    "Title": "Cancel invoice",
    "Description": "Do you really want to completely cancel the invoice <b>{0}</b> from the enterprise <b>{1}</b>?",
    "Reason": "Reason",
    "Note": "Note",
    "Cancel": "Cancel",
    "Success": {
      "Title": "Cnacelled invoice",
      "Description": "The invoice <b>{0}</b> has been successfully cancelled completely."
    },
    "Error": "Could not cancel invoice",
    "Refund": "Refund"
  },
  "CreateCreditNoteDialog": {
    "Title": "Create credit note",
    "AmountNet": "Amount (net)",
    "AmountGross": "Amount (gross)",
    "Reason": "Reason",
    "Note": "Note",
    "Success": {
      "Title": "Created credit note",
      "Description": "A credit note for the invoice <b>{0}</b> has been created successfully."
    },
    "Error": "Could not create credit note"
  },
  "CorrectInvoiceDialog": {
    "Title": "Correct invoice",
    "Correct": "Correct",
    "Success": {
      "Title": "Corrected invoice",
      "Description": "The invoice <b>{0}</b> has been successfully corrected."
    },
    "Error": "Could not correct invoice",
    "ErrorLoadingEnterprise": "Could not load enterprise"
  },
  "CountriesDropdown": {
    "SearchBarPlaceholder": "Search country..."
  },
  "LippPOS": {
    "Automations": {
      "Title": "Automations",
      "Add": "Automation",
      "NewName": "New automation",
      "CopyName": "{0} (copy)",
      "CopyNameNumbered": "{0} (copy {1})",
      "Rename": "Rename",
      "Duplicate": "Duplicate",
      "Pause": "Pause",
      "Resume": "Resume",
      "Delete": "Delete",
      "Flow": "Flow",
      "FlowEmpty": "Select an automation on the left to see its flow here.",
      "Trigger": "Trigger",
      "Condition": "Condition",
      "Action": "Action",
      "AddCondition": "Add condition",
      "AddAction": "Add action",
      "RemoveStep": "Remove step",
      "Next": "Next",
      "Save": "Save",
      "DayOfMonthLast": "Last day of month",
      "State": {
        "Active": "Saved and active",
        "Unsaved": "Not saved",
        "Paused": "Paused",
        "LastRunFailed": "The last run failed",
        "LastRunFailedWithReason": "The last run failed: {0}"
      },
      "TriggerKind": {
        "event": "When something happens",
        "schedule": "At a point in time"
      },
      "Event": {
        "daily_closing": {
          "created": "Daily closing created"
        },
        "invoice": {
          "cancelled": "Invoice cancelled",
          "recalled": "Invoice retrieved",
          "corrected": "Invoice corrected"
        },
        "booking": {
          "cancelled": "Booking cancelled",
          "instant_cancelled": "Instant cancellation"
        },
        "discount": {
          "changed": "Discount changed"
        },
        "price": {
          "changed": "Price changed"
        },
        "proforma": {
          "created": "Proforma created"
        }
      },
      "Cadence": {
        "daily": "daily",
        "weekly": "weekly",
        "monthly": "monthly"
      },
      "Weekday": {
        "1": "Monday",
        "2": "Tuesday",
        "3": "Wednesday",
        "4": "Thursday",
        "5": "Friday",
        "6": "Saturday",
        "7": "Sunday"
      },
      "Period": {
        "previous_day": "Previous day",
        "previous_week": "Previous week",
        "previous_month": "Previous month",
        "current_month": "Current month",
        "current_year": "Current year"
      },
      "ConditionField": {
        "revenue": "Revenue (gross)",
        "invoice_count": "Number of invoices",
        "cancellation_amount": "Cancellation amount",
        "cancellation_count": "Number of cancellations",
        "average_invoice": "Average per invoice",
        "effort_amount": "Efforts (gross)",
        "booking_cancellation_count": "Number of booking cancellations",
        "instant_cancellation_count": "Number of instant cancellations",
        "amount": "Amount",
        "quantity": "Quantity",
        "user": "User",
        "workstation": "Workstation",
        "table": "Table",
        "article": "Article",
        "reason": "Cancellation reason",
        "discount_percent": "Discount in %",
        "discount_amount": "Discount in €",
        "price": "New price"
      },
      "Operator": {
        "is": "is",
        "is_not": "is not",
        "greater": "greater than",
        "less": "less than",
        "contains": "contains"
      },
      "Join": {
        "and": "AND",
        "or": "OR"
      },
      "ActionKind": {
        "mail": "Send e-mail",
        "print": "Print"
      },
      "Format": {
        "pdf": "PDF",
        "excel": "Excel"
      },
      "Attachment": {
        "CashJournal": "Cash journal",
        "OpenItems": "Open items",
        "AccountingExport": "Accounting export (BMD/DATEV)"
      },
      "Summary": {
        "OnDay": "on the {0}.",
        "At": "at {0}",
        "Attachments": "{0} attachment(s)",
        "Quoted": "“{0}”"
      },
      "Fields": {
        "Name": "Designation",
        "TriggerKind": "Kind",
        "Event": "Event",
        "Cadence": "Cadence",
        "Weekday": "Weekday",
        "DayOfMonth": "Day of month",
        "Time": "Time",
        "Period": "Data period",
        "Field": "Field",
        "Operator": "Comparison",
        "Value": "Value",
        "ActionKind": "Kind",
        "MailAccount": "Sending mail account",
        "To": "Recipients",
        "Cc": "Copy (CC)",
        "Subject": "Subject",
        "Body": "E-mail text",
        "Attachments": "Attachments",
        "Format": "Format",
        "Users": "Users of the user accounting",
        "PrintReport": "Report",
        "Printer": "Printer"
      },
      "Hints": {
        "Event": {
          "daily_closing": {
            "created": "Runs once per closed day — closed at the POS or in Lipp Portal. The closed day is evaluated."
          },
          "invoice": {
            "cancelled": "Runs on every invoice cancellation at the POS (not when positions are retrieved). Attachments show the business day of the cancellation.",
            "recalled": "Runs when the positions of an invoice are retrieved to the table at the POS. Attachments show the business day.",
            "corrected": "Runs when the payment method of an invoice is corrected at the POS."
          },
          "booking": {
            "cancelled": "Runs on every cancellation of an already booked item (with cancellation reason) — also for returns and cancellations of delivery notes, as in the change log.",
            "instant_cancelled": "Runs when an item that has not been sent yet is removed or its quantity is reduced. If a role may remove without logging, no entry is written for it and the automation does not run."
          },
          "discount": {
            "changed": "Runs when the discount of an item is changed at the POS."
          },
          "price": {
            "changed": "Runs when the price of an item is changed at the POS."
          },
          "proforma": {
            "created": "Runs when a proforma invoice is printed at the POS."
          }
        },
        "DayOfMonth": "If the day does not exist in a month (e.g. the 31st), the automation runs on the last day of the month.",
        "Time": "Local time of the station. Please choose a time after the station's change of day — before it, the previous business day is still running and the period is counted from it.",
        "Period": "Which period is evaluated, in business days (day change of the station) — not when it runs.",
        "Field": {
          "revenue": "Gross total of the invoices in the period without expense invoices, cancellations deducted — like the “Normal” total of the invoice statistics. Decimals with a dot.",
          "invoice_count": "Number of invoices in the period, without cancellation receipts.",
          "cancellation_amount": "Total of the cancellation receipts in the period. Decimals with a dot.",
          "cancellation_count": "Number of cancellation receipts in the period (cancellation and retrieved positions).",
          "average_invoice": "Revenue divided by the number of invoices that are not cancelled. Decimals with a dot.",
          "effort_amount": "Gross total of the efforts in the period, cancellations deducted. Decimals with a dot.",
          "booking_cancellation_count": "Number of “Booking cancellation” entries in the change log of the period (also returns and cancellations of delivery notes).",
          "instant_cancellation_count": "Number of “Instant cancellation” entries in the change log of the period.",
          "amount": "Gross amount — for cancellations and retrieved positions the amount of the original invoice. Decimals with a dot.",
          "quantity": "Cancelled or removed quantity. Decimals with a dot.",
          "user": "Who did it at the POS.",
          "workstation": "At which workstation it happened.",
          "table": "Name of the table, as at the POS.",
          "article": "Text of the item or name of the article.",
          "reason": "The cancellation reason chosen at the POS.",
          "discount_percent": "The new discount in percent. Decimals with a dot.",
          "discount_amount": "The new discount per piece in euros. Decimals with a dot.",
          "price": "The new gross price per piece. Decimals with a dot."
        },
        "Recipients": "Separate several addresses with a comma or semicolon.",
        "MailAccount": "A mail account of the station that Lipp Connect can send from.",
        "NoMailAccount": "The station has no mail account that Lipp Connect can send from. Add one under Master data → E-mail accounts.",
        "Attachments": "The lists with the data of the period. Without attachments, only the text is sent.",
        "Users": "Empty: all active users. One accounting per user; by e-mail, several users come as a zip file.",
        "PrintNeedsVersion": "Printing requires Lipp POS 1.38.0 or newer at the main POS."
      },
      "Dialogs": {
        "create": "New automation",
        "createConfirm": "Create",
        "rename": "Rename automation",
        "renameConfirm": "Change",
        "delete": "Delete automation",
        "deleteQuestion": "Do you really want to delete {0}?",
        "discard": "Discard changes",
        "discardQuestion": "The changes to {0} are not saved. Do you want to discard them?",
        "discardConfirm": "Discard",
        "keepEditing": "Keep editing"
      },
      "Errors": {
        "LoadError": "The automations could not be loaded.",
        "LoadStationData": "Reports, printers or users of the station could not be loaded — the selection is incomplete.",
        "SaveError": "The automation could not be saved.",
        "DeleteError": "The automation could not be deleted.",
        "FixFields": "Please check the marked fields.",
        "NotFound": "The automation no longer exists — please reload the page.",
        "NameRequired": "Please enter a designation.",
        "NameTooLong": "The designation may be at most 150 characters long.",
        "NameExists": "An automation with this designation already exists.",
        "StepsRequired": "The automation needs a trigger and an action.",
        "TooManySteps": "The automation has too many steps.",
        "TriggerFirst": "The trigger must come first.",
        "SingleTrigger": "An automation has exactly one trigger.",
        "ActionRequired": "The automation needs at least one action.",
        "StepKindUnknown": "Unknown step.",
        "TriggerKindUnknown": "Please choose the kind.",
        "EventUnknown": "Unknown event.",
        "CadenceUnknown": "Please choose the cadence.",
        "TimeInvalid": "Please choose a time.",
        "WeekdayInvalid": "Please choose a weekday.",
        "DayOfMonthInvalid": "Please choose a day of the month.",
        "PeriodUnknown": "Please choose a period.",
        "FieldUnknown": "Please choose a field.",
        "OperatorUnknown": "Please choose a comparison.",
        "ValueInvalid": "Please enter a number (decimals with a dot).",
        "JoinUnknown": "Unknown link.",
        "ActionKindUnknown": "Please choose what to execute.",
        "MailAccountRequired": "Please choose a sender.",
        "MailAccountNotSendable": "Lipp Connect cannot send from this mail account.",
        "RecipientRequired": "Please enter at least one recipient.",
        "MailAddressInvalid": "An e-mail address is invalid.",
        "SubjectTooLong": "The subject may be at most 200 characters long.",
        "BodyTooLong": "The text may be at most 4000 characters long.",
        "FormatUnknown": "Unknown format.",
        "AttachmentUnknown": "A selected attachment is unknown.",
        "UserIdsInvalid": "A selected user is unknown.",
        "ReportRequired": "Please choose a report.",
        "ReportUnknown": "A selected list no longer exists at the station.",
        "PrinterRequired": "Please choose a printer.",
        "PrinterUnknown": "The selected printer no longer exists at the station.",
        "AccountingExportOpenPeriod": "The accounting export is only available for completed periods (previous day, week or month) — otherwise the rest of the current day would be missing from the next export.",
        "DailyAccountingPeriodTooLong": "The daily accounting covers at most 31 days — please choose a shorter period.",
        "ConditionWithoutAction": "An action has to follow a condition, otherwise it decides nothing.",
        "FieldNotForTrigger": "This field does not exist for the selected trigger — please choose another one.",
        "ValueRequired": "Please enter a value.",
        "ValueSelect": "Please select a value.",
        "AccountingExportEvent": "The accounting export is not available for this event — the business day is still open. Choose “Daily closing created” or a schedule instead.",
        "EventNeedsPosVersion": "This event requires Lipp POS 1.36.0 or newer at the POS.",
        "FieldNeedsPosVersion": "This field requires Lipp POS 1.36.0 or newer at the POS."
      }
    },
    "Data": "Core Data",
    "LayoutDesign": {
      "Title": "Layout & Design",
      "QrOrdering": {
        "Title": "Guest ordering"
      },
      "Article": {
        "Articles": {
          "Articles": "Articles",
          "Article": "Article",
          "ArticlePackages": "Article packages",
          "ArticlePackage": "Article package",
          "Sides": "Sides",
          "Side": "Side",
          "Comments": "Comments",
          "Comment": "Comment",
          "Number": "Article No.",
          "Name": "Name",
          "Price": "Price",
          "SearchArticle": "Search article...",
          "SearchArticlePackage": "Search article package...",
          "SearchSide": "Search side...",
          "SearchComment": "Search comment...",
          "SearchCommodityGroup": "Search commodity group...",
          "AllCommodityGroups": "All commodity groups",
          "SelectAllCommodityGroups": "Select all",
          "NoArticlesFound": "No articles found.",
          "NoArticlePackagesFound": "No article packages found.",
          "NoSidesFound": "No sides found.",
          "NoCommentsFound": "No comments found."
        },
        "Layout": {
          "Title": "Article layout",
          "Designer": "Article designer",
          "ClearAll": "Clear all",
          "LayoutProfile": "Layout group",
          "LayoutMainGroup": "Main group",
          "LayoutSubGroup": "Sub group",
          "RemoveFromLayout": "Remove from layout"
        },
        "ErrorLoadingSettings": "Could not load settings",
        "ErrorLoadingArticles": "Could not load articles",
        "ErrorLoadingCommodityGroups": "Could not load commodity groups",
        "ErrorLoadingLayout": "Could not load layout",
        "Changed": {
          "Title": "Changed article layout",
          "Description": "The article layout has been changed successfully.",
          "Error": "Could not change article layout."
        },
        "Conflicts": {
          "Tag": "<i class=\"fas fa-triangle-exclamation\"></i> Overlapping changes",
          "TooltipTitle": "The following entries were changed externally in the meantime and overlap with your changes:",
          "ChangedExternally": "changed externally",
          "DeletedExternally": "deleted externally",
          "EntityType": {
            "LayoutMainGroup": "Main group",
            "LayoutSubGroup": "Sub group",
            "LayoutSubGroupItem": "Article"
          }
        }
      },
      "Department": {
        "Tables": {
          "Warning": "Available in selected department",
          "Number": "Number",
          "Name": "Name",
          "SearchTable": "Search table...",
          "NoTablesFound": "No tables found.",
          "SearchEffort": "Search effort...",
          "NoEffortsFound": "No efforts found.",
          "SearchRoom": "Search room...",
          "NoRoomsFound": "No rooms found.",
          "Table": "Table",
          "Tables": "Tables",
          "Effort": "Effort",
          "Efforts": "Efforts",
          "Room": "Room",
          "Rooms": "Rooms"
        },
        "Layout": {
          "Title": "Table layout",
          "Designer": "Department & Table designer",
          "Shape": "Table shape",
          "Department": "Department",
          "Size": "Size",
          "Color": "Color",
          "ClearAll": "Clear all"
        },
        "ErrorLoadingSettings": "Could not load settings",
        "ErrorLoadingDepartments": "Could not load departments",
        "Changed": {
          "Title": "Changed table layout",
          "Description": "The table layout has been changed successfully.",
          "Error": "Could not change table layout."
        },
        "Conflicts": {
          "Tag": "<i class=\"fas fa-triangle-exclamation\"></i> Overlapping changes",
          "TooltipTitle": "The following entries were changed externally in the meantime and overlap with your changes:",
          "ChangedExternally": "changed externally",
          "DeletedExternally": "deleted externally",
          "EntityType": {
            "Department": "Department",
            "Table": "Table",
            "DepartmentLayout": "Floor plan element"
          }
        }
      }
    },
    "Integrations": {
      "Title": "Integrations",
      "Discover": "Discover integrations",
      "ErrorLoading": "Could not load integrations",
      "Activate": {
        "Title": "Activate integration",
        "Success": {
          "Title": "Activated integration",
          "Description": "The integration <b>{0}</b> has been activated successfully."
        },
        "Error": "Could not activate integration"
      },
      "Deactivate": {
        "Title": "Deactivate integration",
        "Success": {
          "Title": "Deactivated integration",
          "Description": "The integration <b>{0}</b> has been deactivated successfully."
        },
        "Error": "Could not deactivate integration"
      },
      "Activated": "Activated",
      "Deactivated": "Deactivated"
    },
    "TableReservation": {
      "Title": "Table reservation"
    },
    "BonusSystem": {
      "Title": "Bonus system",
      "Info": "The customer accounts are kept at the till in the menu “Bonus system”. Only the points rules are set here – they apply to the whole station, to the bonus system and the card reader alike."
    },
    "MessageCenter": {
      "Title": "Message center",
      "NewMessage": "New message",
      "PlannedMessages": "Planned messages",
      "SentMessages": "Sent messages",
      "Filter": {
        "From": "From",
        "To": "To",
        "Apply": "Filter",
        "Delete": "Delete"
      },
      "TabsShort": {
        "New": "New",
        "Planned": "Planned",
        "Sent": "Sent"
      },
      "Recipients": "Recipients",
      "AllUsers": "All users",
      "SelectedUsers": "Selected users",
      "SelectAll": "Select all",
      "Users": "Users",
      "Message": "Message",
      "TextPlaceholder": "Enter text …",
      "Timing": "Timing",
      "Immediate": "Immediately",
      "Scheduled": "Scheduled",
      "Recurring": "Recurring",
      "Date": "Date",
      "Time": "Time",
      "Status": "Status",
      "SendNow": "Send message",
      "SendPlanned": "Send as planned",
      "LoadError": "Messages could not be loaded",
      "Saved": {
        "Title": "Message saved",
        "Description": "The POS will send the message at the scheduled time.",
        "DescriptionImmediate": "The POS will send the message as soon as it is connected. It will then appear under \"Sent messages\".",
        "Error": "Message could not be saved"
      },
      "AlreadySent": {
        "Title": "Message already sent",
        "Description": "The POS has sent this message in the meantime. You will find it under sent messages."
      },
      "DueReached": {
        "Title": "Scheduled time reached",
        "Description": "The scheduled time has passed. The POS is sending this message or has already sent it, so it can no longer be edited."
      },
      "StatusTexts": {
        "planned": "planned",
        "recurring": "recurring",
        "sent": "sent",
        "undelivered": "not delivered"
      },
      "Weekdays": {
        "Title": "Weekdays",
        "0": "Sun",
        "1": "Mon",
        "2": "Tue",
        "3": "Wed",
        "4": "Thu",
        "5": "Fri",
        "6": "Sat"
      }
    },
    "DeliveryNotes": {
      "Title": "Delivery notes",
      "TotalOpen": "Total open",
      "Tabs": {
        "Open": "Open",
        "Completed": "Completed",
        "Cancelled": "Cancelled"
      },
      "Columns": {
        "Number": "Number",
        "Date": "Date",
        "DeliveryDate": "Delivery date",
        "Customer": "Customer",
        "Amount": "Gross",
        "Note": "Note",
        "InvoiceNumber": "Inv. no.",
        "Table": "Table",
        "User": "User",
        "Cancelled": "Cancelled",
        "CancelledOn": "Cancelled on"
      },
      "Actions": {
        "Preview": "Preview",
        "Print": "Print",
        "Download": "Download",
        "SendMail": "Send by email"
      },
      "Cancelled": "Cancelled",
      "ErrorLoading": "Delivery notes could not be loaded",
      "ErrorRendering": "Delivery note could not be loaded",
      "NoDeliveryNoteReport": "No delivery note report is configured.",
      "SendMail": {
        "Title": "Send delivery note by email",
        "FilePrefix": "DeliveryNote",
        "Success": {
          "Title": "Delivery note sent",
          "Description": "The delivery note was sent by email to <b>{0}</b>."
        },
        "Error": "Could not send delivery note"
      }
    },
    "InvoiceCenter": {
      "Title": "Invoice center",
      "Columns": {
        "Number": "Inv. no.",
        "Date": "Inv. date",
        "Table": "Table",
        "User": "User",
        "Amount": "Amount",
        "Customer": "Customer",
        "PaymentMethod": "Payment method",
        "Mail": "Email",
        "Cancelled": "Cancellation",
        "CancellationReason": "Cancellation reason"
      },
      "Actions": {
        "Preview": "Preview",
        "Print": "Print",
        "Download": "Download",
        "SendMail": "Send by email"
      },
      "Cancelled": "Cancelled",
      "ErrorLoading": "Could not load invoices",
      "ErrorRendering": "Could not render invoice",
      "NoInvoiceReport": "No invoice report is configured.",
      "SendMail": {
        "Title": "Send invoice by email",
        "Account": "Mail account",
        "NoAccounts": "No mail account is configured for this station.",
        "Recipient": "Recipient",
        "RequiresReauth": "This account must be re-authorized on the POS.",
        "Cc": "Cc",
        "Subject": "Subject",
        "Attachments": "Attachment",
        "Upload": "Upload",
        "Text": "Text",
        "SelectFromCustomers": "Select from customers",
        "CustomerWithoutEmail": "No email address is stored for this customer.",
        "ExceedsSizeLimit": "The attachments exceed the 10 MB size limit.",
        "FilePrefix": "Invoice",
        "Success": {
          "Title": "Invoice sent",
          "Description": "The invoice was sent by email to <b>{0}</b>."
        },
        "Error": "Could not send invoice"
      }
    },
    "Lists": {
      "Title": "Lists & Invoices",
      "Lists": {
        "Title": "Lists"
      },
      "Reports": {
        "Title": "Reports",
        "Types": {
          "0": "Invoice",
          "1": "Order receipt",
          "2": "Course recall receipt",
          "3": "Cancellation receipt",
          "4": "User accounting",
          "5": "Daily accounting",
          "6": "Period accounting",
          "7": "Customer list",
          "8": "Proforma invoice",
          "9": "Table transfer",
          "10": "RKSV",
          "11": "Article sales",
          "12": "Bookings log",
          "13": "Change log",
          "18": "Inventory stock",
          "19": "Inventory movements",
          "20": "Inventory consumption",
          "21": "Inventory",
          "22": "Inventory to fill",
          "26": "Invoice statistics"
        },
        "ErrorLoadingReports": "Could not load reports"
      },
      "Criteria": {
        "Title": "Criteria",
        "Period": "Period",
        "Filters": "Filters",
        "Departments": "Departments",
        "Tables": "Tables",
        "Efforts": "Efforts",
        "RevenueGroups": "Revenue groups",
        "CommodityGroups": "Commodity groups",
        "Articles": "Articles",
        "PaymentMethods": "Payment methods",
        "Weekdays": "Weekdays",
        "SearchPlaceholder": "Search...",
        "SelectAll": "Select all",
        "AllUsers": "All users",
        "AllDepartments": "All departments",
        "AllTables": "All tables",
        "AllEfforts": "All efforts",
        "AllRevenueGroups": "All revenue groups",
        "AllCommodityGroups": "All commodity groups",
        "AllArticles": "All articles",
        "AllWeekdays": "All weekdays",
        "AllPaymentMethods": "All payment methods",
        "AllCustomers": "All customers",
        "AllWorkstations": "All workstations",
        "ChangeLogTypes": "Types",
        "AllChangeLogTypes": "All types",
        "WeekdayNames": {
          "0": "Sunday",
          "1": "Monday",
          "2": "Tuesday",
          "3": "Wednesday",
          "4": "Thursday",
          "5": "Friday",
          "6": "Saturday"
        },
        "ChangeLogTypeNames": {
          "0": "Price change",
          "1": "Discount change",
          "2": "Macro executed",
          "3": "Booking cancellation",
          "4": "Table transfer",
          "5": "Invoice cancellation",
          "6": "Invoice correction",
          "7": "Positions retrieved",
          "8": "Proforma created",
          "9": "Article changed",
          "10": "Department changed",
          "11": "Table changed",
          "12": "Table handover",
          "13": "Instant cancellation",
          "14": "Room charge reassigned or closed without delivery"
        },
        "Users": {
          "Title": "Users",
          "Name": "Name",
          "ErrorLoadingUsers": "Could not load users",
          "SearchPlaceholder": "Search..."
        },
        "Inventory": {
          "Title": "Inventory",
          "NoSelection": "Please select an inventory first.",
          "NoneAvailable": "No inventories available."
        },
        "SummarizeUsers": "Summarize users for accounting?",
        "AdditionalDays": "Select additional days",
        "CloseDay": "Close day",
        "CloseDayTooltipWhenOffline": "The days cannot be closed as the connection to the Lipp POS database is offline.",
        "UndoDailyClosingsTooltipWhenOffline": "The daily closings cannot be reset as the connection to the Lipp POS database is offline.",
        "ErrorLoadingLatestDailyClosing": "Could not load latest daily closing",
        "ErrorLoadingPaymentMethods": "Could not load payment methods",
        "SendSalesToPMS": "Send sales to PMS",
        "SendSalesToPMSTooltipWhenOffline": "The sales cannot be sent to PMS as the connection to the Lipp POS database is offline."
      },
      "Preview": {
        "Title": "Preview",
        "Info": "You can generate a preview for your selection/criteria.",
        "Preview": "Preview",
        "ErrorRendering": "Could not render report",
        "Page": "Page {0}/{1}",
        "Day": "Day {0}/{1}"
      }
    },
    "Reports": {
      "Title": "Report settings",
      "Settings": {
        "Sections": {
          "Company": "Header & company data",
          "Invoice": "Invoices",
          "Receipt": "Order receipts",
          "Accounting": "Accounting reports"
        },
        "ErrorLoading": "Could not load settings",
        "ErrorChanging": "Could not change settings",
        "SuccessChanging": {
          "Title": "Changed settings",
          "Description": "The report settings have been changed successfully."
        },
        "Logo": "Logo",
        "ReceiptLogo": "Receipt logo",
        "A4Logo": "A4 logo",
        "UploadImage": "Upload image",
        "ShowEnterpriseName": "Show enterprise name",
        "ShowZeroOnInvoice": "Show items billed at €0.00",
        "ShowPricesOnReceipt": "Show price on receipt",
        "ShowArticleDescriptionOnInvoice": "Show article description on invoice",
        "ShowArticlePackageDetailsOnInvoice": "Show article package details on invoice",
        "ShowQRCodeOnInvoice": "Show QR code on bank transfer invoice",
        "ShowWebsiteQRCodeOnInvoice": "Show website QR code on invoice",
        "EnableEntertainmentReceipt": "Offer German entertainment receipt as print option",
        "ShowTipFieldOnPMSTransferInfo": "Prints an empty tip field above the signature line on the PMS transfer receipt, to be filled in by hand. It only appears when no tip was entered at the till.",
        "ShowTipFieldOnPMSTransfer": "Show tip field on PMS transfer receipt",
        "ShowTipFieldOnProformaInvoiceInfo": "Prints an empty tip field at the bottom of the proforma invoice, to be filled in by hand.",
        "ShowTipFieldOnProformaInvoice": "Show tip field on proforma invoice",
        "ShowTipFieldOnInvoicePaymentMethodsInfo": "Prints an empty tip field, to be filled in by hand, on invoices paid with one of the selected payment methods. It does not appear when a tip was already entered at the till, nor on cancellation receipts.",
        "ShowTipFieldOnInvoicePaymentMethods": "Show tip field on invoice by payment method",
        "ShowWebsiteQRCodeOnInvoiceInfo": "The QR code is only shown if a website has been entered in the location data.",
        "CountSidesInReceiptSummaryInfo": "Controls whether sides are included in the total item count at the bottom of the order receipt. The printed amount is unaffected.",
        "BoldComment": "Bold comment",
        "CountSidesInReceiptSummary": "Count sides in summary",
        "ShowCompanyData": "Show company data",
        "AlwaysShowBankDetailsOn80mmInvoice": "Always show bank details on 80mm invoices",
        "AlwaysShowBankDetails": "Always show bank details on A4 invoices",
        "UseDin5008Letterhead": "DIN 5008 standard for letterheads",
        "UseDin5008LetterheadInfo": "Applies to A4 invoices and delivery notes. When enabled, the address is placed in the window of a window envelope with a small sender line above it. When disabled, the sender line is omitted and the address and invoice move up without the space reserved for the window.",
        "ShowTipInDailyAccounting": "Show tip in daily accounting",
        "ShowTipInPeriodAccounting": "Show tip in period accounting",
        "ShowTipInUserAccounting": "Show tip in user accounting",
        "ShowDailyTaxTotalsInPeriodAccounting": "Show daily totals by tax rate in period accounting",
        "ShowAdditionalInfoInDailyAccounting": "Show additional info in daily accounting",
        "ShowDailyRevenueGroupsInPeriodAccounting": "Show revenue groups per day in period accounting",
        "ShowDailyRevenueGroupsInDailyAccounting": "Show revenue groups per day in daily accounting",
        "ShowAdditionalInfoInPeriodAccounting": "Show additional info in period accounting",
        "ShowAdditionalInfoInUserAccounting": "Show additional info in user accounting",
        "ShowAdditionalInfoInAccountingInfo": "Depending on the template, shows tax per payment method, open and cancelled bookings, and cancelled and retrieved invoices at the end of the report.",
        "ShowPaymentMethodsPerUserInDailyAccounting": "Show payment methods per user in daily accounting",
        "ShowPaymentMethodsPerUserInPeriodAccounting": "Show payment methods per user per day in period accounting",
        "ShowOpenBookingsInCommodityGroupsInDailyAccounting": "Show open bookings in commodity groups in daily accounting",
        "ShowOpenBookingsInCommodityGroupsInDailyAccountingInfo": "The commodity groups then also include the day's open bookings (except effort tables), and the heading reads \"Bookings\". Payment methods and the tax summary still only show billed bookings. Applies to the supplied daily accounting templates.",
        "ReceiptFontSize": {
          "Title": "Order receipt font size",
          "Small": "Small",
          "Medium": "Medium",
          "Large": "Large"
        },
        "CompanyHeaderAlignment": {
          "Title": "Enterprise data alignment",
          "Left": "Left",
          "Right": "Right",
          "LogoFullWidth": "Logo full width",
          "LogoFullWidthInfo": "With \"Logo full width\" the enterprise data sits below the logo. The header grows by the height of the logo and the invoice address moves down accordingly. With a flat, wide logo it still lines up with the window of a windowed envelope; from roughly 40 mm logo height it drops below it. Print a test page before mailing in windowed envelopes."
        },
        "RksvQrCodeSize": {
          "Title": "RKSV QR code size",
          "Small": "Small",
          "Medium": "Medium",
          "Large": "Large"
        },
        "InvoiceAddressFontSize": {
          "Title": "Invoice address font size",
          "Small": "Small",
          "Medium": "Medium",
          "Large": "Large"
        }
      }
    },
    "Settings": {
      "Title": "Settings",
      "All": {
        "Title": "All"
      },
      "General": {
        "Title": "General"
      },
      "TableLayout": {
        "Title": "Departments & Tables"
      },
      "ArticleLayout": {
        "Title": "Articles"
      },
      "Invoicing": {
        "Title": "Invoicing"
      },
      "Warehouse": {
        "Title": "Warehouse management"
      },
      "QrOrdering": {
        "Title": "QR table ordering",
        "Settings": "Settings",
        "Assortment": "Assortment",
        "IsActive": "Guest ordering active",
        "Discard": "Discard",
        "LayoutProfile": "Layout group",
        "SelectLayoutProfile": "Select layout group …",
        "SelectLayoutProfileHint": "Pick a layout group above to edit its articles for online ordering.",
        "MainGroups": "Main groups",
        "SubGroups": "Sub groups",
        "All": "All",
        "SearchCommodityGroup": "Search commodity group …",
        "Name": "Name",
        "EditArticle": "Edit article",
        "GeneralBackground": "General background",
        "HeaderText": "Header text",
        "MainGroupBackground": "Main group background",
        "MainGroupText": "Main group text",
        "MainGroupSelectedBackground": "Main group selected background",
        "MainGroupSelectedText": "Main group selected text",
        "SubGroupText": "Sub group text",
        "SubGroupSelectedText": "Sub group selected text",
        "ArticleCardBackground": "Article card background",
        "ArticleNameText": "Article name text",
        "PriceText": "Price text",
        "AddButtonBackground": "Add button background",
        "AddButtonText": "Add button text",
        "Design": "Design",
        "Preview": "Live preview",
        "Hint": "Choose which articles appear in the QR guest menu, and optionally adjust the display name, description and price for online ordering.",
        "Search": "Search articles…",
        "Online": "Online",
        "Article": "Article",
        "Number": "Art. no.",
        "Price": "Price",
        "Image": "Image",
        "Bookable": "Orderable",
        "NoArticles": "No articles found.",
        "EditTitle": "Edit online presentation",
        "DisplayName": "Display name (optional)",
        "Description": "Description (optional)",
        "PriceOverride": "Online price (optional)",
        "PriceOverrideHint": "Prefilled with the register price — change only if the online price should differ.",
        "Saved": "Saved.",
        "ShowCallService": "Show \"call service\"",
        "AllowImmediatePay": "Allow immediate payment",
        "AllowPayAtStaff": "Allow paying at the counter",
        "AllowImmediatePayStripeHint": "Only available once a Stripe account is connected. Without Stripe guests cannot pay online — the order stays open and is settled at the table.",
        "AllowImmediatePayHint": "Guests can pay their order online directly by card or wallet instead of ordering openly and settling at the table. Requires a connected Stripe account.",
        "ShowTipPrompt": "Tip prompt on payment page",
        "TipPercent": "Percentage",
        "GuestSessionLifetime": "Guest session validity",
        "GuestSessionLifetimeHint": "How long a QR scan stays valid before the guest has to scan again.",
        "Payment": "Payment",
        "StripeConnected": "Connected",
        "StripeNotConnected": "Not connected",
        "StripeDisconnect": "Disconnect",
        "StripeConnect": "Connect with Stripe",
        "StripeConnectedAs": "Connected as",
        "StripeOnboardingHint": "Connect a Stripe account so guests can pay online directly.",
        "Logo": "Logo",
        "FontSize": "Font size",
        "FontSizes": {
          "Small": "Small",
          "Medium": "Medium",
          "Large": "Large"
        },
        "Colors": "Colors",
        "ResetColors": "Reset to design defaults",
        "UndoColor": "Undo change",
        "PrimaryColor": "Primary color",
        "AccentColor": "Accent color",
        "BackgroundColor": "Background",
        "CardColor": "Card surface",
        "HeadingColor": "Headings",
        "BodyTextColor": "Body text",
        "CategoryBarColor": "Category bar",
        "ButtonTextColor": "Button text",
        "PriceColor": "Price color",
        "PreviewMenu": "Menu",
        "PreviewCategory": "Drinks",
        "PreviewEmpty": "No articles published yet.",
        "TableCodes": "Table QR codes",
        "SearchTable": "Search table …",
        "Table": "Table",
        "NoCode": "No code",
        "GenerateCode": "Generate code",
        "PrintQr": "Print QR",
        "RevokeCode": "Revoke",
        "NoTables": "No tables found.",
        "ScanToOrder": "Scan to order",
        "AllDepartments": "All departments",
        "GenerateAllFiltered": "Generate all filtered",
        "RevokeAllFiltered": "Revoke all filtered",
        "TablesUsed": "{0} of {1} tables active for guest ordering",
        "TableLimitReached": "A maximum of {0} tables per workstation can be used for guest ordering.",
        "MenuCode": "Menu code",
        "MenuCodeHint": "One code for the whole venue, without a table: guests only see the menu and cannot order. For table stickers, tablets and the website. Requires “Guest ordering active” and a layout group under “Assortment”.",
        "MenuLink": "Link to the menu",
        "MenuEmbedCode": "Embed code for the website",
        "MenuEmbedCodeCopied": "Embed code copied.",
        "EmbedHint": "Paste the code where the menu should appear on the website. Adjust the size via width and height of the outer div (default: full width, 800 px high).",
        "MenuCardLabel": "Menu",
        "ScanToViewMenu": "Scan to view the menu"
      },
      "PMSTransfer": {
        "Title": "PMS transfer"
      },
      "Category": "Category",
      "Name": "Name",
      "Value": "Value",
      "Identifiers": {
        "Application": {
          "Title": "Application",
          "DecimalPlacesForPrices": "Decimal places for prices",
          "Language": "System language",
          "Updating": "Update in progress",
          "Version": "Database version",
          "ExitPin": "Code for exiting the Lipp POS application",
          "ShowKeyboard": "Show on-screen keyboard",
          "AutoLogoutInactivityMinutes": "Automatically log out user after inactivity (min)",
          "HapticFeedback": "Vibrate when tapping controls (mobile devices only)",
          "NumericKeypadLikeKeyboard": "Number pad like on a PC keyboard (7 8 9 on top)",
          "PreOrder": "Pre-orders"
        },
        "ArticleLayout": {
          "Title": "Booking Screen Designer",
          "Colors": {
            "Default": {
              "Background": "Article button - default background color",
              "Text": "Article button - default text color"
            }
          },
          "Columns": {
            "Default": "New subgroup - suggested columns",
            "Max": "Subgroup - Columns (max)",
            "Min": "Subgroup - Columns (min)"
          },
          "QuickSelectSides": "Quick-select sides on article",
          "AllowScrolling": "Allow scrolling in subgroups",
          "HidePriceList": "Hide price list",
          "ConfirmPriceListChange": "Confirmation prompt when changing the price list",
          "OnlyShowSidesWithSameCommodityGroup": "Only show side dishes with the same commodity group",
          "RecallFirstCourseImmediately": "Recall the first course immediately",
          "DoNotCumulateBookings": "Do not cumulate bookings",
          "CollapsibleMainGroups": "Collapsible main groups",
          "HideFollowUpArticlesInSplit": "Hide follow-up items when splitting",
          "BookingRowColor": "Booking row color",
          "ShowArticleNumber": "Show article number",
          "Rows": {
            "Default": "New subgroup - suggested rows",
            "Max": "Subgroup - Rows (max)",
            "Min": "Subgroup - Rows (min)"
          },
          "ArticleSortOrder": "Article sort order",
          "SearchedArticleSortOrder": "Sort order in article search",
          "SelectedProfileId": "Selected profile (ID)"
        },
        "Articles": {
          "Title": "Articles",
          "Comment": {
            "DefaultCommentArticleId": "Default article - Comment (ID)"
          },
          "Discount": {
            "DefaultDiscountArticleId": "Default article - Discount (ID)"
          },
          "Tip": {
            "DefaultTipArticleId": "Default article - Tip (ID)"
          }
        },
        "Backup": {
          "Title": "Backup",
          "FullBackupTime": "Full backup time"
        },
        "Bookings": {
          "Title": "Bookings",
          "Cancellation": {
            "DefaultCancellationReasonId": "Default cancellation reason (ID)"
          }
        },
        "DepartmentLayout": {
          "Title": "Department & Table Designer",
          "Colors": {
            "Default": {
              "Background": "New table - default background color",
              "Text": "New table - default text color"
            },
            "Open": {
              "Background": "Open table - background color",
              "Text": "Open table - text color",
              "Old": {
                "Duration": "Open table - color change interval (min)",
                "Background": "Open table - changed background color",
                "Text": "Open table - changed text color"
              }
            }
          },
          "SnapGridRatio": "Snap grid ratio",
          "TableSortOrder": "Table sort order",
          "ShowTimeSinceLastBooking": "Display time since last table booking"
        },
        "Encryption": {
          "Title": "Encryption",
          "Key": "Key",
          "Salt": "Salt"
        },
        "Invoicing": {
          "Title": "Invoicing",
          "DefaultCashInvoicePaymentMethodId": "Default payment method (cash invoice) (ID)",
          "FooterText": "Footer text",
          "HeaderText": "Header text",
          "CashPaymentRequiresConfirmation": "Confirmation prompt for cash invoices",
          "DefaultPaymentMethodId": "Default payment method for article layout",
          "ShowTip": "Show tip functionality",
          "PersonInputOnInvoicing": "Prompt for person count when creating invoice",
          "PrintCancelledInvoice": "Print cancelled invoice",
          "ShowReturnMoneyCalculator": "Show return money calculator on cash payment",
          "EnableZUGFeRD": "Attach e-invoice (ZUGFeRD) when sending by e-mail",
          "ShowNfcTip": "Tip prompt on NFC card payment",
          "ShowSignatureTip": "Tip selection on signature",
          "StayInSplitAfterInvoice": "Stay in split mode after creating an invoice",
          "PrintInvoiceOnEmailSend": "Also print the invoice when sending it by email",
          "CloseEffortTablesOnChangeOfDay": "Automatically close effort tables at the change of day",
          "IgnoreDownPaymentForTip": "Do not deduct down payment from percentage tip",
          "CardPaymentOnlyOnCardCapableWorkstations": "Show card payment only at card-capable workstations",
          "ApplyPrintCountOnReprint": "Print the payment method's print count when reprinting"
        },
        "Keycard": {
          "Title": "Customer cards",
          "TopUpArticleId": "Article - top-up",
          "PointsActive": "Points system active",
          "PointsDivisor": "Turnover per point",
          "PointsRedemptionValue": "Points for € 1",
          "PointsRequiredForRedemption": "Minimum points for a redemption",
          "PointsRedemptionArticleId": "Article for the redemption"
        },
        "Warehouse": {
          "Title": "Warehouse management",
          "EnforceStockLimit": "Block bookings when stock would be negative"
        },
        "PMSTransfer": {
          "Title": "PMS transfer",
          "SignatureRequired": "Require signature for PMS transfer"
        },
        "LippPortal": {
          "Title": "Lipp Portal",
          "Url": {
            "Dev": "URL - Development",
            "Production": "URL - Production",
            "SignalR": {
              "Dev": "SignalR URL - Development",
              "Production": "SignalR URL - Production",
              "Staging": "SignalR URL - Staging"
            },
            "Staging": "URL - Staging"
          }
        },
        "RetailMode": {
          "Title": "Retail Mode",
          "DepartmentId": "Department (ID)"
        },
        "Signing": {
          "Title": "Signing",
          "ApiKey": "API key",
          "ApiSecret": "API secret",
          "CashRegisterId": "Cash register ID",
          "SCUId": "SCU ID",
          "TSSId": "TSS ID",
          "AdminPin": "Admin PIN",
          "TSETimeoutSeconds": "TSE timeout per call (seconds)"
        },
        "Statistics": {
          "Title": "Statistics",
          "ChangeOfDay": {
            "Time": "Change of day for statistics",
            "Type": "Change of day for statistics - Type"
          }
        },
        "Printing": {
          "Title": "Printing",
          "DailyAccountingPrinterId": "Automatic printing of daily accounting"
        },
        "ReportParameters": {
          "Title": "Report settings",
          "ShowCompanyName": "Show enterprise name",
          "LogoFileId": "Logo File ID",
          "A4LogoFileId": "A4 logo file ID",
          "ShowZeroOnInvoice": "Show items billed at €0.00",
          "ShowPricesOnReceipt": "Show price on receipt",
          "ShowArticleDescriptionOnInvoice": "Show article description on invoice",
          "ShowArticlePackageDetailsOnInvoice": "Show article package details on invoice",
          "ShowQRCodeOnInvoice": "Show QR code on bank transfer invoice",
          "ShowWebsiteQRCodeOnInvoice": "Show website QR code on invoice",
          "EnableEntertainmentReceipt": "Offer German entertainment receipt as print option",
          "ShowTipFieldOnPMSTransfer": "Show tip field on PMS transfer receipt",
          "ShowTipFieldOnProformaInvoice": "Show tip field on proforma invoice",
          "ShowTipFieldOnInvoicePaymentMethodIds": "Show tip field on invoice by payment method",
          "AlwaysShowBankDetailsOn80mmInvoice": "Always show bank details on 80mm invoices",
          "BoldComment": "Bold comment",
          "CountSidesInReceiptSummary": "Count sides in summary",
          "ReceiptFontSize": "Order receipt font size",
          "CompanyHeaderAlignment": "Enterprise data alignment",
          "RksvQrCodeSize": "RKSV QR code size",
          "InvoiceAddressFontSize": "Invoice address font size",
          "UseDin5008Letterhead": "DIN 5008 standard for letterheads",
          "ShowOpenBookingsInCommodityGroupsInDailyAccounting": "Show open bookings in commodity groups in daily accounting"
        }
      },
      "Enum": {
        "ArticleLayoutSortOrder": {
          "LeftToRight": "Left to right",
          "TopToBottom": "Top to bottom",
          "Alphabetical": "Alphabetical"
        },
        "DepartmentTableSortOrder": {
          "Number": "Number",
          "Name": "Name"
        },
        "SearchedArticleSortOrder": {
          "Name": "Name",
          "Number": "Number"
        },
        "ShowKeyboard": {
          "Automatic": "Automatic",
          "Yes": "Yes",
          "No": "No"
        }
      }
    },
    "Extensions": {
      "Title": "Extensions",
      "Discover": "Discover extensions"
    },
    "TimeTracking": {
      "Title": "Time tracking",
      "Weekdays": {
        "Sun": "Sun",
        "Mon": "Mon",
        "Tue": "Tue",
        "Wed": "Wed",
        "Thu": "Thu",
        "Fri": "Fri",
        "Sat": "Sat"
      },
      "Export": {
        "Title": "Export",
        "Export": "Export",
        "AllUsers": "All users",
        "Users": "users",
        "Error": "Export could not be created",
        "LatestExportInfo": "Last exported by <b>{0}</b> on <b>{1}</b> at <b>{2}</b>",
        "NoReportAvailable": "The report \"Zeiterfassungsliste\" is not yet available on this station."
      },
      "Entries": {
        "Title": "Working times",
        "Entry": "Entry",
        "User": "User",
        "Date": "Date",
        "Type": "Type",
        "Start": "Clock-in",
        "End": "Clock-out",
        "WorkingTime": "Working time",
        "NonWorkingTime": "Non-working time",
        "Deduction": "Auto deduction"
      },
      "Types": {
        "Title": "Time tracking types",
        "Type": "Type",
        "Name": "Name",
        "Color": "Color",
        "AutoPrint": "Auto print",
        "Report": "Report",
        "Settings": "Settings",
        "Preview": "Preview",
        "NoSettings": "None",
        "IsWorkingTime": "Working time",
        "ActiveInactive": "Active/Inactive",
        "ErrorChanging": "The type could not be changed."
      }
    },
    "OpenItems": {
      "Title": "Open Items Management",
      "MenuTitle": "Open items",
      "Status": {
        "Open": "Open",
        "PartiallyPaid": "Partially paid",
        "Paid": "Paid"
      },
      "Invoices": {
        "Title": "Invoices",
        "TotalOpen": "Total open",
        "Number": "Inv. no.",
        "Date": "Inv. date",
        "DueDate": "Due date",
        "GrossAmount": "Amount",
        "PaidAmount": "Paid",
        "PaidOn": "Paid on",
        "OpenAmount": "Open amount",
        "PaymentMethod": "Payment method",
        "Customer": "Customer"
      },
      "PaymentMethods": {
        "Title": "Payment methods",
        "Description": "Show invoices with the following payment methods",
        "Saved": {
          "Title": "Payment methods saved",
          "Description": "The payment methods tracked in Open Items Management have been saved."
        },
        "Error": "The payment methods could not be saved"
      },
      "Export": {
        "Title": "Export",
        "ErrorExporting": "Open items could not be exported"
      },
      "Settlement": {
        "Settle": "Record payment",
        "Edit": "Edit invoice",
        "Created": {
          "Title": "Payment recorded",
          "Description": "The payment has been recorded."
        },
        "Changed": {
          "Title": "Payment changed",
          "Description": "The payment has been changed."
        },
        "Error": "The payment could not be saved",
        "Dialog": {
          "Title": "Create payment",
          "EditTitle": "Edit invoice",
          "Amount": "Payment amount",
          "OpenAmount": "Remaining open amount",
          "PaidOn": "Paid on",
          "PaymentMethod": "Payment method",
          "InvoiceInformation": "Invoice information",
          "InvoiceNumber": "Invoice number",
          "InvoiceDate": "Invoice date",
          "InvoiceAmount": "Invoice amount",
          "InvoicePaymentMethod": "Payment method"
        }
      }
    },
    "Dunning": {
      "Title": "Dunning",
      "Levels": {
        "Title": "Dunning levels",
        "Add": "Dunning level",
        "Level": "Dunning level",
        "Name": "Name",
        "ToleranceDays": "Tolerance days",
        "MailSubjectAndText": "E-mail subject & text",
        "Edit": "Edit dunning level",
        "Delete": "Delete dunning level",
        "DeleteDescription": "Do you really want to delete the dunning level <b>{0}</b>?",
        "Created": {
          "Title": "Dunning level created",
          "Description": "The dunning level has been created."
        },
        "Changed": {
          "Title": "Dunning level changed",
          "Description": "The dunning level has been changed."
        },
        "Deleted": {
          "Title": "Dunning level deleted",
          "Description": "The dunning level \"{0}\" has been deleted."
        },
        "SaveError": "The dunning level could not be saved",
        "DeleteError": "The dunning level could not be deleted",
        "LoadError": "The dunning levels could not be loaded"
      },
      "Dialog": {
        "CreateTitle": "Create dunning level",
        "EditTitle": "Edit dunning level",
        "MailSubject": "E-mail subject",
        "MailBody": "E-mail text",
        "Placeholders": "Placeholders"
      },
      "Settings": {
        "Title": "Settings",
        "StartDate": "Start date for the automatic dunning run",
        "PaymentMethods": "Payment methods considered by the dunning run",
        "MailAccount": "E-mail account for sending",
        "SendTime": "Time for sending the reminders",
        "Saved": {
          "Title": "Settings saved",
          "Description": "The dunning settings have been saved."
        },
        "Error": "The settings could not be saved",
        "LoadError": "The dunning settings could not be loaded"
      },
      "Block": {
        "Title": "Dunning block",
        "None": "None",
        "Limited": "Limited",
        "Unlimited": "Unlimited",
        "Until": "until",
        "BlockedUntil": "Limited until",
        "Comment": "Dunning block comment",
        "Saved": {
          "Title": "Dunning block saved",
          "Description": "The dunning block has been saved."
        }
      }
    },
    "CashJournal": {
      "Title": "Cash journal",
      "StartFirstTooltip": "The cash journal needs to be started first!",
      "Overview": {
        "Title": "Overview",
        "By": "by {0}",
        "Revenue": "Revenue",
        "Expense": "Expense",
        "CashBalance": "Cash balance",
        "Revenues": "Revenue",
        "Expenses": "Expenses",
        "ErrorLoading": "Could not load overview"
      },
      "Entries": {
        "Title": "Entries",
        "StartCashJournal": "Start cash journal",
        "Export": "Export",
        "Number": "No.",
        "Date": "Date",
        "Description": "Description",
        "Tax": "Tax",
        "TaxAmount": "Tax amount",
        "Amount": "Amount",
        "CashBalance": "Cash balance",
        "User": "User",
        "PaymentMethod": "Payment method",
        "ExternalReceiptNumber": "External receipt number",
        "DailyClosing": "Daily closing",
        "ActiveInactive": "Active/Inactive",
        "ErrorChanging": "Could not change entry"
      },
      "Templates": {
        "Title": "Templates",
        "Template": "Template",
        "Type": "Type",
        "Description": "Description",
        "Tax": "Tax",
        "ActiveInactive": "Active/Inactive",
        "ErrorChanging": "Could not change template"
      },
      "Settings": {
        "Title": "Settings",
        "AddTipAsExpense": "Add tip as expense automatically",
        "DisallowBackdatedEntries": "No entries on past days",
        "BackdatedEntriesLocked": "Entries of past days are locked. Only the current day can be used; it changes with the \"Change of day for statistics\" (setting \"No entries on past days\").",
        "ErrorLoading": "Could not load settings",
        "ErrorChanging": "Could not change settings",
        "Changed": {
          "Title": "Settings changed",
          "Description": "The settings have been saved successfully."
        }
      },
      "ErrorExporting": "Could not export cash journal"
    },
    "OnlineVouchers": {
      "Title": "Online voucher sales",
      "Settings": "Settings",
      "Saved": "Settings saved.",
      "RequiresVoucherGroup": "Online vouchers are group vouchers. The station first has to be switched to the cross-enterprise voucher management (Voucher management → “Migrate vouchers cross-enterprise”, Linecker only) — this also works for a single business.",
      "ShopStatus": {
        "Selling": "The shop is selling.",
        "DayClosed": "Today's business day has been closed at the till – the shop sells again from {0}.",
        "DayClosedNoTime": "Today's business day has been closed at the till – the shop sells again after the day change.",
        "Incomplete": "Not online yet – missing: {0}"
      },
      "Requirements": {
        "voucherType": "Voucher type",
        "voucherArticle": "Voucher article",
        "taxRate": "Tax rate of the voucher article",
        "paymentMethod": "Payment method",
        "user": "User",
        "mailAccount": "Mail account",
        "termsUrl": "Link to the terms and conditions",
        "withdrawalUrl": "Link to the cancellation policy",
        "amounts": "Amounts",
        "stripeAccount": "Stripe account",
        "voucherGroup": "Cross-enterprise voucher management",
        "tse": "Station without German TSE (Austria only)"
      },
      "OptionDefault": "Default",
      "OptionReconnect": "– reconnect in Lipp Portal",
      "Sale": "Sale",
      "VoucherType": "Voucher type",
      "VoucherArticle": "Voucher article (receipt)",
      "VoucherArticleHint": "Commodity group and tax rate of the receipt — as with a voucher sale at the till.",
      "PaymentMethod": "Payment method of the receipt",
      "PaymentMethodHint": "Online purchases appear under this payment method in the reports. Cash, expense, PMS transfer, bank transfer and payment methods for open items cannot be selected – ideally create a separate payment method such as “Online (Stripe)” so online sales are not mixed with card payments at the till.",
      "User": "User of the receipt",
      "MailAccount": "Mail account for sending to the guest",
      "MailAccountHint": "Only accounts the cloud can send from are listed: Google and Microsoft accounts connected in Lipp Portal, and SMTP accounts. Accounts connected at the till can only send from the till.",
      "NoMailAccount": "No suitable mail account available. The shop cannot go online without one – please connect an account in Lipp Portal (Core Data → Mail accounts) or set up an SMTP account.",
      "Amounts": "Amounts",
      "FixedAmounts": "Fixed amounts in € (separated by semicolons)",
      "AllowCustomAmount": "Allow custom amount",
      "MinAmount": "Minimum amount",
      "MaxAmount": "Maximum amount",
      "Texts": "Texts",
      "ShopTitle": "Heading",
      "IntroText": "Introduction",
      "VoucherNote": "Note on the voucher",
      "VoucherNoteHint": "Printed on the PDF, e.g. redemption terms.",
      "Legal": "Legal",
      "LegalHint": "The business is the seller — it provides the legal texts. Terms and cancellation policy are mandatory.",
      "TermsUrl": "Link to the terms and conditions",
      "WithdrawalUrl": "Link to the cancellation policy",
      "PrivacyUrl": "Link to the privacy policy",
      "ImprintUrl": "Link to the imprint",
      "WithdrawalText": "Cancellation policy (wording for the confirmation email)",
      "WithdrawalTextHint": "Included in the purchase confirmation sent to the guest.",
      "Design": "Design",
      "Logo": "Logo",
      "BackgroundColor": "Background",
      "CardColor": "Card",
      "TextColor": "Text",
      "AccentColor": "Accent (heading, buttons)",
      "ButtonTextColor": "Button text",
      "OrderWindow": "Voucher order window",
      "Voucher": "Voucher",
      "VoucherBackground": "Background (PDF)",
      "VoucherBackgroundUpload": "Upload PDF",
      "VoucherTemplate": "Template",
      "VoucherTemplates": {
        "classic": "Classic",
        "bottom": "Card at bottom",
        "center": "Card in center",
        "right": "Strip on right"
      },
      "VoucherPreviewRetry": "Try again",
      "Payment": "Payment",
      "StripeHint": "The same Stripe account as for table ordering. Same fees.",
      "Embed": "Embedding on the website",
      "ShopLink": "Link to the voucher page",
      "EmbedCode": "Embed code (iframe)",
      "EmbedHint": "Paste the code into the business website. “allow=payment” is required for Apple Pay and Google Pay inside the frame.",
      "EmbedWhenComplete": "Link and embed code appear once the shop is fully set up and saved.",
      "PreviewStation": "Your business",
      "DefaultTitle": "Give a voucher",
      "PreviewAmount": "Amount",
      "PreviewCustom": "Custom amount ({0} – {1} €)",
      "PreviewTo": "For",
      "PreviewFrom": "From",
      "PreviewGreeting": "Message (optional)",
      "PreviewEmail": "Your email address",
      "PreviewAccept": "I accept the",
      "TermsShort": "terms",
      "WithdrawalShort": "cancellation policy",
      "PreviewBuy": "Buy now",
      "Purchases": "Online purchases",
      "NoPurchases": "No online purchases yet.",
      "MorePurchases": "There are more than {0} online purchases – showing the latest {0}.",
      "MailErrorHint": "The email could not be sent.",
      "FailureHints": {
        "Failed": "The purchase could not be completed. No payment was collected.",
        "CaptureFailed": "The payment could not be collected via Stripe. The voucher is therefore being blocked.",
        "RefundFailed": "The refund via Stripe failed.",
        "Default": "An error occurred with this purchase."
      },
      "ShowPdf": "Show voucher",
      "ResendMail": "Send mail again",
      "Cancel": "Cancel and refund",
      "MailSent": "Mail sent to {0}.",
      "Cancelled": "Voucher cancelled, the amount is refunded via Stripe.",
      "CancelTitle": "Cancel online purchase",
      "CancelQuestion": "Cancel voucher no. {0} and refund € {1} via Stripe? Only possible while the voucher is unused.",
      "Errors": {
        "Load": "Online voucher sales could not be loaded right now. Please reload the page.",
        "Save": "The settings could not be saved. Please try again in a moment.",
        "Upload": "The logo could not be uploaded. Please try another image (PNG or JPG).",
        "BackgroundNotPdf": "Only a PDF file can be used as the voucher background.",
        "BackgroundUnreadable": "The PDF could not be read. Is it damaged or password-protected?",
        "BackgroundUpload": "The background could not be uploaded. Please try again in a moment.",
        "VoucherPreview": "The voucher preview could not be created right now.",
        "Stripe": "The connection to Stripe could not be started right now. Please try again in a moment.",
        "Pdf": "The voucher could not be opened right now. Please try again in a moment.",
        "Mail": "The mail could not be sent. Please try again in a moment.",
        "Cancel": "The purchase could not be cancelled. Please try again in a moment.",
        "Purchases": "The online purchases could not be loaded right now. Please try again in a moment."
      },
      "Col": {
        "Date": "Date",
        "Number": "Voucher no.",
        "Amount": "Amount",
        "To": "For",
        "From": "From",
        "Email": "Email",
        "Receipt": "Receipt",
        "Status": "Status"
      },
      "Status": {
        "PendingPayment": "Payment pending",
        "Fulfilling": "Processing",
        "Completed": "Completed",
        "Failed": "Failed",
        "CaptureFailed": "Capture failed",
        "Abandoned": "Abandoned",
        "Refunding": "Cancelling",
        "Refunded": "Cancelled",
        "RefundFailed": "Refund failed"
      }
    },
    "Voucher": {
      "Title": "Voucher management",
      "ErrorLoadingStatusCounts": "Could not load status overview",
      "VoucherGroup": {
        "Description": "The vouchers of this location are managed across enterprises. The group consists of: <b>{0}</b>.",
        "Hint": "You now find vouchers and voucher types under \"Cross-Enterprise → Lipp POS → Extensions\".",
        "Open": "Go to cross-enterprise voucher management",
        "Migrate": "Migrate vouchers across enterprises",
        "ErrorLoading": "Could not check whether the vouchers of this location are managed across enterprises. Please reload.",
        "Reload": "Reload"
      },
      "Vouchers": {
        "Title": "Vouchers",
        "All": "All",
        "Open": "Open",
        "Redeemed": "Redeemed",
        "Export": "Export",
        "Type": "Type",
        "Number": "Number",
        "Date": "Date",
        "Name": "Description",
        "Balance": "Balance",
        "TotalValue": "Total",
        "InvoiceNumber": "Invoice no.",
        "InvoiceTotal": "Total (inv.)",
        "PaymentMethod": "Payment method",
        "ErrorExporting": "Could not create export",
        "NoVoucherListReport": "No voucher list report available for this station"
      },
      "VoucherTypes": {
        "Title": "Voucher types",
        "Name": "Description",
        "Tax": "VAT",
        "NumberAssignment": "Number assignment",
        "Automatic": "Automatic",
        "Manual": "Manual",
        "StartNumber": "Start number",
        "Report": "Report",
        "MixedReports": "Differs by location",
        "ActiveInactive": "Active/Inactive",
        "VoucherType": "Voucher type",
        "Default": "Default",
        "ErrorChanging": "Could not change voucher type",
        "ErrorSettingDefault": "Could not set default voucher type"
      },
      "ImportExport": {
        "Title": "Import/Export",
        "Import": "Import",
        "Export": "Export",
        "ImportSuccess": {
          "Title": "Import successful",
          "Description": "{created} voucher(s) created, {updated} updated."
        },
        "ImportPartial": {
          "Title": "Import partially completed",
          "Description": "{created} created, {updated} updated, {failed} failed:"
        },
        "ImportError": {
          "Title": "Import failed"
        },
        "ExportError": "Could not create export"
      }
    },
    "WarehouseManagement": {
      "Title": "Warehouse management",
      "Loading": "Loading...",
      "Active": "Active",
      "Inactive": "Inactive",
      "Export": {
        "Title": "Export report",
        "Tooltip": "Export report",
        "ErrorExporting": "Report could not be exported",
        "NoReportsAvailable": "No report is available."
      },
      "Stock": {
        "Title": "Stock levels",
        "Warehouse": "Warehouse",
        "ArticleNumber": "Art. no.",
        "ArticleName": "Article",
        "Supplier": "Supplier",
        "Pieces": "Pieces",
        "Quantity": "Quantity",
        "Unit": "Unit",
        "PiecesPerPackagingUnit": "Pcs. per PU",
        "PackagingUnits": "No. of PU",
        "MinimumQuantity": "Warning threshold",
        "PurchasePricePerUnit": "Purchase price",
        "PurchaseValue": "Purchase value",
        "NoData": "No stock levels available",
        "ErrorLoading": "Could not load stock levels",
        "MinimumQuantitySaveError": "Warning threshold could not be saved",
        "StockSaveError": "Stock could not be saved"
      },
      "Movements": {
        "Title": "Stock movements",
        "Date": "Booking date",
        "Type": "Booking type",
        "Warehouse": "Warehouse",
        "Article": "Article",
        "Supplier": "Supplier",
        "Pieces": "Pieces",
        "Quantity": "Quantity",
        "Unit": "Unit",
        "PricePerUnit": "Purchase price",
        "PurchaseValue": "Purchase value",
        "GoodsReceipt": "Goods receipt",
        "StockTransfer": "Stock transfer",
        "InventoryCorrection": "Inventory correction",
        "GoodsReceiptCorrection": "Goods receipt correction",
        "ManualCorrection": "Manual correction",
        "CorrectError": "The correction could not be booked",
        "CorrectConfirm": {
          "Title": "Correct goods receipt",
          "Description": "A reversing entry for the same quantity will be created for this goods receipt. The original entry remains in the stock movements.",
          "Amount": "Reversing entry"
        },
        "Corrected": {
          "Title": "Correction booked",
          "Description": "The reversing entry has been created."
        },
        "Consumption": "Sale",
        "ConsumptionReversal": "Cancellation",
        "CurrentMonth": "Current month",
        "Export": "Export",
        "ExportNotAvailable": "Export is not yet available",
        "ErrorExporting": "Could not export stock movements",
        "NoInventoryMovementsReport": "No report of type \"Inventory movements\" is available.",
        "NoData": "No stock movements available",
        "ErrorLoading": "Could not load stock movements"
      },
      "Inventories": {
        "Title": "Inventories",
        "Overview": "Overview",
        "Positions": "Positions",
        "NewInventory": "Inventory",
        "EditInventory": "Edit inventory",
        "Close": "Close",
        "Description": "Description",
        "Warehouse": "Warehouse",
        "CreatedOn": "Created on",
        "ClosedOn": "Closed on",
        "StatusColumn": "Status",
        "Status": {
          "Draft": "Draft",
          "Closed": "Closed"
        },
        "ArticleNumber": "Art. no.",
        "ArticleName": "Article name",
        "Supplier": "Supplier",
        "PlannedPieces": "Planned pcs.",
        "PlannedQuantity": "Planned qty.",
        "DiffPieces": "Diff. pcs.",
        "DiffQuantity": "Diff. qty.",
        "ActualPieces": "Actual pcs.",
        "ActualQuantity": "Actual qty.",
        "Unit": "Unit",
        "PiecesPerPackagingUnit": "Pcs. per PU",
        "ActualPackagingUnits": "Actual no. of PU",
        "NoData": "No inventories available",
        "ErrorLoading": "Could not load inventories",
        "SelectInventoryFirst": "Please select an inventory in the overview tab first.",
        "OpenPDF": "Open PDF",
        "DownloadPDF": "Download PDF",
        "SendByMail": "Send by e-mail",
        "FeatureNotYetAvailable": "This feature is not yet available",
        "CloseConfirm": {
          "Title": "Close inventory?",
          "Description": "{0} differences will be created as correction movements. Stock will be adjusted to the actual value."
        },
        "Created": {
          "Title": "Inventory created",
          "Description": "The inventory was created successfully."
        },
        "Changed": {
          "Title": "Inventory changed",
          "Description": "The description was changed successfully."
        },
        "SaveError": "Could not save inventory",
        "Closed": {
          "Title": "Inventory closed",
          "Description": "Correction movements have been created."
        },
        "ItemSaveError": "Stock could not be saved"
      },
      "Areas": {
        "Title": "Warehouses",
        "Description": "Description",
        "IsDefault": "Default",
        "IsActive": "Active/Inactive",
        "NoData": "No warehouses available",
        "ErrorLoading": "Could not load warehouses"
      },
      "Articles": {
        "Title": "Stock articles",
        "Add": "Add",
        "AddPurchasing": "Purchase article",
        "ToggleError": "Could not activate/deactivate article",
        "Standalone": "Standalone",
        "Recipe": "Recipe",
        "Purchasing": "Purchasing",
        "Type": "Type",
        "Number": "Art. no.",
        "Name": "Description",
        "PriceGross": "Sales price",
        "Costs": "Purchase price",
        "FillQuantity": "Fill quantity",
        "Unit": "Unit",
        "PiecesPerPackagingUnit": "Pcs. per PU",
        "Supplier": "Supplier",
        "CommodityGroup": "Commodity group",
        "IsActive": "Active/Inactive",
        "Assigned": "Assigned",
        "EditRecipe": "Edit recipe",
        "FillQuantitySaveError": "Fill quantity could not be saved",
        "FillQuantityLockedTooltip": "Change the unit to set the fill quantity",
        "SupplierSaveError": "Supplier could not be saved",
        "UnitSaveError": "Unit could not be saved",
        "NoData": "No stock articles available",
        "ErrorLoading": "Could not load stock articles",
        "DeactivateArticle": {
          "Title": "Deactivate article",
          "Description": "Do you really want to deactivate the article <b>{0}</b>?"
        },
        "RemoveFromStock": {
          "Title": "Remove from stock management",
          "Description": "Do you really want to remove the article <b>{0}</b> from stock management?",
          "Error": "Could not remove article from stock management"
        }
      },
      "Suppliers": {
        "Title": "Suppliers",
        "SupplierNumber": "Supplier no.",
        "Name": "Description",
        "City": "City",
        "Country": "Country",
        "VatId": "Supplier VAT id",
        "IsActive": "Active/Inactive",
        "NoData": "No suppliers available",
        "ErrorLoading": "Could not load suppliers",
        "New": "Supplier",
        "CustomerNumber": "Customer no.",
        "Suffix": "Suffix",
        "Street": "Street",
        "ZipCode": "Zip"
      },
      "RemainingQuantities": {
        "Title": "Remaining quantities",
        "Number": "Article no.",
        "Name": "Description",
        "Type": "Type",
        "CommodityGroup": "Commodity group",
        "IsRemainingQuantityArticle": "Remaining-quantity article",
        "Quantity": "Remaining quantity",
        "Warning": "Warning threshold",
        "Unit": "Unit",
        "IsActive": "Active/Inactive",
        "NoData": "No remaining-quantity articles available",
        "ErrorLoading": "Could not load remaining quantities",
        "BelowWarning": "Below warning threshold",
        "SaveError": "Could not save remaining quantity",
        "ToggleError": "Could not toggle remaining-quantity article",
        "NotAllowedForType": "Only articles and sides can be remaining-quantity articles"
      },
      "Requisitions": {
        "Title": "Requisitions",
        "Columns": {
          "Number": "Number",
          "Date": "Date",
          "Department": "To",
          "User": "Ordered by",
          "Note": "Note"
        },
        "Actions": {
          "Preview": "Preview",
          "Print": "Print",
          "Download": "Download",
          "SendMail": "Send by email"
        },
        "SendMail": {
          "Title": "Send requisition by email",
          "FilePrefix": "Requisition",
          "Success": {
            "Title": "Requisition sent",
            "Description": "The requisition was sent by email to <b>{0}</b>."
          },
          "Error": "Could not send requisition"
        },
        "ErrorRendering": "Requisition could not be loaded",
        "NoRequisitionReport": "No requisition report is configured."
      },
      "Actions": {
        "NewWarehouse": "Warehouse area",
        "NewRecipe": "New recipe",
        "GoodsReceipt": "Goods receipt",
        "StockTransfer": "Stock transfer",
        "CorrectGoodsReceipt": "Correct goods receipt",
        "Assignment": "Assignment",
        "NewInventory": "New inventory",
        "EditArticle": "Edit stock article",
        "SetDefault": "Set as default",
        "ToggleActive": "Active/Inactive",
        "DeleteRecipe": "Delete recipe",
        "RemoveFromStock": "Remove from stock management"
      },
      "Dialogs": {
        "Warehouse": {
          "Create": "Create warehouse",
          "Edit": "Edit warehouse",
          "Description": "Description",
          "IsDefault": "Set as default",
          "IsActive": "Active",
          "AssignmentType": "Assignment type",
          "AssignmentWorkstation": "Workstations",
          "AssignmentDepartment": "Departments",
          "AssignmentUser": "Users",
          "Created": {
            "Title": "Warehouse created",
            "Description": "The warehouse <b>{0}</b> has been created successfully.",
            "Error": "Could not create warehouse"
          },
          "Changed": {
            "Title": "Warehouse changed",
            "Description": "The warehouse <b>{0}</b> has been changed successfully.",
            "Error": "Could not change warehouse"
          },
          "ErrorToggling": "Could not activate/deactivate warehouse",
          "ErrorSettingDefault": "Could not set default warehouse"
        },
        "WarehouseAssignment": {
          "Title": "Edit assignment",
          "Workstations": "Workstations",
          "Departments": "Departments",
          "Users": "Users",
          "AssignmentType": "Assignment type",
          "Saved": {
            "Title": "Assignment saved",
            "Description": "The assignment for warehouse <b>{0}</b> has been saved successfully."
          },
          "Error": "Could not save assignment",
          "ErrorLoadingLookups": "Could not load lookup data"
        },
        "Supplier": {
          "Create": "Create supplier",
          "Edit": "Edit supplier",
          "SupplierNumber": "Supplier no.",
          "CustomerNumber": "Customer no.",
          "Name": "Name",
          "Suffix": "Suffix",
          "Street": "Street",
          "ZipCode": "Zip",
          "City": "City",
          "Country": "Country",
          "VatId": "Supplier VAT id",
          "Created": {
            "Title": "Supplier created",
            "Description": "The supplier <b>{0}</b> has been created successfully.",
            "Error": "Could not create supplier"
          },
          "Changed": {
            "Title": "Supplier changed",
            "Description": "The supplier <b>{0}</b> has been changed successfully.",
            "Error": "Could not change supplier"
          },
          "ErrorToggling": "Could not activate/deactivate supplier"
        },
        "GoodsReceipt": {
          "Title": "Record goods receipt",
          "Date": "Date",
          "BookingDate": "Booking date",
          "Warehouse": "Warehouse",
          "Supplier": "Supplier",
          "Article": "Article",
          "Pieces": "Pieces",
          "PiecesLong": "Pieces count",
          "PackagingUnitCount": "Number of PU",
          "PiecesPerPackagingUnit": "Pcs. per PU",
          "Quantity": "Quantity",
          "QuantityLong": "Quantity",
          "FillQuantity": "Fill quantity",
          "PreviewPiecesQuantity": "Preview (pcs. / total quantity)",
          "AddMore": "Record more goods receipts",
          "AddAction": "Add",
          "Created": {
            "Title": "Goods receipt recorded",
            "Description": "The goods receipt has been recorded successfully."
          },
          "Error": "Could not record goods receipt"
        },
        "StockTransfer": {
          "Title": "Perform stock transfer",
          "Date": "Date",
          "BookingDate": "Booking date",
          "SourceWarehouse": "Warehouse - source",
          "TargetWarehouse": "Warehouse - target",
          "Article": "Article",
          "Supplier": "Supplier",
          "Pieces": "Pieces",
          "PiecesLong": "Pieces count",
          "PackagingUnitCount": "Number of PU",
          "PiecesPerPackagingUnit": "Pcs. per PU",
          "Quantity": "Quantity",
          "QuantityLong": "Quantity",
          "FillQuantity": "Fill quantity",
          "PreviewSource": "Preview warehouse - source pcs / qty",
          "PreviewTarget": "Preview warehouse - target pcs / qty",
          "AddMore": "Perform more stock transfers",
          "TransferAction": "Perform",
          "Created": {
            "Title": "Stock transfer recorded",
            "Description": "The stock transfer has been recorded successfully."
          },
          "Error": "Could not record stock transfer",
          "SameWarehouseError": "Source and target warehouse must differ"
        },
        "WarehouseRecipe": {
          "Create": "Create recipe",
          "Edit": "Edit recipe",
          "Article": "Article",
          "Description": "Description",
          "Items": "Items",
          "ItemArticle": "Ingredient",
          "ItemQuantity": "Quantity",
          "AddItem": "Add item",
          "RemoveItem": "Remove",
          "Created": {
            "Title": "Recipe created",
            "Description": "The recipe has been created successfully."
          },
          "Changed": {
            "Title": "Recipe changed",
            "Description": "The recipe has been changed successfully."
          },
          "Error": "Could not save recipe",
          "NoItems": "At least one item must be provided"
        },
        "RecipeDetails": {
          "Title": "Recipe details",
          "Deduction": "Deduction",
          "Article": "Purchasing article",
          "FillQuantity": "Fill quantity",
          "FillQuantityLockedTooltip": "The ingredient is kept in pcs. Change the unit of the stock article to set the fill quantity."
        },
        "AddRecipeArticle": {
          "Title": "Add recipe",
          "Article": "Article"
        },
        "DeleteWarehouseRecipe": {
          "Title": "Delete recipe",
          "Description": "Do you really want to delete the recipe <b>{0}</b>?",
          "Success": {
            "Title": "Recipe deleted",
            "Description": "The recipe has been deleted successfully."
          },
          "Error": "Could not delete recipe"
        },
        "Inventory": {
          "Title": "Inventory",
          "StubNote": "Inventories cannot be persisted yet. This view is a design preview.",
          "Close": "Close"
        },
        "StockArticle": {
          "Title": "Create purchasing article",
          "EditTitle": "Edit purchasing article",
          "Name": "Name",
          "Number": "Art. no.",
          "CommodityGroup": "Commodity group",
          "Supplier": "Supplier",
          "PriceGross": "Sales price",
          "Costs": "Purchase price",
          "FillQuantity": "Fill quantity",
          "Unit": "Unit",
          "PiecesPerPackagingUnit": "Pcs. per PU",
          "Created": {
            "Title": "Purchasing article created",
            "Description": "The purchasing article has been created successfully."
          },
          "Changed": {
            "Title": "Purchasing article changed",
            "Description": "The purchasing article has been changed successfully."
          },
          "Error": "Could not create purchasing article",
          "StubNote": "Editing stock articles from the Portal is not yet available. Use the POS system for article CRUD in the meantime.",
          "Close": "Close"
        },
        "AddStockArticles": {
          "Title": "Mark articles as stock articles",
          "Search": "Search articles (name, art. no.)",
          "SearchCommodityGroup": "Search commodity group",
          "SelectAll": "Select all",
          "Selected": "{0} of {1} selected",
          "NoCandidates": "All articles are already marked as stock articles.",
          "NoMatches": "No articles match the search.",
          "Submit": "Add {0} articles",
          "ErrorLoading": "Could not load articles",
          "ErrorSaving": "The following articles could not be saved",
          "Saved": {
            "Title": "Stock articles added",
            "Description": "{0} articles have been marked as stock articles."
          }
        }
      }
    },
    "DigitalReceipt": {
      "Title": "Digital Receipt",
      "Workstations": {
        "Workstations": "Workstations",
        "ActiveOnWorkstations": "Digital receipt active on the following workstations",
        "Success": {
          "WorkstationTitle": "Workstations changed",
          "WorkstationDescription": "The selection was changed successfully."
        },
        "Error": {
          "WorkstationError": "Error changing the workstations!",
          "InterfaceError": "Error loading the settings!",
          "SettingMissing": "The setting is not yet available on this station."
        }
      }
    },
    "ErrorLoadingData": "Could not load Lipp POS data",
    "RequestSyncBaseData": {
      "Title": "Base data",
      "Success": {
        "Title": "Requested synchronization",
        "Description": "A synchronization of the base data was requested."
      },
      "Error": "Could not request synchronization"
    },
    "RequestSyncTransactionData": {
      "Title": "Transaction data",
      "Success": {
        "Title": "Requested synchronization",
        "Description": "A synchronization of the transaction data was requested."
      },
      "Error": "Could not request synchronization"
    },
    "StartUpdate": {
      "Title": "Plan update",
      "Pending": "Update queued",
      "PendingAt": "Update planned: {0}",
      "Cancel": "Cancel plan",
      "CancelError": "Could not cancel the planned update",
      "Error": "Could not plan the update",
      "Success": {
        "Title": "Update planned",
        "Description": "The update on station <b>{0}</b> will run on {1}. If the station is offline at that time, it will still run up to 1 hour later.",
        "NowTitle": "Update triggered",
        "NowDescription": "The update on station <b>{0}</b> will run now. If the station is offline it will run on next connect (valid for 12 hours)."
      },
      "Dialog": {
        "Title": "Plan update",
        "Description": "When should the update run on station <b>{0}</b>? The station will restart and be briefly unavailable.",
        "Moment": "Time",
        "Moments": {
          "Now": "Now",
          "InMinutes": "in {0} minutes",
          "InHour": "in {0} hour",
          "InHours": "in {0} hours",
          "Custom": "Custom"
        },
        "DateTime": "Date and time",
        "CountdownHint": "If Lipp POS is open on the main station, a 5-minute countdown appears there first.",
        "PlanningRequiresVersion": "Choosing a time requires Lipp POS 1.38.0. Until then the update runs immediately.",
        "TimeInPast": "The selected time is in the past. Please choose a later one.",
        "Confirm": "Plan update"
      }
    },
    "Setup": {
      "Title": "Lipp POS has to be setup.",
      "Description": "In this video we explain how you can setup Lipp POS, so you can then manage your data.",
      "WatchTutorial": "Watch Video"
    },
    "Menu": "Selection",
    "BMD": {
      "Title": "BMD",
      "Export": {
        "Title": "Export",
        "Export": "Export",
        "Error": "Could not create BMD export",
        "NoSettingsSavedYet": "No settings have been saved yet.",
        "LatestExportInfo": "Last exported by <b>{0}</b> on <b>{1}</b> at <b>{2}</b>",
        "YearBoundary": {
          "Title": "Period spans a year boundary",
          "Description": "A DATEV export cannot span a year boundary because the document date only contains day and month. Please export each year separately."
        },
        "MissingText": {
          "Title": "Export not possible",
          "Description": "The following cash movements have no description. It is used as the document text in the DATEV export and is mandatory there. Please add it and export again:"
        },
        "NoMovements": {
          "Title": "No cash movements",
          "Description": "There are no cash movements in the selected period. The bookings file was exported, but no cash movements file was created. Cash movements only exist from the start of this station's cash journal; every period before that stays empty."
        },
        "FormatNotDatev": {
          "Title": "DATEV not set up",
          "Description": "This station is not set to DATEV as its export format. Please click “Save” under “Settings” below and export again."
        }
      },
      "Settings": {
        "Title": "Settings",
        "BookingFileName": "Booking file name",
        "SuspenseAccountNumber": "Suspense account number",
        "BookingSymbol": "Booking symbol",
        "IncludeEfforts": "Include efforts",
        "ErrorLoading": "Could not load settings",
        "ErrorChanging": "Could not change settings",
        "Changed": {
          "Title": "Changed settings",
          "Description": "The settings have been changed successfully."
        }
      },
      "FinancialAccounts": {
        "Title": "Financial accounts",
        "FinancialAccount": "Financial account",
        "AccountNumber": "Account number",
        "AccountName": "Account name",
        "CostCenter": "Cost center",
        "BookingSymbol": "Booking symbol",
        "ExternalTaxCode": "External tax code",
        "OutputType": "Output type",
        "OutputTypes": {
          "0": "Sum",
          "1": "Per invoice",
          "2": "Per day",
          "3": "Single"
        },
        "ActiveInactive": "Active/Inactive",
        "ToggleIsActiveError": "Could not change financial account"
      },
      "Assignments": {
        "Title": "Assignments",
        "CommodityGroup": "Commodity group",
        "CommodityGroups": "Commodity groups",
        "PaymentMethod": "Payment method",
        "PaymentMethods": "Payment methods",
        "Effort": "Effort",
        "Efforts": "Efforts",
        "AccountNumber": "Account number",
        "VAT": "VAT {0}%",
        "TipCommodityGroup": "Tip",
        "DiscountCommodityGroup": "Discount",
        "ErrorLoadingFinancialAccountMappings": "Could not load assignments"
      }
    },
    "DATEV": {
      "Title": "DATEV",
      "Settings": {
        "ExportFormat": "Export format",
        "Consultant": "Consultant number",
        "Client": "Client number",
        "BusinessYearStartMonth": "Fiscal year start (month)",
        "GLAccountNoLength": "G/L account number length",
        "Currency": "Currency"
      }
    },
    "AidaX": {
      "Title": "AIDA.x",
      "CommunicationService": {
        "Title": "Communication service",
        "ErrorLoadingCommunicationServices": "Could not load communication services",
        "ErrorLoadingSelectedCommunicationService": "Could not load selected communication service",
        "Changed": {
          "Success": {
            "Title": "Selected communication service",
            "Description": "The communication service <b>{0}</b> has been selected successfully."
          },
          "Error": "Could not select communication service"
        }
      },
      "Settings": {
        "Title": "Einstellungen",
        "Name": "Bezeichnung",
        "Value": "Wert",
        "Identifiers": {
          "FOLDERPATH": "File storage folder for transfers",
          "INVOICECARRIERFORGUESTS": "Show PMS guests as invoice recipients",
          "SENDDAILYREVENUEPERUSER": "Send daily sales per user",
          "SENDDAILYREVENUEPERWS": "Send daily sales per workstation",
          "SENDDAILYREVENUEWITHOUTTIP": "Send daily sales without tip",
          "SENDDAILYREVENUEAUTOMATIC": "Automatically send daily sales from the previous day",
          "SENDDAILYREVENUESTARTDATE": "Automatically send daily sales from the previous day - Start date",
          "SENDDAILYREVENUETIME": "Automatically send daily sales from the previous day - Time"
        },
        "SendDailyRevenueAutomaticOptions": {
          "0": "No",
          "1": "Yes - PMS room number = Lipp POS table number",
          "2": "Yes - PMS table number = Lipp POS table number"
        }
      }
    },
    "Eucasoft": {
      "Title": "Eucasoft",
      "CommunicationService": {
        "Title": "Communication service",
        "ErrorLoadingCommunicationServices": "Could not load communication services",
        "ErrorLoadingSelectedCommunicationService": "Could not load selected communication service",
        "Changed": {
          "Success": {
            "Title": "Selected communication service",
            "Description": "The communication service <b>{0}</b> has been selected successfully."
          },
          "Error": "Could not select communication service"
        }
      },
      "Settings": {
        "Title": "Settings",
        "Name": "Name",
        "Value": "Value",
        "Identifiers": {
          "FOLDERPATH": "Transfer folder path",
          "INVOICECARRIERFORGUESTS": "Auto-create PMS invoice carriers",
          "SENDDAILYREVENUEAUTOMATIC": "Send daily revenue automatically",
          "SENDDAILYREVENUESTARTDATE": "Send daily revenue automatically - Start date",
          "SENDDAILYREVENUETIME": "Send daily revenue automatically - Time",
          "EUCASOFT_FILENAMEGUESTS": "PMS customers filename",
          "EUCASOFT_FILENAMEBOOKINGS": "PMS bookings filename",
          "EUCASOFT_FILENAMEARTICLES": "Articles filename",
          "EUCASOFT_TRANSFERZEROAMOUNT": "Transfer zero-amount bookings",
          "EUCASOFT_BOOKINGDATEMODE": "Booking date",
          "EUCASOFT_CHECKORPHANCARRIERS": "Check PMS invoice carriers from removed rooms",
          "EUCASOFT_INCLUDETRANSFERS": "Include PMS transfers in daily revenue",
          "EUCASOFT_FIXEDTABLES": "Fixed table numbers (comma-separated, overrides 'Auto-create PMS invoice carriers')"
        },
        "InvoiceCarrierOptions": {
          "0": "No",
          "1": "Yes - PMS room number = Lipp POS table number",
          "2": "Yes - PMS table number = Lipp POS table number"
        },
        "BookingDateMode": {
          "BookingTimestamp": "Booking date",
          "InvoiceTimestamp": "Invoice date"
        }
      }
    },
    "AsaASCII": {
      "Title": "ASA Ascii",
      "CommunicationService": {
        "Title": "Communication service",
        "ErrorLoadingCommunicationServices": "Could not load communication services",
        "ErrorLoadingSelectedCommunicationService": "Could not load selected communication service",
        "Changed": {
          "Success": {
            "Title": "Selected communication service",
            "Description": "The communication service <b>{0}</b> has been selected successfully."
          },
          "Error": "Could not select communication service"
        }
      },
      "Settings": {
        "Title": "Settings",
        "Name": "Name",
        "Value": "Value",
        "Identifiers": {
          "FOLDERPATH": "Transfer folder path",
          "INVOICECARRIERFORGUESTS": "Auto-create PMS invoice carriers",
          "SENDDAILYREVENUEAUTOMATIC": "Send daily revenue automatically",
          "SENDDAILYREVENUESTARTDATE": "Send daily revenue automatically - Start date",
          "SENDDAILYREVENUETIME": "Send daily revenue automatically - Time",
          "ASA_SENDUNITPRICEDISCOUNTED": "Send discounted unit price",
          "ASA_ENCODINGCODEPAGE": "Character set (code page, e.g. 1252)"
        },
        "InvoiceCarrierOptions": {
          "0": "No",
          "1": "Yes - PMS room number = Lipp POS table number",
          "2": "Yes - PMS table number = Lipp POS table number"
        }
      }
    },
    "Sihot": {
      "Title": "SIHOT",
      "CommunicationService": {
        "Title": "Communication service",
        "ErrorLoadingCommunicationServices": "Could not load communication services",
        "ErrorLoadingSelectedCommunicationService": "Could not load selected communication service",
        "Changed": {
          "Success": {
            "Title": "Communication service selected",
            "Description": "The communication service <b>{0}</b> has been selected successfully."
          },
          "Error": "Communication service could not be selected"
        }
      },
      "Settings": {
        "Title": "Settings",
        "Name": "Name",
        "Value": "Value",
        "Identifiers": {
          "SIHOT_URL": "SIHOT server URL",
          "SIHOT_USERNAME": "Username",
          "SIHOT_PASSWORD": "Password",
          "SIHOT_HOTEL": "Hotel number",
          "SIHOT_CASHNO": "Cash register number (1-30)",
          "SIHOT_DAYCLOSECASHNO": "Cash register number dayclose (1-30)",
          "SIHOT_DAYCLOSEACCOUNTS": "Dayclose collective rooms (SIHOT room numbers)",
          "SIHOT_DAYCLOSEACCOUNTS_ACCOUNTNUMBERS": "Dayclose collective accounts (SIHOT account numbers)",
          "INVOICECARRIERFORGUESTS": "Auto-create PMS invoice carriers",
          "SENDDAILYREVENUEAUTOMATIC": "Send daily revenue automatically",
          "SENDDAILYREVENUESTARTDATE": "Send daily revenue automatically - Start date",
          "SENDDAILYREVENUETIME": "Send daily revenue automatically - Time"
        },
        "DaycloseAccountsTooltip": "Room number of the collective account in SIHOT (e.g. 9000), not the account number. The POS looks up the account via a room request each time it sends. One room number for all days, or seven comma-separated numbers for Mon–Sun.",
        "DaycloseAccountNumbersTooltip": "SIHOT account number of the collective account, not the room number. One number for all days, or seven comma-separated numbers for Mon–Sun.",
        "InvoiceCarrierOptions": {
          "0": "No",
          "1": "Yes - PMS room number = Lipp POS table number",
          "2": "Yes - PMS table number = Lipp POS table number"
        }
      },
      "Assignments": {
        "Title": "Assignments",
        "CommodityGroups": "Commodity groups",
        "PaymentMethods": "Payment methods",
        "CommodityGroup": "Commodity group",
        "PaymentMethod": "Payment method",
        "Supercat": "Super category (supercat)",
        "Middlecat": "Middle category (middlecat)",
        "Articlecat": "Article category (articlecat)",
        "SihotCode": "SIHOT payment type"
      }
    },
    "EProtocol": {
      "Title": "E-Protokoll",
      "Description": "Integration with dispensing systems via the classic E-Protokoll (serial or TCP).",
      "SchankSettings": {
        "Title": "Dispenser settings"
      },
      "Tabs": {
        "Systems": "Dispensing systems",
        "Articles": "Dispenser articles"
      },
      "Deactivate": {
        "Button": "Deactivate integration",
        "Error": "Dispensing integration could not be deactivated"
      },
      "Systems": {
        "Title": "Dispensing Systems",
        "Empty": "No dispensing systems configured yet.",
        "LoadError": "Could not load dispensing systems"
      },
      "System": {
        "Add": "Dispensing system",
        "Articles": "Articles",
        "Field": {
          "Name": "Name",
          "IPAddress": "IP address",
          "Connection": "Connection",
          "Port": "Port",
          "Protocol": "Protocol",
          "IsActive": "Active",
          "Assignment": "Assignment",
          "KeyAssignment": "Key list",
          "ArticleAssignment": "Article assignment",
          "CommunicationServer": "Communication server"
        },
        "Saved": {
          "Title": "Dispensing system saved",
          "Error": "Could not save dispensing system"
        },
        "Delete": {
          "Confirm": "Really delete dispensing system \"{0}\"?",
          "Error": "Could not delete dispensing system"
        }
      },
      "Articles": {
        "Title": "Article mappings",
        "Empty": "No articles mapped yet.",
        "NoSystems": "Create a dispensing system first before mapping articles.",
        "SystemSelector": "Dispensing system:",
        "OnlyAssigned": "Show only assigned",
        "AllArticlesEmpty": "No articles available.",
        "UnsavedChanges": "There are unsaved article-mapping changes. Really discard and return to the overview?",
        "Saved": {
          "Title": "Article mappings saved",
          "Description": "The dispenser-article changes have been applied successfully."
        }
      },
      "Article": {
        "Add": "Add article",
        "Field": {
          "ArticleId": "Article ID",
          "ArticleNumber": "Dispenser article number",
          "Mode": "Mode",
          "Name": "Name",
          "Number": "Article no.",
          "CommodityGroup": "Commodity group",
          "DispenserArticleNumber": "Dispenser article no.",
          "DispenserArticleNumberPlaceholder": "Article no."
        },
        "Mode": {
          "Debit": "Debit",
          "Credit": "Credit",
          "Both": "Both"
        },
        "Saved": {
          "Error": "Could not save article mapping"
        },
        "Delete": {
          "Confirm": "Really delete this article mapping?",
          "Error": "Could not delete article mapping"
        }
      },
      "Dialog": {
        "ConnectionSection": "Connection",
        "ConnectionTypeLabel": "Connection type",
        "ProtocolSection": "Protocol",
        "ComPort": "COM port",
        "BaudRate": "Baud rate",
        "DataBits": "Data bits",
        "ParityLabel": "Parity",
        "StopBits": "Stop bits",
        "HandshakeLabel": "Handshake",
        "RtsEnable": "Enable RTS",
        "RtsEnableHint": "Request to Send: hardware flow-control signal. Tells the dispenser 'the POS is ready to send'. Enable when the dispenser expects RTS/CTS handshake — most devices ignore the signal otherwise.",
        "DtrEnable": "Enable DTR",
        "DtrEnableHint": "Data Terminal Ready: tells the dispenser that the POS is up and running (acts like a 'powered on' indicator). Some dispensers refuse any communication unless DTR is asserted.",
        "EProtocolType": "Protocol variant",
        "EProtocolTypeHint": "Determines the wire-format field widths for waiter/product numbers. The correct variant depends on the dispenser vendor.",
        "CalcChecksum": "Append checksum",
        "CreditsUserDependent": "Credits are waiter-bound",
        "CanCreditQty": "Dispenser supports quantity field",
        "CanCreditQtyHint": "On: 3× beer is sent as one booking with qty=3. Off: three separate bookings with qty=1. Which format the dispenser understands depends on the vendor.",
        "DeleteOverdueCreditsOnDayChange": "Automatically delete overdue dispenser credits at day-change",
        "DeleteOverdueCreditsOnDayChangeHint": "At the day-change, all outstanding credits on this dispensing system are automatically deleted.",
        "ConnectionType": {
          "SerialPort": "Serial (RS232)",
          "TcpIp": "TCP/IP"
        },
        "Parity": {
          "None": "None",
          "Odd": "Odd",
          "Even": "Even",
          "Mark": "Mark",
          "Space": "Space"
        },
        "Handshake": {
          "None": "None",
          "XOnXOff": "XOn/XOff",
          "RequestToSend": "RTS",
          "RequestToSendXOnXOff": "RTS + XOn/XOff"
        }
      }
    },
    "Cascade3": {
      "Title": "Cascade 3 (Hart++ / Hart 96)",
      "Description": "Integration with dispensing systems via the Cascade3 protocol (Hart++ / Hart 96, serial or TCP).",
      "SchankSettings": {
        "Title": "Dispenser settings"
      },
      "Tabs": {
        "Systems": "Dispensing systems",
        "Articles": "Dispenser articles"
      },
      "Deactivate": {
        "Button": "Deactivate integration",
        "Error": "Dispensing integration could not be deactivated"
      },
      "Systems": {
        "Title": "Dispensing Systems",
        "Empty": "No dispensing systems configured yet.",
        "LoadError": "Could not load dispensing systems"
      },
      "System": {
        "Add": "Dispensing system",
        "Articles": "Articles",
        "Field": {
          "Name": "Name",
          "IPAddress": "IP address",
          "Connection": "Connection",
          "Port": "Port",
          "Protocol": "Protocol",
          "IsActive": "Active",
          "Assignment": "Assignment",
          "KeyAssignment": "Key list",
          "ArticleAssignment": "Article assignment",
          "CommunicationServer": "Communication server"
        },
        "Saved": {
          "Title": "Dispensing system saved",
          "Error": "Could not save dispensing system"
        },
        "Delete": {
          "Confirm": "Really delete dispensing system \"{0}\"?",
          "Error": "Could not delete dispensing system"
        }
      },
      "Articles": {
        "Title": "Article mappings",
        "Empty": "No articles mapped yet.",
        "NoSystems": "Create a dispensing system first before mapping articles.",
        "SystemSelector": "Dispensing system:",
        "OnlyAssigned": "Show only assigned",
        "AllArticlesEmpty": "No articles available.",
        "UnsavedChanges": "There are unsaved article-mapping changes. Really discard and return to the overview?",
        "Saved": {
          "Title": "Article mappings saved",
          "Description": "The dispenser-article changes have been applied successfully."
        }
      },
      "Article": {
        "Add": "Add article",
        "Field": {
          "ArticleId": "Article ID",
          "ArticleNumber": "Dispenser article number",
          "Mode": "Mode",
          "Name": "Name",
          "Number": "Article no.",
          "CommodityGroup": "Commodity group",
          "DispenserArticleNumber": "Dispenser article no.",
          "DispenserArticleNumberPlaceholder": "Article no."
        },
        "Mode": {
          "Debit": "Debit",
          "Credit": "Credit",
          "Both": "Both"
        },
        "Saved": {
          "Error": "Could not save article mapping"
        },
        "Delete": {
          "Confirm": "Really delete this article mapping?",
          "Error": "Could not delete article mapping"
        }
      },
      "Dialog": {
        "ConnectionSection": "Connection",
        "ConnectionTypeLabel": "Connection type",
        "ProtocolSection": "Protocol",
        "ComPort": "COM port",
        "BaudRate": "Baud rate",
        "DataBits": "Data bits",
        "ParityLabel": "Parity",
        "StopBits": "Stop bits",
        "HandshakeLabel": "Handshake",
        "RtsEnable": "Enable RTS",
        "RtsEnableHint": "Request to Send: hardware flow-control signal. Tells the dispenser 'the POS is ready to send'. Enable when the dispenser expects RTS/CTS handshake — most devices ignore the signal otherwise.",
        "DtrEnable": "Enable DTR",
        "DtrEnableHint": "Data Terminal Ready: tells the dispenser that the POS is up and running (acts like a 'powered on' indicator). Some dispensers refuse any communication unless DTR is asserted.",
        "ConsiderQtyCd": "Consider credit/debit correction quantity",
        "ConsiderQtyCdHint": "On: correction quantities from credit/debit bookings are taken into account. Off: correction quantities are ignored.",
        "ConnectionType": {
          "SerialPort": "Serial (RS232)",
          "TcpIp": "TCP/IP"
        },
        "Parity": {
          "None": "None",
          "Odd": "Odd",
          "Even": "Even",
          "Mark": "Mark",
          "Space": "Space"
        },
        "Handshake": {
          "None": "None",
          "XOnXOff": "XOn/XOff",
          "RequestToSend": "RTS",
          "RequestToSendXOnXOff": "RTS + XOn/XOff"
        }
      }
    },
    "Smartschank": {
      "Title": "Smartschank",
      "Description": "Connects Dirmeier Smartschank dispensing systems. Booking a drink creates a credit that the guest redeems at the device using their tag (customer ID). Choose per system: credits in the manufacturer cloud (SelfserviceCash, shared across branches) or straight to a device on the LAN.",
      "SchankSettings": {
        "Title": "Dispenser settings"
      },
      "Tabs": {
        "Systems": "Dispensing systems",
        "Articles": "Dispenser articles"
      },
      "Deactivate": {
        "Button": "Deactivate integration",
        "Error": "Dispensing integration could not be deactivated"
      },
      "Systems": {
        "Title": "Dispensing Systems",
        "Empty": "No dispensing systems configured yet.",
        "LoadError": "Could not load dispensing systems",
        "EditUnavailable": "The full data of this system could not be loaded — editing would overwrite the stored configuration. Reload the page; if the problem persists, the Connect version does not match the Portal."
      },
      "System": {
        "Add": "Dispensing system",
        "Articles": "Articles",
        "Field": {
          "Name": "Name",
          "IPAddress": "IP address",
          "Connection": "Connection",
          "Port": "Port",
          "Protocol": "Protocol",
          "IsActive": "Active",
          "Assignment": "Assignment",
          "KeyAssignment": "Key list",
          "ArticleAssignment": "Article assignment",
          "CommunicationServer": "Communication server"
        },
        "Saved": {
          "Title": "Dispensing system saved",
          "Error": "Could not save dispensing system"
        },
        "Delete": {
          "Confirm": "Really delete dispensing system \"{0}\"?",
          "Error": "Could not delete dispensing system"
        }
      },
      "Articles": {
        "Title": "Article mappings",
        "Empty": "No articles mapped yet.",
        "NoSystems": "Create a dispensing system first before mapping articles.",
        "SystemSelector": "Dispensing system:",
        "OnlyAssigned": "Show only assigned",
        "AllArticlesEmpty": "No articles available.",
        "UnsavedChanges": "There are unsaved article-mapping changes. Really discard and return to the overview?",
        "Saved": {
          "Title": "Article mappings saved",
          "Description": "The dispenser-article changes have been applied successfully."
        }
      },
      "Article": {
        "Add": "Add article",
        "Field": {
          "ArticleId": "Article ID",
          "ArticleNumber": "Dispenser article number",
          "Mode": "Mode",
          "Name": "Name",
          "Number": "Article no.",
          "CommodityGroup": "Commodity group",
          "DispenserArticleNumber": "Dispenser article no.",
          "DispenserArticleNumberPlaceholder": "Article no."
        },
        "Mode": {
          "Debit": "Debit",
          "Credit": "Credit",
          "Both": "Both"
        },
        "Saved": {
          "Error": "Could not save article mapping"
        },
        "Delete": {
          "Confirm": "Really delete this article mapping?",
          "Error": "Could not delete article mapping"
        }
      },
      "DispensingSystems": "Dispensing Systems",
      "Dialog": {
        "ConnectionSection": "Connection",
        "ConnectionTypeLabel": "Connection type",
        "ConnectionTypeHint": "Manufacturer cloud (SelfserviceCash): credits live at Smartschank and can be redeemed at any of the site's devices. Direct LAN connection: credits go straight to one device on your own network. Cannot be changed on an existing system — create a new one instead.",
        "ConnectionType": {
          "Cloud": "Manufacturer cloud (SelfserviceCash)",
          "Local": "Direct LAN connection"
        },
        "ApiBaseUrl": "API address",
        "IpAddressHint": "IP address or host name of the device — without path and without port (that belongs in the field next to it). A leading https:// is kept; without a scheme, http:// is used.",
        "ApiBaseUrlHint": "Base address of the SelfserviceCash API, e.g. https://app.smartschank.com/ords/dirmeier/selfserviceCash — without a trailing slash.",
        "ApiUsername": "User name",
        "ApiPassword": "Password",
        "TagSection": "Tag (customer ID)",
        "TagIdSourceLabel": "Tag source",
        "TagIdSourceHint": "Generated: Smartschank hands out a short free code per transaction which the guest enters at the device. Customer number: the tag is the customer number on the table’s invoice carrier — bookings without a customer then create no credit.",
        "TagIdSourceHintLocal": "No tag: the credit is created without a customer reference and can be drawn by the waiter signed in at the device — the normal case. Customer number: the customer number from the table's invoice carrier is sent as the customer ID. It does not restrict who may draw at the device.",
        "TagIdSource": {
          "Generated": "Generated",
          "None": "No tag",
          "CustomerNumber": "Customer number"
        },
        "TagLength": "Tag length",
        "TagLookBackHours": "Look-back window (hours)",
        "TagLookBackHoursHint": "Look-back window of the collision check. Tags are short and get reused — without this check a guest could redeem another guest’s open credit. Do not shrink without reason.",
        "CreditType": "Credit type",
        "CreditSection": "Credit content",
        "DeviceId": "Device ID",
        "DeviceIdHint": "Only needed when the system distinguishes several devices/departments. Normally empty — the department follows from the credentials.",
        "PlaceNumber": "Place number",
        "VoucherSection": "Drink voucher",
        "VoucherPrinter": "Voucher printer",
        "VoucherPrinterNone": "No slip",
        "VoucherPrinterHint": "Prints a slip with the redemption code after every booking, which the guest redeems at the dispensing system. Empty = no slip. One slip per credit: two different drinks produce two codes and two slips, because two credits cannot share a tag.",
        "VoucherCodeFormat": "Code format",
        "VoucherCodeFormatHint": "How the code is printed on the slip. Which format the scanner at your system reads depends on the hardware — try it if in doubt. The code is always printed in plain text as well and can be typed in at the device.",
        "VoucherCodeFormatOption": {
          "QrCode": "QR code",
          "Barcode": "Barcode"
        },
        "SendArticleNameAndPrice": "Send article name and price"
      }
    },
    "Tbt": {
      "Title": "TBT",
      "Description": "Integration with TBT dispensing systems (serial or TCP, multi-drop). Bookings flow into Lipp POS and credits are pushed back to the dispenser.",
      "SchankSettings": {
        "Title": "Dispenser settings"
      },
      "Tabs": {
        "Systems": "Dispensing systems",
        "Articles": "Dispenser articles"
      },
      "Deactivate": {
        "Button": "Deactivate integration",
        "Error": "Dispensing integration could not be deactivated"
      },
      "Systems": {
        "Title": "Dispensing Systems",
        "Empty": "No dispensing systems configured yet.",
        "LoadError": "Could not load dispensing systems"
      },
      "System": {
        "Add": "Dispensing system",
        "Articles": "Articles",
        "Field": {
          "Name": "Name",
          "IPAddress": "IP address",
          "Connection": "Connection",
          "Port": "Port",
          "Protocol": "Protocol",
          "IsActive": "Active",
          "Assignment": "Assignment",
          "KeyAssignment": "Key list",
          "ArticleAssignment": "Article assignment",
          "CommunicationServer": "Communication server"
        },
        "Saved": {
          "Title": "Dispensing system saved",
          "Error": "Could not save dispensing system"
        },
        "Delete": {
          "Confirm": "Really delete dispensing system \"{0}\"?",
          "Error": "Could not delete dispensing system"
        }
      },
      "Articles": {
        "Title": "Article mappings",
        "Empty": "No articles mapped yet.",
        "NoSystems": "Create a dispensing system first before mapping articles.",
        "SystemSelector": "Dispensing system:",
        "OnlyAssigned": "Show only assigned",
        "AllArticlesEmpty": "No articles available.",
        "UnsavedChanges": "There are unsaved article-mapping changes. Really discard and return to the overview?",
        "Saved": {
          "Title": "Article mappings saved",
          "Description": "The dispenser-article changes have been applied successfully."
        }
      },
      "Article": {
        "Add": "Add article",
        "Field": {
          "ArticleId": "Article ID",
          "ArticleNumber": "Dispenser article number",
          "Mode": "Mode",
          "Name": "Name",
          "Number": "Article no.",
          "CommodityGroup": "Commodity group",
          "DispenserArticleNumber": "Dispenser article no.",
          "DispenserArticleNumberPlaceholder": "Article no."
        },
        "Mode": {
          "Debit": "Debit",
          "Credit": "Credit",
          "Both": "Both"
        },
        "Saved": {
          "Error": "Could not save article mapping"
        },
        "Delete": {
          "Confirm": "Really delete this article mapping?",
          "Error": "Could not delete article mapping"
        }
      },
      "Dialog": {
        "ConnectionSection": "Connection",
        "ConnectionTypeLabel": "Connection type",
        "ProtocolSection": "TBT settings",
        "ComPort": "COM port",
        "BaudRate": "Baud rate",
        "DataBits": "Data bits",
        "ParityLabel": "Parity",
        "StopBits": "Stop bits",
        "HandshakeLabel": "Handshake",
        "RtsEnable": "Enable RTS",
        "RtsEnableHint": "Request to Send: hardware flow-control signal. Enable when the dispenser expects RTS/CTS handshake — most devices ignore the signal otherwise.",
        "DtrEnable": "Enable DTR",
        "DtrEnableHint": "Data Terminal Ready: tells the dispenser the POS is up and running. Some devices refuse communication unless DTR is asserted.",
        "DeviceCode": "Device address",
        "DeviceCodeHint": "2-character bus address of the device (e.g. D0–D9). TBT is multi-drop: several devices share one COM port and are told apart by this address.",
        "FixedCreditUserNo": "Fixed waiter number",
        "FixedCreditUserNoHint": "When set, ALL outgoing credits of this device are booked on this waiter number (overrides waiter resolution).",
        "ProductNoFormat": "Article no. format",
        "ChannelNoFormat": "Channel no. format",
        "QtyFormat": "Quantity format",
        "UserNoFormat": "Waiter no. format",
        "CanQtyTransfer": "Transfer quantity field",
        "CanQtyTransferHint": "On: the quantity is sent as its own field. Off: the quantity is rolled out into single-unit telegrams (one telegram per unit).",
        "CanItemsInOneRecord": "Several articles per telegram",
        "CanItemsInOneRecordHint": "On: several articles may be combined in one telegram. Off: one telegram per article.",
        "RecordNumbering": "Sequence numbering (Nx)",
        "RecordNumberingHint": "On: the Ns/Nr sequence bits are sent with the telegrams. Only enable when the device expects it (default: off).",
        "EncodingCodePage": "Code page",
        "EncodingCodePageHint": "Character set for the telegrams. Default 28591 (ISO-8859-1). Do NOT use 1252 — it silently loses about 10% of telegrams.",
        "ReceiveTimeoutMs": "Answer timeout (ms)",
        "PollDeviceIdleMs": "Pause per device (ms)",
        "WaitAfterCreditAcceptedMs": "Pause after credit (ms)",
        "ConnectionType": {
          "SerialPort": "Serial (RS232)",
          "TcpIp": "TCP/IP"
        },
        "Parity": {
          "None": "None",
          "Odd": "Odd",
          "Even": "Even",
          "Mark": "Mark",
          "Space": "Space"
        },
        "Handshake": {
          "None": "None",
          "XOnXOff": "XOn/XOff",
          "RequestToSend": "RTS",
          "RequestToSendXOnXOff": "RTS + XOn/XOff"
        }
      }
    },
    "Incert": {
      "Title": "Incert"
    },
    "Websline": {
      "Title": "Websline"
    },
    "ExternalVouchers": {
      "Settings": "Settings",
      "ApiUrl": "API URL",
      "ApiKey": "API Key",
      "ClientId": "Client ID",
      "ClientSecret": "Client Secret",
      "ErrorLoading": "Interface could not be loaded",
      "Saved": {
        "Title": "Settings saved",
        "Description": "The {0} settings were saved successfully."
      },
      "SaveError": "Settings could not be saved",
      "NotConfigured": "Please save all credentials first."
    },
    "DispensingSystemGroup": {
      "Group": "Group",
      "SaveError": "The group could not be saved."
    },
    "DispensingSystemArticleTools": {
      "ImportExport": "Import/Export",
      "Import": "Import",
      "Export": "Export",
      "Copy": "Transfer",
      "FileName": "Dispenser articles",
      "UnsavedChanges": {
        "Title": "Unsaved changes",
        "Description": "Please save first, then import, export or transfer."
      },
      "NoMappings": "This dispensing system has no article mapping to transfer yet.",
      "NoTargets": "There is no other dispensing system to transfer to.",
      "ImportSuccess": {
        "Title": "Import successful",
        "Description": "{created} created, {updated} changed, {deleted} removed."
      },
      "ImportPartial": {
        "Title": "Import partially successful",
        "Description": "{created} created, {updated} changed, {deleted} removed, {failed} failed:"
      },
      "ImportRow": "Row {row}: {reason}",
      "DuplicatesRemoved": "Removed duplicate mappings from legacy data: {count}.",
      "ImportError": "Import failed",
      "ExportError": "The dispenser articles could not be exported"
    },
    "GruberVMPS": {
      "Title": "Gruber VMPS",
      "Description": "Connection to dispensing systems via the Gruber VMPS protocol (UDP). Dispensing operations run directly through the Lipp POS.",
      "SchankSettings": {
        "Title": "Dispenser settings"
      },
      "Tabs": {
        "Systems": "Dispensing systems",
        "Articles": "Dispenser articles"
      },
      "Deactivate": {
        "Button": "Deactivate integration",
        "Error": "Dispensing integration could not be deactivated"
      },
      "Systems": {
        "Title": "Dispensing Systems",
        "Empty": "No dispensing systems configured yet.",
        "LoadError": "Could not load dispensing systems"
      },
      "System": {
        "Add": "Dispensing system",
        "Articles": "Articles",
        "Field": {
          "Name": "Name",
          "IPAddress": "IP address",
          "Connection": "Connection",
          "Port": "Port",
          "Protocol": "Protocol",
          "IsActive": "Active",
          "Assignment": "Assignment",
          "KeyAssignment": "Key list",
          "ArticleAssignment": "Article assignment",
          "CommunicationServer": "Communication server"
        },
        "Saved": {
          "Title": "Dispensing system saved",
          "Error": "Could not save dispensing system"
        },
        "Delete": {
          "Confirm": "Really delete dispensing system \"{0}\"?",
          "Error": "Could not delete dispensing system"
        }
      },
      "Articles": {
        "Title": "Article mappings",
        "Empty": "No articles mapped yet.",
        "NoSystems": "Create a dispensing system first before mapping articles.",
        "SystemSelector": "Dispensing system:",
        "OnlyAssigned": "Show only assigned",
        "AllArticlesEmpty": "No articles available.",
        "UnsavedChanges": "You have unsaved article-mapping changes. Discard and go back to the schank list?",
        "Saved": {
          "Title": "Article mappings saved",
          "Description": "The dispenser-article changes have been applied successfully."
        }
      },
      "Article": {
        "Add": "Add article",
        "Field": {
          "ArticleId": "Article ID",
          "ArticleNumber": "Dispenser article number",
          "Mode": "Mode",
          "Name": "Name",
          "Number": "Article no.",
          "CommodityGroup": "Commodity group",
          "DispenserArticleNumber": "Dispenser article no.",
          "DispenserArticleNumberPlaceholder": "Article no."
        },
        "Mode": {
          "Debit": "Debit",
          "Credit": "Credit",
          "Both": "Both"
        },
        "Saved": {
          "Error": "Could not save article mapping"
        },
        "Delete": {
          "Confirm": "Really delete this article mapping?",
          "Error": "Could not delete article mapping"
        }
      }
    },
    "Keycard": {
      "Title": "Card reader",
      "ErrorLoadingInterfaces": "Card reader could not be loaded",
      "NoWorkstationsAssigned": "No workstation has been assigned yet.",
      "Workstations": {
        "Title": "Workstations",
        "ActiveOnWorkstations": "Card reader active on the following workstations"
      },
      "Reader": {
        "Title": "Reader",
        "ReaderType": "Reader model",
        "ReaderTypes": {
          "OrdermanExternal": "Orderman Ordercard Reader (external)",
          "OrdermanColumbus": "Orderman Columbus (built-in)",
          "ElatecTwn4": "Elatec TWN4 (Simple Protocol)"
        },
        "BaudRate": "Baud rate",
        "ReverseTagBytes": "Reverse card ID",
        "ReverseTagBytesHint": "Reverses the byte order of the card ID that was read. Needed when card numbers from another system have to match. Caution: after a change, cards already registered are recognised under a new number."
      },
      "Points": {
        "Title": "Points system",
        "Active": "Active",
        "Divisor": "Turnover per point",
        "DivisorTooltip": "The invoice amount a guest has to spend for one point. Example: 10 → an invoice of € 100 earns 10 points.",
        "RedemptionValue": "Points for € 1",
        "RedemptionValueTooltip": "How many points are worth € 1 when the guest redeems points. Example: 10 → 50 points are worth € 5.",
        "RequiredPoints": "Minimum points for a redemption",
        "RequiredPointsTooltip": "Redeeming is only possible from this number of points. Leave empty to allow redeeming from the very first point.",
        "ErrorLoading": "The points system settings could not be loaded",
        "Edit": {
          "Success": {
            "Title": "Points system changed",
            "Description": "The points system settings were changed successfully."
          },
          "Error": "The points system settings could not be changed"
        }
      },
      "Edit": {
        "Success": {
          "Title": "Card reader changed",
          "Description": "The card reader settings were changed successfully."
        },
        "Error": "Card reader settings could not be changed"
      }
    },
    "WaiterLock": {
      "Title": "Addimat waiter lock",
      "ErrorLoadingInterfaces": "Could not load waiter lock",
      "NoWorkstationsAssigned": "No workstation has been assigned yet.",
      "Workstations": {
        "Title": "Workstations",
        "ActiveOnWorkstations": "Waiter lock active on the following workstations",
        "Edit": {
          "Success": {
            "Title": "Changed workstations",
            "Description": "The workstations for the waiter lock have been changed successfully."
          },
          "Error": "Could not change workstations for waiter lock"
        }
      }
    },
    "CashDrawer": {
      "Title": "Cash drawer",
      "ErrorLoadingInterfaces": "Could not load cash drawer",
      "NoWorkstationsAssigned": "No workstation has been assigned yet.",
      "Workstations": {
        "Title": "Workstations",
        "ActiveOnWorkstations": "Cash drawer active on the following workstations",
        "Edit": {
          "Success": {
            "Title": "Changed workstations",
            "Description": "The workstations for the cash drawer have been changed successfully."
          },
          "Error": "Could not change workstations for cash drawer"
        }
      },
      "ErrorLoadingPaymentMethods": "Could not load payment methods",
      "PaymentMethods": {
        "Title": "Payment method",
        "OpenForPaymentMethods": "Open cash drawer for the following payment methods",
        "Edit": {
          "Success": {
            "Title": "Changed payment methods",
            "Description": "The payment methods for the cash drawer have been changed successfully."
          },
          "Error": "Could not change payment methods for cash drawer"
        }
      },
      "NoPaymentMethodsAssigned": "No payment method has been assigned yet."
    },
    "CustomerDisplay2Lines": {
      "Title": "Customer display, 2 lines",
      "ErrorLoadingInterfaces": "Could not load customer display (2 lines)",
      "NoWorkstationsAssigned": "No workstation has been assigned yet.",
      "Workstations": {
        "Title": "Workstations",
        "ActiveOnWorkstations": "Customer display (2 lines) active on the following workstations",
        "Edit": {
          "Success": {
            "Title": "Changed workstations",
            "Description": "The workstations for the customer display (2 lines) have been changed successfully."
          },
          "Error": "Could not change workstations for customer display (2 lines)"
        }
      },
      "Idlerun": {
        "Title": "Idle screen",
        "IdleTimeout": "Idle message after invoice creation",
        "Message1": "Idle message line 1",
        "Message1Placeholder": "Welcome",
        "Message2": "Idle message line 2",
        "Message2Placeholder": "Buy 2 get 1 free!",
        "Edit": {
          "Success": {
            "Title": "Idle screen saved",
            "Description": "The idle screen settings have been saved successfully."
          },
          "Error": "Could not save idle screen settings"
        }
      }
    },
    "CustomerDisplay": {
      "Title": "Customer display",
      "Workstations": {
        "Workstations": "Workstations",
        "DisplayOnWorkstations": "Customer display active on the following workstations"
      },
      "Design": {
        "Design": "Design",
        "BackgroundColor": "Background colour",
        "TextBackgroundColor": "Headline & booking text - Background colour",
        "FontColor": "Headline & booking text - Text colour",
        "FooterTextBackgroundColor": "Footer - Background colour",
        "FooterFontColor": "Footer - Text colour",
        "CashFontColor": "Receive cash - Colour text",
        "ChangeFontColor": "Change - Colour text",
        "Logo": "Logo",
        "UploadPicture": "Upload picture",
        "Headline": "Headline/Additional text",
        "PictureOrVideo": "Pictures/Videos",
        "UpdloadPictureOrVideo": "upload Pictures/Videos",
        "Slideshow": "Display images/videos as a slideshow with a time delay after invoicing"
      },
      "Preview": {
        "Preview": "Preview",
        "Text": "You can generate a digital preview of your changes.",
        "Quantity": "Quantity",
        "Description": "Description",
        "Gross": "Gross",
        "Total": "Total",
        "CashReceived": "Cash received",
        "Change": "Change",
        "Schnitzel": "Schnitzel with fries"
      },
      "Success": {
        "WorkstationTitle": "Added workstation",
        "WorkstationDescription": "The selection has been changed successfully.",
        "DesignTitle": "Changed design",
        "DesignDescription": "The design has been changed successfully."
      },
      "Error": {
        "WorkstationError": "Error changing workstations!",
        "DesignError": "Error changing the design!",
        "InterfaceError": "Error loading the settings!",
        "LoadFilesError": "Error loading images/videos!"
      },
      "ActivateIntegration": "Activate integration",
      "DeactivateIntegration": "Deactivate integration"
    },
    "ZVT": {
      "Title": "ZVT Payment Terminal",
      "Error": "Error loading the integration.",
      "Settings": {
        "Title": "Payment Terminals",
        "PaymentTerminal": "Payment Terminal",
        "Name": "Name",
        "IPAddress": "IP Address",
        "Port": "Port",
        "Workstation": "Workstation",
        "PaymentMethods": "Payment Methods",
        "ProcessTerminalTip": "Tip prompt",
        "AutoEndOfDay": "Auto End of Day",
        "IsActive": "Active/Inactive",
        "Success": "Successfully activated payment terminal",
        "ChangeError": "Could not change setting",
        "SettingNotSynced": "Setting not yet synced from the POS"
      }
    },
    "SixTIM": {
      "Title": "SIX TIM Payment Terminal",
      "Error": "Error loading the integration.",
      "Settings": {
        "Title": "Payment Terminals",
        "PaymentTerminal": "Payment Terminal",
        "Name": "Name",
        "ConnectionMode": "Connection Mode",
        "ConnectionModes": {
          "Broadcast": "Broadcast",
          "FixedIP": "Fixed IP"
        },
        "TerminalId": "Terminal ID",
        "IPAddress": "IP Address",
        "Port": "Port",
        "Workstation": "Workstation",
        "PaymentMethods": "Payment Methods",
        "ProcessTerminalTip": "Tip on Terminal",
        "AutoEndOfDay": "Auto End of Day",
        "IsActive": "Active/Inactive",
        "Success": "Successfully activated payment terminal",
        "ChangeError": "Could not change setting",
        "ErrorLoadingPaymentMethods": "Error loading payment methods",
        "ActivateError": "The payment terminal could not be activated."
      },
      "Dialogs": {
        "PaymentTerminal": {
          "Create": "Create Payment Terminal",
          "Name": "Name",
          "ConnectionMode": "Connection Mode",
          "TerminalId": "Terminal ID",
          "IPAddress": "IP Address",
          "Port": "Port",
          "ActiveWorkstations": "Enable payment terminal on the following workstation",
          "ActivePaymentMethods": "Enable payment terminal for the following payment methods",
          "ProcessTerminalTip": "Enter tip on the terminal",
          "AutoEndOfDay": "Automatic end of day",
          "Created": {
            "Title": "Payment terminal created",
            "Description": "Successfully created payment terminal.",
            "Error": "Error creating new payment terminal"
          }
        },
        "DeactivatePaymentTerminal": {
          "Title": "Deactivate payment terminal",
          "Description": "Do you really want to deactivate the payment terminal <b>{0}</b>?",
          "Error": "Could not deactivate payment terminal",
          "Success": "Successfully deactivated payment terminal"
        }
      }
    },
    "Articles": {
      "Title": "Articles",
      "Article": "Article",
      "Type": "Type",
      "Types": {
        "0": "Article",
        "1": "Folder",
        "2": "Article package",
        "3": "Side",
        "5": "Comment",
        "6": "Tip",
        "7": "Discount",
        "9": "Voucher",
        "10": "Purchasing",
        "11": "Deposit return",
        "12": "Down payment"
      },
      "CommodityGroup": "Commodity group",
      "Printers": "Printers",
      "Number": "Article No.",
      "Name": "Name",
      "Price": "Price",
      "ActiveInactive": "Active/Inactive",
      "ToggleIsActiveError": "Could not change article",
      "ImportExport": "Import/Export",
      "Import": "Import",
      "Export": "Export",
      "ImportSuccess": {
        "Title": "Import successful",
        "Description": "{created} articles created, {updated} updated."
      },
      "ImportPartial": {
        "Title": "Import partially successful",
        "Description": "{created} articles created, {updated} updated, {failed} failed:"
      },
      "ImportError": {
        "Title": "Import failed",
        "Description": "Articles could not be imported."
      },
      "ExportError": "Articles could not be exported"
    },
    "CancellationReasons": {
      "Title": "Cancellation reasons",
      "CancellationReason": "Cancellation reason",
      "Default": "Default",
      "Name": "Name",
      "ActiveInactive": "Active/Inactive",
      "SetDefaultError": "Could not set default cancellation reason",
      "ChangeSortOrderError": "Could not change cancellation reason",
      "ToggleIsActiveError": "Could not change cancellation reason"
    },
    "CommodityGroups": {
      "Title": "Commodity groups",
      "CommodityGroup": "Commodity group",
      "RevenueGroup": "Revenue group",
      "Name": "Name",
      "VAT": "VAT",
      "ActiveInactive": "Active/Inactive",
      "ToggleIsActiveError": "Could not change commodity group",
      "ChangeSortOrderError": "Could not change commodity group",
      "ImportExport": "Import/Export",
      "Import": "Import",
      "Export": "Export",
      "ImportSuccess": {
        "Title": "Import successful",
        "Description": "{created} commodity groups created, {updated} updated."
      },
      "ImportPartial": {
        "Title": "Import partially successful",
        "Description": "{created} commodity groups created, {updated} updated, {failed} failed:"
      },
      "ImportError": {
        "Title": "Import failed",
        "Description": "Commodity groups could not be imported."
      },
      "ImportCreatedRevenueGroups": "Newly created revenue groups: {names}",
      "ExportError": "Commodity groups could not be exported"
    },
    "CommunicationServices": {
      "Title": "Communication services",
      "CommunicationService": "Communication service",
      "Name": "Name",
      "DeviceName": "Device name",
      "Networks": "Networks",
      "Main": "Main service",
      "Status": "Status",
      "Online": "Online",
      "Offline": "Offline",
      "LogFile": "Log",
      "DownloadLogFile": "Download log file",
      "LogFileDownloadFailed": "Log file could not be loaded",
      "LogFileOffline": "The communication service is not connected.",
      "LogFileVersionTooOld": "This communication service's version does not support the log file download yet.",
      "LogFileTimeout": "The communication service did not respond in time.",
      "LogFileNotFound": "No current log file was found on the communication service.",
      "LogFileTooLarge": "The log file is too large to download."
    },
    "StationData": {
      "Title": "Location data",
      "Sections": {
        "Address": "Address data",
        "Contact": "Contact data",
        "Other": "Other data"
      },
      "CompanyName": "Location name",
      "Address": "Street",
      "Zip": "ZIP",
      "City": "City",
      "Phone": "Phone number",
      "Email": "Email",
      "Website": "Website",
      "TaxNumber": "Tax number",
      "VatId": "VAT ID",
      "IBAN": "IBAN",
      "BIC": "BIC",
      "CompanyFooterText": "Receipt footer text",
      "ErrorLoading": "Failed to load location data",
      "ErrorChanging": "Failed to save location data",
      "SuccessChanging": {
        "Title": "Location data saved",
        "Description": "Location data was saved successfully."
      }
    },
    "Courses": {
      "Title": "Courses",
      "Course": "Course",
      "Code": "Code",
      "Name": "Name",
      "AutoRecallAfter": "Automatically recall after",
      "AutoRecallImmediate": "Immediately",
      "ChangeSortOrderError": "Could not change course"
    },
    "Customers": {
      "Title": "Customers",
      "SearchPlaceholder": "Search...",
      "Customer": "Customer",
      "Number": "Customer No.",
      "Salutation": "Salutation",
      "Salutations": {
        "Mr": "Mr",
        "Mrs": "Mrs",
        "Company": "Company",
        "Family": "Family",
        "Club": "Club"
      },
      "Name": "Name",
      "Addition": "Addition",
      "Phone": "Phone",
      "Mobile": "Mobile",
      "Remark": "Remark",
      "InternalNote": "Internal note",
      "Email": "Email",
      "Street": "Street",
      "Zip": "Zip",
      "City": "City",
      "Country": "Country",
      "ActiveInactive": "Active/Inactive",
      "ToggleIsActiveError": "Could not change customer",
      "ImportExport": "Import/Export",
      "Import": "Import",
      "Export": "Export",
      "ImportSuccess": {
        "Title": "Import successful",
        "Description": "{created} customers created, {updated} updated."
      },
      "ImportPartial": {
        "Title": "Import partially successful",
        "Description": "{created} customers created, {updated} updated, {failed} failed:"
      },
      "ImportError": {
        "Title": "Import failed",
        "Description": "Customers could not be imported."
      },
      "ExportError": "Customers could not be exported"
    },
    "Departments": {
      "Title": "Departments",
      "Department": "Department",
      "Name": "Name",
      "Discount": "Discount",
      "DefaultPriceList": "Default price list",
      "ActiveInactive": "Active/Inactive",
      "ToggleIsActiveError": "Could not change department",
      "ChangeSortOrderError": "Could not change department",
      "ImportExport": "Import/Export",
      "Import": "Import",
      "Export": "Export",
      "ImportSuccess": {
        "Title": "Import successful",
        "Description": "{created} departments created, {updated} updated."
      },
      "ImportPartial": {
        "Title": "Import partially successful",
        "Description": "{created} departments created, {updated} updated, {failed} failed:"
      },
      "ImportError": {
        "Title": "Import failed",
        "Description": "Departments could not be imported."
      },
      "ExportError": "Departments could not be exported"
    },
    "Efforts": {
      "Title": "Efforts",
      "Effort": "Effort",
      "Department": "Department",
      "Type": "Type",
      "Types": {
        "1": "Own consumption",
        "2": "Invitation",
        "3": "Staff",
        "4": "Shrinkage",
        "5": "Advertising",
        "6": "Test"
      },
      "Number": "Number",
      "Name": "Name",
      "DefaultPriceList": "Default price list",
      "AlternativeTax": "Alternative tax",
      "PriceMode": "Price",
      "ActiveInactive": "Active/Inactive",
      "ToggleIsActiveError": "Could not change effort",
      "ImportExport": "Import/Export",
      "Import": "Import",
      "Export": "Export",
      "ImportSuccess": {
        "Title": "Import successful",
        "Description": "{created} efforts created, {updated} updated."
      },
      "ImportPartial": {
        "Title": "Import partially successful",
        "Description": "{created} efforts created, {updated} updated, {failed} failed:"
      },
      "ImportError": {
        "Title": "Import failed",
        "Description": "Efforts could not be imported."
      },
      "ExportError": "Efforts could not be exported"
    },
    "InvoiceTexts": {
      "Title": "Invoice texts",
      "Type": "Type",
      "Types": {
        "Invoicing": {
          "HeaderText": "Header text",
          "FooterText": "Footer text"
        }
      },
      "Text": "Text"
    },
    "Macros": {
      "Title": "Macros",
      "Macro": "Macro",
      "Name": "Name",
      "Code": "Code",
      "Prefix": "Text before",
      "Suffix": "Text after",
      "PriceType": "Price type",
      "PriceTypes": {
        "0": "Amount",
        "1": "Addition"
      },
      "Price": "Price",
      "Discount": "Discount",
      "Action": "Action",
      "AlternativeTax": "Alternative tax",
      "Preview": "Preview",
      "ActiveInactive": "Active/Inactive",
      "ToggleIsActiveError": "Could not change macro",
      "ChangeSortOrderError": "Could not change macro"
    },
    "Promotions": {
      "Title": "Promotions",
      "Promotion": "Promotion",
      "ShowExpired": "Show expired promotions",
      "ShowInactive": "Show inactive promotions",
      "ToggleIsActiveError": "Could not change promotion",
      "Name": "Name",
      "Date": "Date",
      "Time": "Time",
      "AllDay": "All day",
      "Action": "Action",
      "Priority": "Priority",
      "Discount": "Discount",
      "PriceChange": "Price change"
    },
    "MailAccounts": {
      "Title": "Mail accounts",
      "MailAccount": "Mail account",
      "Name": "Name",
      "Mail": "Mail",
      "Status": "Status",
      "RequiresReauthHint": "Access expired — please re-authorize.",
      "Signature": "Signature",
      "Templates": {
        "Title": "Mail templates",
        "Template": "Template",
        "Subject": "Subject",
        "MailAccount": "Mail account",
        "Recipients": "Recipients"
      }
    },
    "NumberRanges": {
      "Title": "Number ranges",
      "NumberRange": "Number range",
      "Name": "Name",
      "Type": "Type",
      "Types": {
        "0": "Invoice",
        "3": "Order receipt",
        "4": "Customer No.",
        "5": "Booking sequenz",
        "6": "PMS transfer",
        "999999": "Other"
      },
      "Prefix": "Text before",
      "Suffix": "Text after",
      "Length": "Length",
      "StartNumber": "Start number",
      "CurrentNumber": "Current number",
      "Preview": "Preview",
      "StartDate": "Start date",
      "EndDate": "End date",
      "ActiveInactive": "Active/Inactive",
      "ToggleIsActiveError": "Could not change number range"
    },
    "PaymentMethods": {
      "Title": "Payment methods",
      "PaymentMethod": "Payment method",
      "Type": "Type",
      "Types": {
        "0": "Cash",
        "1": "Card payment",
        "2": "Bank transfer",
        "3": "Effort",
        "4": "PMS transfer",
        "9999": "Other"
      },
      "Name": "Name",
      "PaymentTarget": "Payment target",
      "PrintCount": "Print count",
      "ActiveInactive": "Active/Inactive",
      "ToggleIsActiveError": "Could not change payment method",
      "ChangeSortOrderError": "Could not change payment method"
    },
    "Printers": {
      "Title": "Printers",
      "Printer": "Printer",
      "CommunicationService": "Communication service",
      "Redirections": "Redirections",
      "PrinterName": "Printer name",
      "Name": "Name",
      "Reports": "Reports",
      "Type": "Format",
      "Types": {
        "0": "80mm",
        "1": "A4",
        "2": "76mm"
      },
      "ChangeSortOrderError": "Could not change printer"
    },
    "RKSV": {
      "Title": "RKSV 2017",
      "RegisteredOn": "RKSV 2017 has been registered on {0} at {1}",
      "Deactivate": "Deactivate",
      "ErrorLoadingRKSV": "Could not load RKSV 2017",
      "NotConfigured": {
        "Title": "RKSV 2017 (signing) has to be set up.",
        "Description": "Enter your FinanzOnline data from the cash register web service user.",
        "Setup": "Set up",
        "DeleteLiveData": "Delete live data"
      },
      "DEP7": {
        "Title": "Data acquisition protocol DEP7",
        "Export": "Export",
        "ErrorExporting": "Could not export Data acquisition protocol DEP7",
        "SystemDocumentation": "System documentation § 131 BAO"
      },
      "NullReport": {
        "Title": "Null report",
        "ReportDesigner": "Report designer",
        "Preview": "Preview",
        "Print": "Print"
      }
    },
    "TSE": {
      "Title": "TSS",
      "RegisteredOn": "TSS has been registered on {0} at {1}",
      "Deactivate": "Deactivate",
      "ErrorLoadingTSE": "Could not load TSS",
      "SuccessSettingUp": {
        "Title": "Set up TSS",
        "Description": "TSS has been set up successfully!"
      },
      "ErrorSettingUp": "Could not set up TSS",
      "NotConfigured": {
        "Title": "TSS (signing) has to be set up.",
        "Description": "Enter your data for the technical security system.",
        "Setup": "Set up",
        "DeleteLiveData": "Delete live data"
      },
      "DSFinVK": {
        "Title": "Digital Interface of the Tax Administration for POS systems DSFinV-K",
        "Export": "Export",
        "ErrorExporting": "Could not export DSFinV-K"
      },
      "ProceduralDocumentation": {
        "Title": "Procedural documentation",
        "KassenSichV": "Procedural documentation KassenSichV",
        "GoBD": "Procedural documentation GoBD"
      },
      "ConformityConfirmation": "GoBD"
    },
    "Tables": {
      "Title": "Tables",
      "Table": "Table",
      "Department": "Department",
      "Number": "Number",
      "Name": "Name",
      "ActiveInactive": "Active/Inactive",
      "ToggleIsActiveError": "Could not change department",
      "Discount": "Discount",
      "DefaultPriceList": "Default price list",
      "PriceMode": "Price",
      "ImportExport": "Import/Export",
      "Import": "Import",
      "Export": "Export",
      "ImportSuccess": {
        "Title": "Import successful",
        "Description": "{created} tables created, {updated} updated."
      },
      "ImportPartial": {
        "Title": "Import partially successful",
        "Description": "{created} tables created, {updated} updated, {failed} failed:"
      },
      "ImportError": {
        "Title": "Import failed",
        "Description": "Tables could not be imported."
      },
      "ExportError": "Tables could not be exported"
    },
    "Rooms": {
      "Title": "Rooms",
      "Room": "Room",
      "Department": "Department",
      "Number": "Number",
      "Name": "Name",
      "ActiveInactive": "Active/Inactive",
      "ToggleIsActiveError": "Could not change room",
      "Discount": "Discount",
      "DefaultPriceList": "Default price list",
      "PriceMode": "Price",
      "ImportExport": "Import/Export",
      "Import": "Import",
      "Export": "Export",
      "ImportSuccess": {
        "Title": "Import successful",
        "Description": "{created} rooms created, {updated} updated."
      },
      "ImportPartial": {
        "Title": "Import partially successful",
        "Description": "{created} rooms created, {updated} updated, {failed} failed:"
      },
      "ImportError": {
        "Title": "Import failed",
        "Description": "Rooms could not be imported."
      },
      "ExportError": "Rooms could not be exported"
    },
    "TablePriceModes": {
      "Standard": "Standard",
      "PurchasePrice": "Purchase price",
      "Zero": "€0",
      "GrossForNet": "Gross for net"
    },
    "TaxRates": {
      "Title": "Tax rates",
      "Name": "Name",
      "Rate": "Rate",
      "ValidFrom": "Valid from",
      "ValidTo": "Valid to"
    },
    "Users": {
      "Title": "Users",
      "User": "Users",
      "PermissionRoles": "Permission roles",
      "BookingLocks": "Booking locks",
      "Name": "Name",
      "Language": "Language",
      "RetailMode": "Retail mode",
      "IsRetailMode": "Retail mode",
      "Type": "Type",
      "Types": {
        "Gastronomy": "Gastronomy",
        "Retail": "Retail",
        "OrderManager": "Order manager"
      },
      "PermissionRole": "Permission role",
      "BookingLock": "Booking lock",
      "Team": "Team",
      "QuickLogin": "Quick login",
      "TimeTracking": "Time tracking",
      "ActiveInactive": "Active/Inactive",
      "ToggleIsRetailModeError": "Could not change user",
      "ToggleQuickLoginError": "Could not change user",
      "ToggleTimeTrackingError": "Could not change user",
      "ToggleIsActiveError": "Could not change user",
      "ChangeSortOrderError": "Could not change user"
    },
    "Workstations": {
      "Title": "Workstations",
      "Workstation": "Workstation",
      "Type": "Type",
      "Types": {
        "0": "Lipp POS",
        "1": "Lipp POS Mobile",
        "2": "Lipp POS Order Manager",
        "3": "Lipp POS Guest Ordering"
      },
      "MobileTag": "Mobile",
      "OrderManagerTag": "Order Manager",
      "DisconnectDevice": "Disconnect device",
      "OnlineOrderingTag": "Guest ordering",
      "Number": "Number",
      "Name": "Name",
      "Version": "Version",
      "License": "License",
      "LicensesInUseSingular": "{0} of {1} License in use",
      "LicensesInUsePlural": "{0} of {1} Licenses in use",
      "ManageLicenses": "Manage licenses",
      "ActivateLicense": "Activate license",
      "ActivatedLicense": {
        "Title": "Activated license",
        "Description": "The license for the workstation <b>{0}</b> has been activated successfully."
      },
      "ActivateLicenseError": "Could not activate license",
      "UnlinkLicense": "Unlink license",
      "ErrorLoadingLicenses": "Could not load licenses"
    },
    "SubsequentPositions": {
      "Title": "Subsequent positions",
      "Assignment": "Assignment",
      "Count": "Assigned"
    },
    "Dialogs": {
      "BookingLocks": {
        "Title": "Edit booking locks",
        "CommodityGroups": "Locked commodity groups",
        "Articles": "Locked articles",
        "TimePeriods": "Time periods",
        "TimePeriodsTitle": "Time period for the lock",
        "TimeFrom": "Time from",
        "TimeTo": "Time to",
        "AllDay": "All day",
        "Weekdays": "Weekdays",
        "AddTimePeriod": "Add time period",
        "Tabs": {
          "Scope": "Commodity groups & articles",
          "TimePeriod": "Time period"
        },
        "Changed": {
          "Title": "Booking lock changed",
          "Description": "The booking lock has been changed successfully.",
          "Error": "Booking lock could not be changed"
        },
        "ErrorLoading": "Booking locks could not be loaded"
      },
      "CreateBookingLock": {
        "Title": "Create booking lock",
        "Name": "Name",
        "Created": {
          "Title": "Booking lock created",
          "Description": "The booking lock <b>{0}</b> has been created successfully.",
          "Error": "Booking lock could not be created"
        }
      },
      "DeleteBookingLock": {
        "Title": "Delete booking lock",
        "Description": "Are you sure you want to delete the booking lock <b>{0}</b>?",
        "Deleted": {
          "Title": "Booking lock deleted",
          "Description": "The booking lock <b>{0}</b> has been deleted successfully.",
          "Error": "Booking lock could not be deleted"
        }
      },
      "CopyDispensingSystemArticles": {
        "Title": "Transfer mapping",
        "Description": "The article mapping of <b>{0}</b> is transferred with dispenser article no., debit and credit to the selected dispensing systems. If a dispensing system already has the same article, it is overwritten; its other mappings remain.",
        "Targets": "Dispensing systems",
        "Copy": "Transfer",
        "Success": {
          "Title": "Mapping transferred",
          "Description": "{created} created, {updated} overwritten, {unchanged} unchanged."
        },
        "Error": "Mapping could not be transferred"
      },
      "DeleteDispensingSystem": {
        "Title": "Delete dispensing system",
        "Description": "Really delete dispensing system <b>{0}</b>? All article mappings and key assignments will be lost.",
        "Error": "Could not delete dispensing system"
      },
      "DispensingSystemAssignment": {
        "Title": "Dispensing system assignment",
        "Workstations": "Workstations",
        "Departments": "Departments",
        "Tables": "Tables",
        "SelectDepartmentHint": "Select a department on the left to see its tables.",
        "Changed": {
          "Title": "Assignment saved",
          "Description": "Assignment for \"{0}\" has been updated.",
          "Error": "Assignment could not be saved"
        }
      },
      "DispensingSystemKeyAssignment": {
        "Title": "Key assignment",
        "Empty": "No active users available.",
        "SearchTablePlaceholder": "Search table...",
        "Columns": {
          "Name": "Name",
          "DefaultTable": "Default table",
          "DefaultTableHint": "Default table for dispensings of this user (used when the schank reports an incoming dispensing without a table number).",
          "SchankKeyNumber": "Schank user number",
          "SchankKeyNumberHint": "Schank user number (1-999). Leave empty to fall back to the user's list order.",
          "DoNotBook": "Do not book",
          "DoNotBookHint": "When active, this user is excluded from this schank in both directions: no credit is sent, and no incoming dispensing is auto-booked as a POS booking."
        },
        "Changed": {
          "Title": "Key assignment saved",
          "Description": "Key assignment for \"{0}\" was updated.",
          "Error": "Could not save key assignment"
        }
      },
      "DispensingSystem": {
        "Create": "Create dispensing system",
        "Edit": "Edit dispensing system",
        "Name": "Name",
        "IPAddress": "IP address",
        "Port": "Port",
        "CommunicationService": "Communication server",
        "CreditDebitSettings": "Credit & debit settings",
        "DefaultUser": "Def. user",
        "DefaultUserHint": "User whose schank user number is used for credit (POS booking sent to the schank) when the booking user has none of their own. If the default user itself has no schank user number set, its list order is used as fallback. Additionally used as a fallback for debit when the schank reports an unknown user number.",
        "DefaultTable": "Def. table",
        "DefaultTableHint": "Table that incoming dispensing-system records are booked against when the schank reports no or an unknown table number.",
        "DefaultWorkstation": "Def. workstation",
        "DefaultWorkstationHint": "Workstation under which incoming dispensing-system bookings are recorded. Required for fiscal signing (RKSV/TSE).",
        "PrintDebitBookingReceipt": "Print order receipt for debit bookings",
        "PrintDebitBookingReceiptHint": "Prints an order receipt when a draw from the schank comes in as a booking (debit). When disabled no receipt is printed; the booking itself and the order-receipt record stay untouched. Enabled by default.",
        "DefaultPrinters": "Default printers",
        "DefaultPrintersHint": "Overrides the article and workstation printers for everything dispensed at this schank.",
        "DefaultOrderReceiptPrinter": "Order receipt",
        "DefaultInvoicePrinter": "Invoice",
        "IsActive": "Active",
        "Created": {
          "Title": "Dispensing system created",
          "Description": "The dispensing system \"{0}\" has been created successfully.",
          "Error": "Could not create dispensing system"
        },
        "Changed": {
          "Title": "Dispensing system saved",
          "Description": "The dispensing system \"{0}\" has been updated.",
          "Error": "Could not save dispensing system"
        }
      },
      "Workstation": {
        "Close": "Close",
        "SetupCodeValidity": "Code valid for another {0} min",
        "Create": "Create workstation",
        "Edit": "Edit workstation",
        "Type": "Type",
        "Number": "Number",
        "Name": "Name",
        "CommunicationService": "Communication service",
        "CreateNewCommunicationService": "Create new",
        "Printers": "Printers",
        "AllowedWorkstations": "Permitted workstations",
        "AllowedWorkstationsAll": "All",
        "InvoicePrinter": "Invoice printer",
        "TableTransferPrinter": "Table transfer printer",
        "OrderManagerConfirmationPrinter": "Print confirmation on",
        "ServiceCallPrinter": "Service call printer",
        "OnlineOrderingUser": "Booking user",
        "OnlineOrderingPaymentMethod": "Payment method",
        "ArticleLayoutProfile": "Layout group",
        "DefaultLayoutSubGroup": "Default sub group",
        "DefaultDepartment": "Default department",
        "DefaultTable": "Default table",
        "StayOnTableAfterInvoice": "Stay on table after invoice",
        "OnlyEffectiveInGastronomyMode": "Only effective in gastronomy mode.",
        "PrintReceiptInRetailMode": "Print receipt in retail mode",
        "Created": {
          "Title": "Created workstation",
          "Description": "The workstation <b>{0}</b> has been created successfully.",
          "Error": "Could not create workstation"
        },
        "Changed": {
          "Title": "Changed workstation",
          "Description": "The workstation <b>{0}</b> has been changed successfully.",
          "Error": "Could not change workstation"
        },
        "ErrorLoadingCommunicationServices": "Could not load communication services",
        "ErrorLoadingPrinters": "Could not load printers",
        "ErrorLoadingArticleLayoutProfiles": "Could not load layout groups",
        "ErrorLoadingLayoutSubGroups": "Could not load sub groups",
        "ErrorLoadingOrderManagerSettings": "Could not load order manager settings",
        "ErrorSavingOrderManagerSettings": "Could not save order manager settings",
        "Tabs": {
          "General": "General",
          "BookingReceipt": "Order receipt",
          "TimeSettings": "Time settings",
          "Sounds": "Sounds",
          "ColorSettings": "Color settings",
          "Priority": "Priority",
          "QrCodes": "QR codes",
          "GlobalMessages": "Global messages"
        },
        "OrderManagerSettings": {
          "GlobalMessages": {
            "Message": "Message",
            "Suggestion1": "e.g. Kitchen briefly busy – food approx. 5 min later",
            "Suggestion2": "e.g. Food is delayed by approx. 10 min",
            "Suggestion3": "e.g. Chef briefly away – hot dishes approx. 15 min later",
            "Suggestion4": "e.g. Very busy – waiting time for food approx. 20 min",
            "Suggestion5": "e.g. Kitchen overloaded – cold dishes only for now (approx. 25 min)",
            "Duration": "Duration (minutes)"
          },
          "BookingReceipt": {
            "Title": "Order receipt designer",
            "ConfirmAllWithIntermediate": "Confirm all with intermediate query",
            "ShowConfirmedStrikethrough": "Show single confirmed positions as strikethrough",
            "ShowCoursesOnlyWhenRecalled": "Show positions on the receipt only when course is recalled",
            "ShowCoursesOnlyWhenRecalledInfo": "Cannot be active at the same time as “Show the time since the previous recalled course was delivered on the following course” (Time settings) — enabling this automatically disables that setting.",
            "CollapseNotRecalledCourses": "Automatically collapse courses that have not been recalled",
            "SummarizeReorders": "Combine reorders for the table",
            "SummarizeReordersInfo": "Combines open receipts of the same table or invoice carrier into a single card in the order manager. The receipts and bookings themselves remain unchanged.",
            "ShowPrices": "Show prices",
            "ShowPricesInfo": "Shows the gross amount of each line (quantity × price) on the right of the receipt line, as on the printed order receipt. Side dishes without a surcharge and comments have no price.",
            "SortByCommodityGroup": "Sort receipt items by commodity group",
            "SortByCommodityGroupInfo": "Sorts the items on the order receipt by commodity group instead of the order in which they were booked, within each course and among the items without a course (same order as \"Commodity groups\" in the order manager sidebar). Side dishes and comments stay with their item, printed receipts remain unchanged.",
            "DisplaySize": "Display size on order receipt",
            "DisplaySizeOptions": {
              "Small": "Small",
              "Medium": "Medium",
              "Large": "Large",
              "Ultra": "Ultra"
            },
            "HeaderSlots": {
              "DepartmentTable": "Department, table",
              "User": "User",
              "BonNumber": "Receipt no.",
              "Pages": "Page count",
              "Time": "Time",
              "Order": "Order",
              "BonColor": "Receipt color",
              "None": "No display"
            },
            "Preview": {
              "Designation": "Description",
              "All": "All"
            }
          },
          "TimeSettings": {
            "WarningColor": "Warning color of time from",
            "ShowLongestArticleCountdown": "Show the longest-producing article of a course/receipt as a countdown on the order receipt header",
            "ShowLongestArticleCountdownInfo": "This setting replaces the time on the order receipt",
            "ShowPreviousCourseDeliveredTimer": "Show the time since the previous recalled course was delivered on the following course",
            "ShowPreviousCourseDeliveredTimerInfo": "Cannot be active at the same time as “Show positions on the receipt only when course is recalled” (Order receipt) — enabling this automatically disables that setting."
          },
          "ColorSettings": {
            "CommodityGroups": "Commodity groups",
            "Name": "Commodity group",
            "Color": "Color",
            "ResetColor": "Reset to default color",
            "Number": "Number",
            "WorkstationName": "Name",
            "ApplyToAllWorkstations": "Apply to all order manager workstations",
            "FollowUpArticles": "Follow-up items",
            "FollowUpArticleTypes": {
              "3": "Side dish",
              "5": "Comment",
              "8": "Article package details"
            }
          },
          "Priority": {
            "Title": "Move workstations to front"
          },
          "Sounds": {
            "NewOrder": "Incoming new order receipt",
            "CourseRecall": "Course was recalled",
            "Tone": "Tone",
            "Groups": {
              "Desktop": "Desktop",
              "Mobile": "Android/iOS"
            },
            "Options": {
              "None": "No sound",
              "WindowsNotify": "Standard notification",
              "WindowsNotifyCalendar": "Calendar",
              "WindowsNotifyEmail": "Email",
              "WindowsNotifyMessaging": "Message",
              "WindowsNotifySystemGeneric": "System (generic)",
              "WindowsMessageNudge": "Nudge",
              "WindowsInformationBar": "Notice",
              "WindowsBalloon": "Balloon",
              "WindowsDing": "Windows Ding",
              "WindowsDefault": "Windows Default",
              "WindowsForeground": "Foreground",
              "WindowsBackground": "Background",
              "Chimes": "Chimes",
              "Chord": "Chord",
              "Ding": "Ding",
              "Notify": "Notification",
              "Tada": "Tada",
              "NewOrderBell": "Bell",
              "BrightPing": "Bright ping",
              "MarimbaHint": "Marimba (hint)",
              "DoubleBeepAlarm": "Double-beep (alarm)",
              "SoftPlop": "Soft plop"
            }
          }
        }
      },
      "User": {
        "Create": "Create user",
        "Edit": "Change user",
        "Name": "Name",
        "Language": "Language",
        "Theme": "Theme",
        "ThemeLight": "Light",
        "ThemeDark": "Dark",
        "PIN": "Code",
        "RetailMode": "Retail mode",
        "Type": "Type",
        "QuickLogin": "Quick login",
        "TimeTracking": "Time tracking",
        "ArticleLayoutProfile": "Layout group",
        "PermissionRole": "Permission role",
        "BookingLock": "Booking lock",
        "Team": "Team",
        "TeamTooltip": "If the user works in a team, all multi-user permissions within the team are ignored.",
        "Created": {
          "Title": "Created user",
          "Description": "The user <b>{0}</b> has been created successfully.",
          "Error": "Could not create user"
        },
        "Changed": {
          "Title": "Changed user",
          "Description": "The user <b>{0}</b> has been changed successfully.",
          "Error": "Could not change user"
        },
        "ErrorLoadingArticleLayoutProfiles": "Could not load layout groups",
        "ErrorLoadingPermissionRoles": "Could not load permission roles",
        "ErrorLoadingBookingLocks": "Could not load booking locks",
        "ErrorLoadingTeams": "Could not load teams",
        "TakeFromWorkstation": "Take from workstation"
      },
      "PermissionRoles": {
        "Title": "Change permission roles",
        "Overview": "Overview",
        "Access": "Access",
        "Duplicate": "Duplicate",
        "Duplicated": {
          "Title": "Permission role duplicated",
          "Description": "The permission role <b>{0}</b> was duplicated successfully.",
          "Error": "Permissions could not be copied"
        },
        "Permissions": {
          "General": {
            "Title": "General",
            "EditTableLayout": "Department & Table designer",
            "ChangeTableDesignation": "Change table designation",
            "ShowUserAccounting": "User accounting",
            "EditArticleLayout": "Article designer",
            "SendMails": "Send mails",
            "ShowCustomers": "Customers",
            "ShowPeriodAccounting": "PeriodAccounting",
            "ShowInvoiceCenter": "Invoice center",
            "ShowReceiptCenter": "Receipt center",
            "ShowDailyAccounting": "Daily accounting",
            "ShowDailySales": "Daily sales",
            "ResetDailyClosing": "Reset day closing",
            "ShowInventoryManagement": "Inventory management",
            "ShowDeliveryNotes": "Delivery notes",
            "ShowPreOrders": "Pre-orders",
            "EditGlobalDispensingExceptions": "Change global dispensing exceptions",
            "UserAccountingMultiUsers": "User accounting - Multiuser",
            "UserAccountingMultiUsersTooltip": "User A may open the user accounting of User B.",
            "OpenTablesMultiUsers": "Open Tables - Multiuser",
            "OpenTablesMultiUsersTooltip": "User A may see the open tables of User B.",
            "InvoiceCenterMultiUsers": "Invoice center - Multiuser",
            "InvoiceCenterMultiUsersTooltip": "User A may see the invoices of User B.",
            "Management": "Management"
          },
          "BookingProcess": {
            "Title": "Booking process",
            "ChangeBookingText": "Change booking text",
            "BookingMultiUsers": "Booking - Multiuser",
            "BookingMultiUsersTooltip": "User A may make an additional booking even though User B has already made a booking.",
            "BookNegativeQuantities": "Booking - negative quantity",
            "BookNegativePrice": "Booking - negative price",
            "BookEfforts": "Book to efforts",
            "ParkBookings": "Park bookings",
            "ApplyDiscount": "Discount",
            "ExecuteMacros": "Execute macros",
            "ChangePriceBeforeReceipt": "Change price before receipt",
            "ChangePriceAfterReceipt": "Change price after receipt",
            "ChangeInvoiceCarriers": "Create/Edit invoice carriers",
            "CancelBookingsAfterReceipt": "Cancel bookings after receipt",
            "CancelUnsentWithoutLog": "Instant cancellation without log",
            "CancelUnsentWithoutLogTooltip": "Removing bookings that have not been sent yet (instant cancellation) is not recorded in the change log for this role.",
            "CancelBookingsMultiUsers": "Cancel bookings - Multiuser",
            "CancelBookingsMultiUsersTooltip": "User A may cancel the bookings of User B.",
            "TransferTables": "Table transfer",
            "TableTransferMultiUser": "Table transfer - Multiuser",
            "TableTransferMultiUserTooltip": "User A may transfer the bookings of User B.",
            "TableTransferToEfforts": "Table transfer to efforts",
            "CreatePreOrder": "Create pre-order",
            "RecallPreOrder": "Recall pre-order"
          },
          "Accounting": {
            "Title": "Accounting",
            "CreateInvoice": "Invoice",
            "CreateProformaInvoice": "Proforma invoice",
            "InvoiceMultiUsers": "Invoice - Multiuser",
            "InvoiceMultiUsersTooltip": "User A may bill the bookings of User B.",
            "ReprintInvoice": "Reprint invoice",
            "CorrectInvoice": "Correct invoice",
            "RetrieveInvoice": "Retrieve invoice positions",
            "CreateEffortInvoice": "Invoice - Efforts",
            "ApplyDiscount": "Discount",
            "CancelInvoice": "Cancel invoice",
            "CancelInvoiceMultiUsers": "Cancel invoice - Multiuser",
            "CancelInvoiceMultiUsersTooltip": "User A may cancel the invoice of User B."
          }
        },
        "Changed": {
          "Title": "Changed permission roles",
          "Description": "The permission roles have been changed successfully.",
          "Error": "Could not change permission roles"
        },
        "Departments": "Departments",
        "Tables": "Tables",
        "Workstations": "Workstations",
        "PaymentMethods": "Payment methods",
        "PaymentMethodsTooltip": "Payment methods allowed at the POS. Newly created payment methods are allowed automatically.",
        "PaymentMethodsChanged": {
          "Error": "Could not save the payment methods of permission role {0}"
        },
        "ErrorLoadingPermissionRoles": "Could not load permission roles",
        "ErrorLoadingPermissions": "Could not load permissions",
        "ErrorLoadingDepartments": "Could not load departments",
        "ErrorLoadingTables": "Could not load tables",
        "ErrorLoadingWorkstations": "Could not load workstations",
        "ErrorLoadingPaymentMethods": "Could not load payment methods"
      },
      "CreatePermissionRole": {
        "Title": "Create permission role",
        "DuplicateTitle": "Duplicate permission role",
        "Duplicate": "Duplicate",
        "CopySuffix": "(Copy)",
        "Name": "Name",
        "Created": {
          "Title": "Created permission role",
          "Description": "The permission role <b>{0}</b> has been created successfully.",
          "Error": "Could not create permission role"
        }
      },
      "DeletePermissionRole": {
        "Title": "Delete permission role",
        "Description": "Do you really want to delete the permission role <b>{0}</b>?",
        "Deleted": {
          "Title": "Deleted permission role",
          "Description": "The permission role <b>{0}</b> has been deleted successfully.",
          "Error": "Could not delete permission role"
        }
      },
      "CreateLayoutProfile": {
        "Title": "Create layout profile",
        "Name": "Name",
        "Created": {
          "Title": "Created layout profile",
          "Description": "The layout profile <b>{0}</b> has been created successfully.",
          "Error": "Could not create layout profile"
        }
      },
      "DeleteLayoutProfile": {
        "Title": "Delete layout profile",
        "Description": "Do you really want to delete the layout profile <b>{0}</b>?",
        "Deleted": {
          "Title": "Deleted layout profile",
          "Description": "The layout profile <b>{0}</b> has been deleted successfully.",
          "Error": "Could not delete layout profile"
        }
      },
      "DeactivateUser": {
        "Title": "Deactivate user",
        "Description": "Do you really want to deactivate the user <b>{0}</b>?",
        "Error": "Could not deactivate user"
      },
      "MailTemplate": {
        "Create": "Create template",
        "Edit": "Edit template",
        "MailAccount": "Mail account",
        "Recipients": "Recipients",
        "Cc": "CC",
        "Bcc": "BCC",
        "Subject": "Subject",
        "Text": "Text",
        "Created": {
          "Title": "Template created",
          "Description": "The template <b>{0}</b> was created successfully.",
          "Error": "Could not create template"
        },
        "Changed": {
          "Title": "Template changed",
          "Description": "The template <b>{0}</b> was changed successfully.",
          "Error": "Could not change template"
        }
      },
      "MailSignature": {
        "Title": "Edit signature",
        "MailAccount": "Mail account",
        "Signature": "Signature",
        "Hint": "The signature is appended to every e-mail sent via this account.",
        "LoadError": "Could not load signature",
        "ImageError": "Could not insert image",
        "ImageNotEmbedded": {
          "Title": "Image not taken over",
          "Description": "Please insert images via the image button. Images pasted from other programs are not sent."
        },
        "TooLarge": {
          "Title": "Signature too large",
          "Description": "The signature may be at most 1 MB. Please use smaller or fewer images."
        },
        "Changed": {
          "Title": "Signature saved",
          "Description": "The signature of <b>{0}</b> was saved successfully.",
          "Error": "Could not save signature"
        }
      },
      "MailAccount": {
        "Create": "Create mail account",
        "Edit": "Edit mail account",
        "SenderName": "Sender name",
        "SenderMail": "Sender mail",
        "Username": "Username",
        "Password": "Password",
        "Host": "Outgoing mail server (SMTP)",
        "Port": "Port",
        "Authenticate": "Authenticate",
        "CouldNotValidate": "Could not validate mail",
        "NotValid": {
          "Title": "Mail authentication failed",
          "Description": "Please check that the fields you have already entered are correct."
        },
        "Created": {
          "Title": "Create mail account",
          "Description": "The mail account <b>{0}</b> has been created successfully.",
          "Error": "The mail account could not be created"
        },
        "Changed": {
          "Title": "Changed mail account",
          "Description": "The mail account <b>{0}</b> has been changed successfully.",
          "Error": "The mail account could not be changed"
        },
        "SendTestMail": "Send test mail",
        "SentTestMail": {
          "Title": "Sent test mail",
          "Description": "The test mail has been sent to <b>{0}</b>.",
          "Error": "Could not send test mail"
        },
        "Provider": {
          "Microsoft": "Microsoft 365 (Outlook, Hotmail)",
          "Google": "Google (Gmail)",
          "Apple": "iCloud",
          "OtherAccount": "Other account (POP, IMAP)"
        },
        "iCloud": {
          "Title": "Set up iCloud Mail",
          "Step1": "Sign in to <b>appleid.apple.com</b> and create a new app-specific password under <b>Sign-In and Security</b> → <b>App-Specific Passwords</b> (e.g. name it <b>LIPP POS</b>).",
          "Step2": "Apple shows a <b>16-character password</b> once — <b>copy it</b>.",
          "Step3": "Enter sender name, iCloud email address and the copied app password in the form below.",
          "OpenAppleId": "Open appleid.apple.com",
          "AppPassword": "App-specific password"
        },
        "OAuth": {
          "Errors": {
            "ConfigLoadFailed": "Could not load the OAuth configuration from the server.",
            "ClientIdMissing": "No OAuth client ID is configured on the server for provider \"{0}\".",
            "StateMismatch": "The OAuth security check failed (state mismatch). Please try again.",
            "PopupBlocked": "The popup blocker prevented the OAuth window. Please allow popups for this page and try again.",
            "ProviderError": "The provider returned an error: {0}",
            "NoCode": "The OAuth response did not contain a code. Please try again.",
            "WindowClosed": "The OAuth window was closed before sign-in completed.",
            "Timeout": "OAuth sign-in timed out (5 minutes)."
          },
          "Callback": {
            "Success": "OAuth sign-in successful. You can close this window now.",
            "Failed": "OAuth sign-in failed: {0}. You can close this window now.",
            "NoOpener": "This window was not opened as part of an OAuth flow. Please close it.",
            "Error": "Error in the OAuth callback: {0}"
          }
        }
      },
      "Department": {
        "Create": "Create department",
        "Edit": "Edit department",
        "Name": "Name",
        "ShortNameMobile": "Mobile abbreviation",
        "Discount": "Discount %",
        "DefaultPriceList": "Default price list",
        "Image": "Image",
        "IsActive": "Active",
        "Created": {
          "Title": "Created department",
          "Description": "The department <b>{0}</b> has been created successfully.",
          "Error": "Could not create department"
        },
        "Changed": {
          "Title": "Changed department",
          "Description": "The department <b>{0}</b> has been changed successfully.",
          "Error": "Could not change department"
        }
      },
      "DeactivateDepartment": {
        "Title": "Deactivate department",
        "Description": "Do you really want to deactivate the department <b>{0}</b>?",
        "Error": "Could not deactivate department"
      },
      "InvoiceText": {
        "Edit": "Edit {0}",
        "Text": "Text",
        "Changed": {
          "Title": "Changed invoice text",
          "Description": "<b>{0}</b> has been changed successfully.",
          "Error": "Could not change invoice text"
        }
      },
      "CancellationReason": {
        "Create": "Create cancellation reason",
        "Edit": "Edit cancellation reason",
        "Text": "Text",
        "Created": {
          "Title": "Created cancellation reason",
          "Description": "The cancellation reason <b>{0}</b> has been created successfully.",
          "Error": "Could not create cancellation reason"
        },
        "Changed": {
          "Title": "Changed cancellation reason",
          "Description": "The cancellation reason <b>{0}</b> has been changed successfully.",
          "Error": "Could not change cancellation reason"
        }
      },
      "DeactivateCancellationReason": {
        "Title": "Deactivate cancellation reason",
        "Description": "Do you really want to deactivate the cancellation reason <b>{0}</b>?",
        "Error": "Could not deactivate cancellation reason"
      },
      "Course": {
        "Create": "Create course",
        "Edit": "Edit course",
        "Name": "Name",
        "Code": "Code",
        "BackgroundColor": "Background color",
        "ForegroundColor": "Text color",
        "AutoRecallAfter": "Automatically recall after",
        "AutoRecallHint": "Format hours:minutes (e.g. 00:05 = 5 minutes, 01:30 = 90 minutes). 00:00 = recall immediately after the previous course.",
        "ToggleIsActiveError": "Could not change course",
        "Created": {
          "Title": "Created course",
          "Description": "The course <b>{0}</b> has been created successfully.",
          "Error": "Could not create course"
        },
        "Changed": {
          "Title": "Changed course",
          "Description": "The course <b>{0}</b> has been changed successfully.",
          "Error": "Could not change course"
        }
      },
      "DeactivateCourse": {
        "Title": "Deactivate course",
        "Description": "Do you really want to deactivate the course <b>{0}</b>?",
        "Error": "Could not deactivate course"
      },
      "DeactivateSupplier": {
        "Title": "Deactivate supplier",
        "Description": "Do you really want to deactivate the supplier <b>{0}</b>?",
        "Error": "Could not deactivate supplier"
      },
      "Table": {
        "Create": "Create table",
        "Edit": "Edit table",
        "Type": "Type",
        "TypeStandard": "Standard",
        "TypeRequisition": "Requisition",
        "Department": "Department",
        "Number": "Number",
        "NumberFrom": "Number from",
        "NumberTo": "Number to",
        "CreateMultiple": "Create multiple",
        "NumberAlreadyTaken": "The table number <b>{0}</b> is already taken.",
        "NumberTooLarge": "The number must not be greater than <b>{0}</b>.",
        "NameTooLong": "The names would be too long (at most {0} characters).",
        "Preview": "{0} tables: {1}",
        "PreviewSingle": "1 table: {0}",
        "Name": "Name",
        "IsActive": "Active",
        "DefaultPriceList": "Default price list",
        "TakeFromDepartment": "Take from department",
        "InstantInvoice": "Instant invoice",
        "PriceMode": "Price",
        "ErrorLoadingDepartments": "Could not load departments",
        "Created": {
          "Title": "Created table",
          "Description": "The table <b>{0}</b> has been created successfully.",
          "Error": "Could not create table"
        },
        "CreatedMultiple": {
          "Title": "Tables created",
          "Description": "<b>{0}</b> tables have been created successfully.",
          "Error": "Could not create tables"
        },
        "Changed": {
          "Title": "Changed table",
          "Description": "The table <b>{0}</b> has been changed successfully.",
          "Error": "Could not change table"
        }
      },
      "DeactivateTable": {
        "Title": "Deactivate table",
        "Description": "Do you really want to deactivate the table <b>{0}</b>?",
        "Error": "Could not deactivate table"
      },
      "Room": {
        "Create": "Create room",
        "Edit": "Edit room",
        "Department": "Department",
        "Number": "Number",
        "NumberFrom": "Number from",
        "NumberTo": "Number to",
        "CreateMultiple": "Create multiple",
        "NumberAlreadyTaken": "The number <b>{0}</b> is already taken.",
        "NumberTooLarge": "The number must not be greater than <b>{0}</b>.",
        "NameTooLong": "The names would be too long (at most {0} characters).",
        "Preview": "{0} rooms: {1}",
        "PreviewSingle": "1 room: {0}",
        "Name": "Name",
        "IsActive": "Active",
        "DefaultPriceList": "Default price list",
        "TakeFromDepartment": "Take from department",
        "PriceMode": "Price",
        "ErrorLoadingDepartments": "Could not load departments",
        "Created": {
          "Title": "Created room",
          "Description": "The room <b>{0}</b> has been created successfully.",
          "Error": "Could not create room"
        },
        "CreatedMultiple": {
          "Title": "Rooms created",
          "Description": "<b>{0}</b> rooms have been created successfully.",
          "Error": "Could not create rooms"
        },
        "Changed": {
          "Title": "Changed room",
          "Description": "The room <b>{0}</b> has been changed successfully.",
          "Error": "Could not change room"
        }
      },
      "DeactivateRoom": {
        "Title": "Deactivate room",
        "Description": "Do you really want to deactivate the room <b>{0}</b>?",
        "Error": "Could not deactivate room"
      },
      "Effort": {
        "Create": "Create effort",
        "Edit": "Edit effort",
        "Department": "Department",
        "Type": "Type",
        "Number": "Number",
        "Name": "Name",
        "IsActive": "Active",
        "DefaultPriceList": "Default price list",
        "AlternativeTax": "Altern. Tax",
        "PriceMode": "Price",
        "ErrorLoadingTaxes": "Could not load taxes",
        "Created": {
          "Title": "Created effort",
          "Description": "The effort <b>{0}</b> has been created successfully.",
          "Error": "Could not create effort"
        },
        "Changed": {
          "Title": "Changed effort",
          "Description": "The effort <b>{0}</b> has been changed successfully.",
          "Error": "Could not change effort"
        }
      },
      "DeactivateEffort": {
        "Title": "Deactivate effort",
        "Description": "Do you really want to deactivate the effort <b>{0}</b>?",
        "Error": "Could not deactivate effort"
      },
      "PaymentMethod": {
        "Create": "Create payment method",
        "Edit": "Edit payment method",
        "Type": "Type",
        "Name": "Name",
        "PaymentTarget": "Payment target",
        "PrintCount": "Print count",
        "AppearsInOpenItemsManagement": "Show in open-items management",
        "Created": {
          "Title": "Created payment method",
          "Description": "The payment method <b>{0}</b> has been created successfully.",
          "Error": "Could not create payment method"
        },
        "Changed": {
          "Title": "Changed payment method",
          "Description": "The payment method <b>{0}</b> has been changed successfully.",
          "Error": "Could not change payment method"
        }
      },
      "DeactivatePaymentMethod": {
        "Title": "Deactivate payment method",
        "Description": "Do you really want to deactivate the payment method <b>{0}</b>?",
        "Error": "Could not deactivate payment method"
      },
      "RevenueGroup": {
        "Create": "Create revenue group",
        "Edit": "Edit revenue group",
        "Name": "Name",
        "Created": {
          "Title": "Created revenue group",
          "Description": "The revenue group <b>{0}</b> has been created successfully.",
          "Error": "Could not create revenue group"
        },
        "Changed": {
          "Title": "Changed revenue group",
          "Description": "The revenue group <b>{0}</b> has been changed successfully.",
          "Error": "Could not change revenue group"
        }
      },
      "Team": {
        "Create": "Create team",
        "Edit": "Edit team",
        "Name": "Name",
        "Created": {
          "Title": "Created team",
          "Description": "The team <b>{0}</b> has been created successfully.",
          "Error": "Could not create team"
        },
        "Changed": {
          "Title": "Changed team",
          "Description": "The team <b>{0}</b> has been changed successfully.",
          "Error": "Could not change team"
        }
      },
      "DeleteUserMessage": {
        "Title": "Delete message",
        "Description": "Do you really want to delete this message? Messages that have already been sent are kept.",
        "Deleted": {
          "Title": "Message deleted",
          "Description": "The message was deleted successfully.",
          "Error": "Message could not be deleted"
        }
      },
      "DeleteTeam": {
        "Title": "Delete team",
        "Description": "Do you really want to delete the team <b>{0}</b>?",
        "Deleted": {
          "Title": "Deleted team",
          "Description": "The team <b>{0}</b> has been deleted successfully.",
          "Error": "Could not delete team"
        }
      },
      "Macro": {
        "Create": "Create macro",
        "Edit": "Edit macro",
        "Name": "Name",
        "Code": "Code",
        "Prefix": "Text before",
        "Suffix": "Text after",
        "PriceType": "Price type",
        "Price": "Price",
        "Discount": "Discount %",
        "AlternativeTax": "Altern. Tax",
        "BackgroundColor": "Background color",
        "ForegroundColor": "Text color",
        "Preview": "Preview",
        "Created": {
          "Title": "Created macro",
          "Description": "The macro <b>{0}</b> has been created successfully.",
          "Error": "Could not create macro"
        },
        "Changed": {
          "Title": "Changed macro",
          "Description": "The macro <b>{0}</b> has been changed successfully.",
          "Error": "Could not change macro"
        },
        "ErrorLoadingTaxes": "Could not load taxes",
        "ErrorLoadingPriceLists": "Could not load price lists",
        "ErrorLoadingRevenueGroups": "Could not load revenue groups",
        "ErrorLoadingCommodityGroups": "Could not load commodity groups",
        "ErrorLoadingArticles": "Could not load articles",
        "General": "General",
        "ArticleScope": "Revenue, commodity groups & articles",
        "RevenueGroups": "Revenue groups",
        "CommodityGroups": "Commodity groups",
        "Articles": "Articles",
        "PriceMode": {
          "Pricelist": "Price list",
          "Discount": "Discount",
          "PriceOverride": "Price type",
          "Price": "Price"
        },
        "PriceTypes": {
          "Add": "Add",
          "Fixed": "Amount"
        }
      },
      "DeactivateMacro": {
        "Title": "Deactivate macro",
        "Description": "Do you really want to deactivate the macro <b>{0}</b>?",
        "Error": "Could not deactivate macro"
      },
      "NumberRange": {
        "Create": "Create number range",
        "Edit": "Edit number range",
        "Type": "Type",
        "Name": "Name",
        "Prefix": "Text before",
        "Suffix": "Text after",
        "Length": "Length",
        "StartNumber": "Start number",
        "Preview": "Preview",
        "StartDate": "Start date",
        "Created": {
          "Title": "Created number range",
          "Description": "The number range <b>{0}</b> has been created successfully.",
          "Error": "Could not create number range"
        },
        "Changed": {
          "Title": "Changed number range",
          "Description": "The number range <b>{0}</b> has been changed successfully.",
          "Error": "Could not change number range"
        }
      },
      "DeactivateNumberRange": {
        "Title": "Deactivate number range",
        "Description": "Do you really want to deactivate the number range <b>{0}</b>?",
        "Error": "Could not deactivate number range"
      },
      "CommodityGroup": {
        "Create": "Create commodity group",
        "Edit": "Edit commodity group",
        "RevenueGroup": "Revenue group",
        "Name": "Name",
        "Tax": "VAT",
        "Created": {
          "Title": "Created commodity group",
          "Description": "The commodity group <b>{0}</b> has been created successfully.",
          "Error": "Could not create commodity group"
        },
        "Changed": {
          "Title": "Changed commodity group",
          "Description": "The commodity group <b>{0}</b> has been changed successfully.",
          "Error": "Could not change commodity group"
        },
        "ErrorLoadingTaxes": "Could not load taxes",
        "ErrorLoadingRevenueGroups": "Could not load revenue groups"
      },
      "DeactivateCommodityGroup": {
        "Title": "Deactivate commodity group",
        "Description": "Do you really want to deactivate the commodity group <b>{0}</b>?",
        "Error": "Could not deactivate commodity group"
      },
      "DeactivateIntegration": {
        "Title": "Deactivate integration",
        "Description": "Do you really want to deactivate the integration <b>{0}</b>?"
      },
      "AidaXSetting": {
        "Title": "Change setting",
        "Changed": {
          "Title": "Changed setting",
          "Description": "The setting <b>{0}</b> has been changed successfully.",
          "Error": "Could not change setting"
        }
      },
      "EucasoftSetting": {
        "Title": "Change setting",
        "Changed": {
          "Title": "Changed setting",
          "Description": "The setting <b>{0}</b> has been changed successfully.",
          "Error": "Could not change setting"
        }
      },
      "SihotSetting": {
        "Title": "Change setting",
        "Changed": {
          "Title": "Changed setting",
          "Description": "The setting <b>{0}</b> has been changed successfully.",
          "Error": "Setting could not be changed"
        }
      },
      "SihotCategoryMapping": {
        "Title": "Assign commodity group",
        "Hint": "Valid values are whole numbers from 1 to 100.",
        "Changed": {
          "Title": "Assignment changed",
          "Description": "The assignment for <b>{0}</b> has been changed successfully.",
          "Error": "Assignment could not be changed"
        }
      },
      "SihotPaymentTypeMapping": {
        "Title": "Assign payment method",
        "Changed": {
          "Title": "Assignment changed",
          "Description": "The assignment for <b>{0}</b> has been changed successfully.",
          "Error": "Assignment could not be changed"
        }
      },
      "AsaAsciiSetting": {
        "Title": "Change setting",
        "Changed": {
          "Title": "Changed setting",
          "Description": "The setting <b>{0}</b> has been changed successfully.",
          "Error": "Could not change setting"
        }
      },
      "CashJournalEntry": {
        "Create": {
          "Revenue": {
            "Title": "Add revenue",
            "Success": {
              "Title": "Added revenue",
              "Description": "The revenue <b>{0}</b> ({1}) has been added successfully."
            },
            "Error": "Could not add revenue"
          },
          "Expense": {
            "Title": "Add expense",
            "Success": {
              "Title": "Added expense",
              "Description": "The expense <b>{0}</b> ({1}) has been added successfully."
            },
            "Error": "Could not add expense"
          }
        },
        "Edit": {
          "Revenue": {
            "Title": "Edit revenue",
            "Success": {
              "Title": "Changed revenue",
              "Description": "The revenue <b>{0}</b> ({1}) has been changed successfully."
            },
            "Error": "Could not change revenue"
          },
          "Expense": {
            "Title": "Edit expense",
            "Success": {
              "Title": "Changed expense",
              "Description": "The expense <b>{0}</b> ({1}) has been changed successfully."
            },
            "Error": "Could not change expense"
          }
        },
        "Date": "Date",
        "Description": "Description",
        "Templates": "Templates",
        "Amount": "Amount",
        "TaxRate": "Tax rate",
        "ExternalReceiptNumber": "External receipt number",
        "TaxAmount": "Tax amount",
        "CashBalance": "Cash balance preview",
        "ErrorLoadingTemplates": "Could not load templates"
      },
      "DeleteCashJournalEntry": {
        "Revenue": {
          "Title": "Delete revenue",
          "Description": "Do you really want to delete the revenue <b>{0}</b> ({1})?",
          "Error": "Could not delete the revenue"
        },
        "Expense": {
          "Title": "Delete expense",
          "Description": "Do you really want to delete the expense <b>{0}</b> ({1})?",
          "Error": "Could not delete the expense"
        }
      },
      "DeactivateCashJournalTemplate": {
        "Title": "Deactivate template",
        "Description": "Do you really want to deactivate the template <b>{0}</b>?",
        "Error": "Could not deactivate template"
      },
      "DeactivateVoucherType": {
        "Title": "Deactivate voucher type",
        "Description": "Do you really want to deactivate the voucher type <b>{0}</b>?",
        "Error": "Could not deactivate voucher type"
      },
      "MigrateVouchers": {
        "Title": "Migrate vouchers across enterprises",
        "Question": "Do you really want to migrate all vouchers of the <b>{0}</b> locations across enterprises?",
        "AddStation": "Add another location",
        "SearchPlaceholder": "Search enterprise",
        "TestPhaseWarning": "{0} is still in the test phase (without RKSV/TSE). Its test vouchers will be moved into the voucher group and can no longer be removed via \"Delete live data\" afterwards. Delete the live data and set up RKSV/TSE first, or migrate deliberately (e.g. for testing).",
        "Hint": "Afterwards the vouchers are valid at all selected locations. Issuing and redeeming requires an internet connection, and voucher types are only managed across enterprises. Run the daily closing at all POS systems first: otherwise invoices from before the migration cannot automatically restore their voucher redemptions when cancelled. Also make sure that all POS systems of the selected locations run version 1.37 or newer, including secondary servers in the network. An older POS does not know the voucher group and would redeem vouchers only locally.",
        "Migrating": "Migration in progress. This can take up to a minute.",
        "Migrate": "Migrate",
        "Error": "Migration failed",
        "State": {
          "Checking": "Checking",
          "Ready": "Ready",
          "Offline": "Offline",
          "Version": "Version {0}, at least {1} required",
          "Group": "Already in group {0}",
          "Error": "Could not be checked",
          "TestPhase": "Test phase"
        },
        "Result": {
          "Title": "The migration is complete.",
          "Migrated": "Migrated vouchers",
          "NextNumber": "Next voucher number",
          "Duplicates": "Numbers used more than once",
          "DuplicatesHint": "Identical numbers from different locations stay valid. At the POS they are told apart by the location.",
          "VoucherTypes": "Migrated voucher types",
          "Open": "Go to voucher management"
        }
      },
      "DeactivateTimeTrackingType": {
        "Title": "Deactivate time tracking type",
        "Description": "Do you really want to deactivate the time tracking type <b>{0}</b>?",
        "Error": "Could not deactivate time tracking type"
      },
      "CashJournalTemplate": {
        "Create": "Create template",
        "Edit": "Edit template",
        "Type": "Type",
        "Description": "Description",
        "Tax": "Tax",
        "Created": {
          "Success": {
            "Title": "Created template",
            "Description": "The template <b>{0}</b> has been created successfully."
          },
          "Error": "Could not create template"
        },
        "Changed": {
          "Success": {
            "Title": "Changed template",
            "Description": "The template <b>{0}</b> has been changed successfully."
          },
          "Error": "Could not change template"
        }
      },
      "TimeTrackingType": {
        "Create": "Create time tracking type",
        "Edit": "Edit time tracking type",
        "Name": "Name",
        "Report": "Report",
        "BackgroundColor": "Background color",
        "TextColor": "Text color",
        "Preview": "Preview",
        "Settings": "Settings",
        "IsWorkingTime": "Working time",
        "IsLoginAllowed": "Login allowed",
        "IsSelectableByUser": "Selectable by user",
        "HasAutomaticDeduction": "Automatic deduction",
        "DeductionThreshold": "When exceeding",
        "DeductionAmount": "Deduction",
        "CreateMore": "Create more entries",
        "AutoPrint": {
          "Title": "Auto print",
          "None": "No",
          "OnLogin": "Clock-in",
          "OnLogout": "Clock-out",
          "OnLoginAndLogout": "Clock-in + clock-out"
        },
        "Created": {
          "Success": {
            "Title": "Type created",
            "Description": "The type \"{0}\" was created."
          },
          "Error": "The type could not be created"
        },
        "Changed": {
          "Success": {
            "Title": "Type changed",
            "Description": "The type \"{0}\" was changed."
          },
          "Error": "The type could not be changed"
        }
      },
      "TimeTrackingEntry": {
        "Create": "Create entry",
        "Edit": "Edit entry",
        "User": "User",
        "Date": "Date",
        "Type": "Type",
        "Start": "Clock-in",
        "End": "Clock-out",
        "WorkingTime": "Working time",
        "AutomaticDeduction": "Auto deduction",
        "CreateMore": "Create more entries",
        "ErrorLoadingTypes": "Time tracking types could not be loaded",
        "ErrorLoadingUsers": "Users could not be loaded",
        "Created": {
          "Success": {
            "Title": "Entry created",
            "Description": "The entry was created."
          },
          "Error": "The entry could not be created"
        },
        "Edited": {
          "Success": {
            "Title": "Entry changed",
            "Description": "The entry was changed."
          },
          "Error": "The entry could not be changed"
        }
      },
      "DeleteTimeTrackingEntry": {
        "Title": "Delete entry",
        "Description": "Do you really want to delete the entry <b>{0}</b>?",
        "Error": "The entry could not be deleted"
      },
      "VoucherType": {
        "Create": "Create voucher type",
        "Edit": "Edit voucher type",
        "Name": "Description",
        "CloudReportHint": "Applies to all locations in the group. Only reports that every location has under this name can be selected.",
        "CloudReportsError": "The reports could not be loaded.",
        "MixedReportsUnchanged": "Differs by location (keep)",
        "Created": {
          "Success": {
            "Title": "Voucher type created",
            "Description": "The voucher type <b>{0}</b> has been created successfully."
          },
          "Error": "Could not create voucher type"
        },
        "Changed": {
          "Success": {
            "Title": "Voucher type changed",
            "Description": "The voucher type <b>{0}</b> has been changed successfully."
          },
          "Error": "Could not change voucher type"
        }
      },
      "CommunicationService": {
        "Edit": "Edit communication service",
        "Name": "Name",
        "DeviceName": "Device name",
        "Networks": "Networks",
        "Changed": {
          "Title": "Changed communication service",
          "Description": "The communication service <b>{0}</b> has been changed successfully.",
          "Error": "Could not change communication service"
        }
      },
      "Folder": {
        "Create": "Create folder",
        "Edit": "Edit folder"
      },
      "Article": {
        "Create": "Create article",
        "Edit": "Edit article",
        "Type": "Type",
        "CommodityGroup": "Commodity group",
        "CommodityGroupSearchPlaceholder": "Search commodity group...",
        "Barcodes": "Barcodes",
        "SubsequentPositions": "Subsequent positions",
        "Number": "Article No.",
        "Name": "Name",
        "Prices": "Prices",
        "PriceLists": "Price lists",
        "PriceListsTooltip": "You can create as many price lists as you want. In Lipp POS, you can switch between price lists so the articles are booked using the selected price list.",
        "Price": "Price",
        "Costs": "Costs",
        "MarkupOnCost": "% Markup on cost",
        "Settings": "Settings",
        "Sign": "Sign",
        "Course": "Course",
        "PackageDetails": "Package details",
        "Article": "Article",
        "Group": "Group",
        "Printers": "Printers",
        "BookingProcess": "Booking process",
        "TextEntryForBooking": "Text entry for booking",
        "IsDiscountable": "Eligible for discount",
        "PriceEntryForBooking": "Price entry for booking",
        "ExternalDocumentNumberEntryForBooking": "External document number entry for booking",
        "Invoicing": "Invoicing",
        "IsIncludedInParentPrice": "Disable separate display – included in main article price",
        "IsIncludedInParentPriceTooltip": "If the booked side dish has a different tax rate from the main article, this setting is ignored and the side dish is still shown on the invoice.",
        "Tabs": {
          "General": "General",
          "Weight": "Weight"
        },
        "Additions": "Additions",
        "Preparation": "Preparation",
        "Deposit": {
          "Tab": "Deposit",
          "Title": "Deposit",
          "Hint": "When this article is booked, the deposit is automatically booked as a separate line item (like a side order) and shown separately on the invoice.",
          "Type": "Deposit type",
          "Amount": "Deposit amount",
          "Types": {
            "None": "No deposit",
            "SingleUse": "Single-use",
            "Reusable": "Reusable"
          },
          "AmountRequired": "Please enter a deposit amount greater than 0.",
          "TaxInfoRKSV": "The deposit type automatically determines the tax rate:<br><b>Single-use deposit</b> = not taxable (pass-through item)<br><b>Reusable</b> = same tax as the article",
          "TaxInfoTSE": "In Germany, deposits are considered an ancillary service and are taxed at the article's tax rate — for both single-use and reusable."
        },
        "Weight": {
          "Title": "Sale by weight",
          "Hint": "For an article sold by weight, the sales price applies per kilogram or per gram. When booking, the POS asks for the weight and calculates the price from it.",
          "IsWeightArticle": "Sold by weight",
          "PriceType": "Price type",
          "PriceTypes": {
            "PerKilogram": "Price per kilogram",
            "PerGram": "Price per gram"
          },
          "Tare": "Tare",
          "TareTooltip": "Weight of the packaging (e.g. tray or plate). It is automatically subtracted from the entered weight when weighing at the POS. The unit follows the price type.",
          "Preview": "On the POS button:",
          "Validation": {
            "Title": "Invalid article sold by weight",
            "TareNegative": "The tare must not be negative.",
            "NegativeArticle": "An article sold by weight cannot be a minus article. Please set the sign to “+” or untick “Sold by weight”."
          }
        },
        "DepositReturn": {
          "Validation": {
            "Title": "Invalid deposit amount",
            "Message": "Please enter a sales price (deposit amount per unit) greater than 0."
          },
          "SystemGroupMissing": {
            "Message": "The system commodity group \"Einwegpfand\" could not be resolved. Please make sure the station is updated to POS 1.27.0 and synced."
          },
          "FiscalContextMissing": {
            "Message": "The station's fiscal configuration could not be loaded. Please reopen the dialog."
          },
          "CommodityGroupRequired": {
            "Message": "Please select a valid commodity group."
          }
        },
        "CopySuffix": "(copy)",
        "ProductionTime": {
          "Title": "Preparation time by quantity",
          "Hint": "Define how long preparation takes — tiered by quantity per booking. The order manager uses this to calculate the ready-by estimate.",
          "FromQuantity": "From quantity",
          "ToQuantity": "To quantity",
          "Minutes": "Time (minutes)",
          "AddTier": "Tier",
          "PreviewTitle": "Example preview",
          "PreviewItems": "pcs. booked",
          "PreviewInfinite": "infinite",
          "MinutesShort": "min",
          "Validation": {
            "Title": "Invalid tiers",
            "Message": "The preparation-time tiers must be in ascending order: 'To' must not be smaller than 'From', and each tier's 'From' must be greater than the previous tier's 'To'."
          }
        },
        "Description": "Description",
        "DescriptionTooltip": "Only printed on order receipts.",
        "Image": "Image",
        "ImageForBookingMask": "Image for booking mask",
        "IsActive": "Active",
        "CreateMultiple": "Create multiple",
        "Created": {
          "Title": "Created article",
          "Description": "The article <b>{0}</b> has been created successfully.",
          "Error": "Could not create article"
        },
        "Changed": {
          "Title": "Changed article",
          "Description": "The article <b>{0}</b> has been changed successfully.",
          "Error": "Could not change article"
        },
        "NoPrintersWarning": {
          "Title": "No printer assigned",
          "Description": "This article has no printer assigned. Save anyway?",
          "SaveAnyway": "Save anyway"
        },
        "ErrorLoadingCommodityGroups": "Could not load commodity groups",
        "ErrorLoadingCourses": "Could not load courses",
        "ErrorLoadingPrinters": "Could not load printers",
        "ErrorLoadingPriceLists": "Could not load price lists"
      },
      "Articles": {
        "SelectArticle": "Select article"
      },
      "ArticlePackageDetail": {
        "Create": "Add article package detail",
        "Edit": "Edit article package detail",
        "Quantities": "Quantities",
        "MinQuantity": "Minimum",
        "Suggested": "Suggested",
        "MaxQuantity": "Maximum",
        "CourseFromArticlePackage": "Take from article package"
      },
      "ArticlePackageGroup": {
        "Create": "Add article package group",
        "Edit": "Edit article package group",
        "MinQuantity": "Minimum",
        "MaxQuantity": "Maximum",
        "Note": "Note",
        "Articles": "Articles",
        "Article": "Article"
      },
      "DeactivateArticle": {
        "Title": "Deactivate article",
        "Description": "Do you really want to deactivate the article <b>{0}</b>?",
        "Error": "Could not deactivate article"
      },
      "Customer": {
        "Create": "Create customer",
        "Edit": "Change customer",
        "Salutation": "Salutation",
        "FirstName": "First name",
        "LastName": "Last name",
        "Name": "Name",
        "Addition": "Addition",
        "Street": "Street",
        "Zip": "ZIP",
        "City": "City",
        "Country": "Country",
        "VAT": "VAT id",
        "ContactDetails": "Contact details",
        "Email": "Email",
        "Phone": "Phone",
        "Mobile": "Mobile",
        "Birthdate": "Birthdate",
        "Notes": "Notes",
        "Remark": "Remark",
        "InternalNote": "Internal note",
        "Payment": "Payment",
        "PaymentTermDays": "Payment term (days)",
        "PaymentTarget": "Payment term (note)",
        "Created": {
          "Title": "Created customer",
          "Description": "The customer <b>{0}</b> has been created successfully.",
          "Error": "Could not create customer"
        },
        "Changed": {
          "Title": "Changed customer",
          "Description": "The customer <b>{0}</b> has been changed successfully.",
          "Error": "Could not change customer"
        },
        "ErrorLoadingSalutations": "Could not load salutations",
        "ErrorLoadingCountries": "Could not load countries"
      },
      "DeactivateCustomer": {
        "Title": "Deactivate customer",
        "Description": "Do you really want to deactivate the customer <b>{0}</b>?",
        "Error": "Could not deactivate customer"
      },
      "DeleteMailAccount": {
        "Title": "Delete mail account",
        "Description": "Do you really want to delete the mail account <b>{0}</b> ({1})?",
        "Error": "Could not delete mail account"
      },
      "DeleteMailTemplate": {
        "Title": "Delete template",
        "Description": "Do you really want to delete the template <b>{0}</b>?",
        "Error": "Could not delete template"
      },
      "ResetSetting": {
        "Title": "Reset setting",
        "Description": "Do you really want to reset the setting <b>{0}</b>?",
        "Reset": {
          "Title": "Reset setting",
          "Description": "The setting <b>{0}</b> has been reset successfully."
        },
        "Error": "Could not reset setting"
      },
      "Setting": {
        "Title": "Change setting",
        "Changed": {
          "Title": "Changed setting",
          "Description": "The setting <b>{0}</b> has been changed successfully."
        },
        "Error": "Could not change setting"
      },
      "NfcTipPrompt": {
        "NoDisplay": "Not shown",
        "Percentage": "Percentage"
      },
      "Printer": {
        "Create": "Create printer",
        "Edit": "Edit printer",
        "General": "General",
        "Redirections": "Redirections",
        "AdditionalPrints": "Additional print",
        "Name": "Name",
        "CommunicationService": "Communication service",
        "SystemPrinter": "Printer",
        "Type": "Format",
        "Reports": {
          "Title": "Reports",
          "BookingsReceipt": "Bookings receipt",
          "BookingsReceiptPrintCount": "Number of bookings receipts",
          "OrderManagerConfirmation": "Order manager confirmation",
          "DeliveryNote": "Delivery note",
          "BookingsCancellationReceipt": "Bookings cancellation receipt",
          "TableTransfer": "Table transfer",
          "CourseRecall": "Course recall",
          "ProformaInvoice": "Proforma invoice",
          "Invoice": "Invoice"
        },
        "Margin": {
          "Title": "Page margins",
          "Left": "Left",
          "Top": "Top"
        },
        "If": "If",
        "Then": "Then",
        "Workstation": "Workstation",
        "User": "User",
        "Department": "Department",
        "Table": "Table",
        "Printer": "Printer",
        "AtLeastOneConditionRequired": "Each redirection must have at least one condition (workstation, user, department, or table) enabled and selected.",
        "AdditionalPrintAtLeastOneConditionRequired": "Each additional print must have at least one condition (workstation, user, department, or table) enabled and selected.",
        "Created": {
          "Title": "Created printer",
          "Description": "The printer <b>{0}</b> has been created successfully.",
          "Error": "Could not create printer"
        },
        "Changed": {
          "Title": "Changed printer",
          "Description": "The printer <b>{0}</b> has been changed successfully.",
          "Error": "Could not change printer"
        },
        "ErrorLoadingCommunicationServices": "Could not load communication services",
        "ErrorLoadingSystemPrinters": "Could not load printers",
        "ErrorLoadingReports": "Could not load reports",
        "ErrorLoadingUsers": "Could not load users"
      },
      "DeletePrinter": {
        "Title": "Delete printer",
        "Description": "Do you really want to delete the printer <b>{0}</b> ({1})?",
        "PrinterStillAssignedDescription": "The printer <b>{0}</b> ({1}) still has assigned <b>articles, workstations or printer redirections</b>.<br><br>Do you really want to delete it?",
        "Error": "Could not delete printer"
      },
      "PriceList": {
        "Create": "Create price list",
        "Edit": "Edit price list",
        "Name": "Name",
        "Created": {
          "Title": "Created price list",
          "Description": "The price list <b>{0}</b> has been created successfully.",
          "Error": "Could not create price list"
        },
        "Changed": {
          "Title": "Changed price list",
          "Description": "The price list <b>{0}</b> has been changed successfully.",
          "Error": "Could not change price list"
        }
      },
      "DeletePriceList": {
        "Title": "Delete price list",
        "Description": "Do you really want to delete the price list <b>{0}</b>?",
        "Error": "Could not delete price list"
      },
      "Promotion": {
        "Create": "Create promotion",
        "Edit": "Edit promotion",
        "General": "General",
        "TableScope": "Departments & tables",
        "ArticleScope": "Revenue, commodity groups & articles",
        "Name": "Name",
        "Priority": "Priority",
        "DateFrom": "Date from",
        "DateTo": "Date to",
        "AllDay": "All day",
        "TimeFrom": "Time from",
        "TimeTo": "Time to",
        "Weekdays": "Weekdays",
        "WeekdaysRequired": "At least one weekday must be selected.",
        "Departments": "Departments",
        "Tables": "Tables",
        "TableScopeRequired": "At least one department or table must be selected.",
        "RevenueGroups": "Revenue groups",
        "CommodityGroups": "Commodity groups",
        "Articles": "Articles",
        "ArticleScopeRequired": "At least one revenue group, commodity group or article must be selected.",
        "PriceMode": {
          "Title": "Price mode",
          "Pricelist": "Price list",
          "Discount": "Discount",
          "PriceOverride": "Price type",
          "Price": "Price"
        },
        "PriceTypes": {
          "Add": "Add",
          "Fixed": "Amount"
        },
        "ErrorLoadingPriceLists": "Could not load price lists",
        "ErrorLoadingDepartments": "Could not load departments",
        "ErrorLoadingTables": "Could not load tables",
        "ErrorLoadingRevenueGroups": "Could not load revenue groups",
        "ErrorLoadingCommodityGroups": "Could not load commodity groups",
        "ErrorLoadingArticles": "Could not load articles",
        "Created": {
          "Title": "Promotion created",
          "Description": "The promotion <b>{0}</b> has been created successfully.",
          "Error": "Could not create promotion"
        },
        "Changed": {
          "Title": "Promotion changed",
          "Description": "The promotion <b>{0}</b> has been changed successfully.",
          "Error": "Could not change promotion"
        }
      },
      "DeactivatePromotion": {
        "Title": "Deactivate promotion",
        "Description": "Do you really want to deactivate the promotion <b>{0}</b>?",
        "Error": "Could not deactivate promotion"
      },
      "UnlinkLicense": {
        "Title": "Unlink license",
        "Description": "Do you really want to unlink the license for the workstation <b>{0}</b>?",
        "Unlink": "Unlink license",
        "Unlinked": {
          "Title": "Unlinked license",
          "Description": "The license for the workstation <b>{0}</b> has been unlinked successfully.",
          "Error": "Could not unlink license"
        }
      },
      "DisconnectMobileDevice": {
        "Title": "Disconnect device",
        "Description": "Do you really want to disconnect the paired device of the workstation <b>{0}</b>? The device will be disconnected and can reconnect afterwards using the QR code.",
        "Disconnect": "Disconnect",
        "Disconnected": {
          "Title": "Device disconnected",
          "Description": "The disconnect for the workstation <b>{0}</b> has been triggered.",
          "Error": "Could not disconnect device"
        }
      },
      "RemoveLicencesAndBackups": {
        "Title": "Remove licences & backups",
        "Description": "Do you really want to delete <b>all licences & backups</b> of the station <b>{0}</b> of the enterprise <b>{1}</b>?",
        "Remove": "Remove",
        "Error": "Could not remove licences & backups",
        "Success": {
          "Title": "Removed licences & backups",
          "Description": "The licences & backups of the station <b>{0}</b> of the enterprise <b>{1}</b> have been removed successfully."
        }
      },
      "DeleteLiveData": {
        "Title": "Delete live data",
        "DateDescription": "Do you really want to delete the live data from <b>{0}</b>?",
        "Description": "<b>Warning!</b> When you delete live data, all sales data, invoices and digital receipts will be irrevocably deleted.",
        "Deleted": {
          "Title": "Initiated deleting live data",
          "Description": "The deleting of live data has been initiated successfully!"
        },
        "DigitalReceiptsError": {
          "Title": "Digital receipts not deleted",
          "Description": "The live data is being deleted, but the digital receipts could not be removed."
        },
        "Error": "Could not delete live data"
      },
      "RKSV": {
        "Title": "Set up RKSV 2017",
        "ParticipantId": "Participant Identification",
        "UserId": "User Identification",
        "PIN": "PIN",
        "VatId": "VAT id",
        "TaxNumber": "Tax number",
        "Setup": "Set up",
        "SuccessSettingUp": {
          "Title": "Set up RKSV 2017",
          "Description": "RKSV 2017 has been set up successfully!"
        },
        "ErrorSettingUp": "Could not set up RKSV"
      },
      "DeactivateRKSV": {
        "Title": "Deactivate RKSV 2017",
        "Description": "<b>Attention!</b> When you deactivate RKSV 2017, a final receipt is created and automatically sent to your stored FinanzOnline data for the cash register web service user.",
        "Deactivated": {
          "Title": "Deactivated RKSV 2017",
          "Description": "RKSV 2017 has been deactivated successfully!"
        },
        "Error": "Could not deactivate RKSV 2017"
      },
      "DeactivateTSE": {
        "Title": "Deactivate TSS",
        "Description": "<b>Attention!</b> When TSS has been deactivated, your invoices will no longer be signed in accordance with the law.",
        "Deactivated": {
          "Title": "Deactivated TSS",
          "Description": "TSS has been deactivated successfully!"
        },
        "Error": "Could not deactivate TSS"
      },
      "FinancialAccount": {
        "Create": "Create financial account",
        "Edit": "Edit financial account",
        "AccountNumber": "Account number",
        "AccountName": "Account name",
        "CostCenter": "Cost center",
        "BookingSymbol": "Booking symbol",
        "ExternalTaxCode": "External tax code",
        "OutputType": "Output type",
        "Created": {
          "Title": "Created financial account",
          "Description": "The financial account <b>{0} ({1})</b> has been created successfully.",
          "Error": "Could not create financial account"
        },
        "Changed": {
          "Title": "Changed financial account",
          "Description": "The financial account <b>{0} ({1})</b> has been changed successfully.",
          "Error": "Could not change financial account"
        }
      },
      "DeactivateFinancialAccount": {
        "Title": "Deactivate financial account",
        "Description": "Do you really want to deactivate the financial account <b>{0} ({1})</b>?",
        "MappingsWarningOne": "<b>1 assignment</b> is still assigned to this account. After deactivating, its amounts are missing from the BMD/DATEV export.",
        "MappingsWarningMany": "<b>{0} assignments</b> are still assigned to this account. After deactivating, their amounts are missing from the BMD/DATEV export.",
        "Error": "Could not deactivate financial account"
      },
      "ExportWarnings": {
        "Title": "Export warnings",
        "Description": "The following amounts are missing from the export for <b>{0} – {1}</b>:",
        "CheckFailed": "The check for missing financial account assignments could not be performed. You can still export.",
        "InactiveFinancialAccountsTitle": "Deactivated financial accounts",
        "MissingMappingsTitle": "Missing financial account assignments",
        "InactiveFinancialAccount": "is assigned to the deactivated financial account {0} ({1})",
        "MissingMapping": "has no financial account assignment",
        "InactiveSubjectInactiveFinancialAccount": "is deactivated and assigned to the deactivated financial account {0} ({1})",
        "InactiveSubjectMissingMapping": "is deactivated and has no financial account assignment",
        "InactiveSubjectsHint": "Deactivated entries only appear in the assignments once you reactivate them in the master data.",
        "CommodityGroup": "Commodity group {0} (VAT {1}%)",
        "UnknownCommodityGroup": "Unknown commodity group (VAT {0}%)",
        "UnknownCommodityGroupWithSample": "Unknown commodity group, e.g. \"{0}\" (VAT {1}%)",
        "PaymentMethod": "Payment method {0}",
        "UnknownPaymentMethod": "Unknown payment method",
        "Effort": "Effort {0}",
        "UnknownEffort": "Unknown effort",
        "BookingsOne": "{0} booking",
        "BookingsMany": "{0} bookings",
        "PaymentsOne": "{0} payment",
        "PaymentsMany": "{0} payments",
        "InvoicesOne": "{0} invoice",
        "InvoicesMany": "{0} invoices",
        "ExportAnyway": "Export anyway"
      },
      "FinancialAccountMapping": {
        "Title": "Change assignment",
        "PaymentMethod": "Payment method",
        "CommodityGroup": "Commodity group",
        "Effort": "Effort",
        "FinancialAccount": "Financial account",
        "ErrorLoadingFinancialAccounts": "Could not load financial accounts",
        "ChangePaymentMethod": {
          "Success": {
            "Title": "Changed assignment",
            "Description": "The assignment for the payment method <b>{0}</b> has been changed successfully."
          },
          "Error": "Could not change assignment"
        },
        "ChangeCommodityGroup": {
          "Success": {
            "Title": "Changed assignment",
            "Description": "The assignment for the commodity group <b>{0}</b> has been changed successfully."
          },
          "Error": "Could not change assignment"
        },
        "ChangeEffort": {
          "Success": {
            "Title": "Changed assignment",
            "Description": "The assignment for the effort <b>{0}</b> has been changed successfully."
          },
          "Error": "Could not change assignment"
        }
      },
      "CloseDays": {
        "Title": "Close days",
        "Description": "Do you really want to close the days until <b>{0}</b>?",
        "Success": {
          "Title": "Closed days",
          "Description": "The days have been closed until <b>{0}</b>."
        },
        "Error": "Could not close days"
      },
      "UndoDailyClosings": {
        "Title": "Undo daily closings",
        "Description": "Do you really want to undo the daily closings until <b>{0}</b>?",
        "Success": {
          "Title": "Reset daily closings",
          "Description": "The daily closings have been reset until <b>{0}</b>."
        },
        "Error": "Could not undo daily closings"
      },
      "SendSalesToPMS": {
        "Title": "Send sales to PMS",
        "Description": "Do you really want to send the sales of <b>{0}</b> to the PMS?",
        "Success": {
          "Title": "Sent sales",
          "Description": "The sales of <b>{0}</b> have been sent to the PMS."
        },
        "Error": "Could not send sales"
      },
      "TableLayout": {
        "Text": {
          "Create": "Create text",
          "Edit": "Edit text",
          "Text": "Text",
          "FontSize": "Font size",
          "TextColor": "Color"
        },
        "Shape": {
          "Edit": "Edit shape",
          "TableShape": "Table shape",
          "Color": "Color",
          "Width": "Width",
          "Height": "Height",
          "Rotation": "Rotation"
        },
        "Size": {
          "Width": "Width",
          "Height": "Height"
        },
        "Color": {
          "Background": "Background",
          "Text": "Text"
        },
        "SaveLayout": {
          "Title": "Save department & table designer",
          "Description": "Do you want to save the changed department & table designer?",
          "ConflictTitle": "Warning! The following entries were changed by someone else in the meantime. If you save, you will overwrite those changes:",
          "SaveAnyway": "Save anyway"
        }
      },
      "ArticleLayout": {
        "SaveLayout": {
          "Title": "Save article designer",
          "Description": "Do you want to save the changed article designer?",
          "ConflictTitle": "Warning! The following entries were changed by someone else in the meantime. If you save, you will overwrite those changes:",
          "SaveAnyway": "Save anyway"
        },
        "LayoutMainGroup": {
          "Create": "Create main group",
          "Edit": "Edit main group \"{0}\"",
          "Name": "Name",
          "ShortNameMobile": "Mobile abbreviation",
          "CreateMultiple": "Create multiple"
        },
        "LayoutSubGroup": {
          "Create": "Create sub group",
          "Edit": "Edit sub group \"{0}\"",
          "Name": "Name",
          "ShortNameMobile": "Mobile abbreviation",
          "Rows": "Rows",
          "Columns": "Columns",
          "ArticlePositionFontSize": "Article caption size",
          "ArticlePositionFontSizes": {
            "Small": "Small",
            "Medium": "Medium",
            "Large": "Large"
          },
          "Preview": "Preview",
          "Slots": "Slots",
          "IsActive": "Active",
          "IndicatorColor": "Indicator colour",
          "ResetIndicatorColor": "Reset to default",
          "OnlineDescription": "Guest ordering description",
          "CreateMultiple": "Create multiple"
        }
      },
      "ArticleAddon": {
        "Edit": "Eddit subsequent position",
        "Sequence": "Sequence"
      },
      "ArticleAddons": {
        "Edit": "Assign subsequent positions",
        "NotAssigned": "Not assigned",
        "Assigned": "Assigned",
        "Sequence": "Sequence",
        "Position": "{0} Position",
        "Positions": "{0} Positions",
        "Changed": {
          "Title": "Assigned subsequent positions",
          "Description": "The subsequent positions for the article <b>{0}</b> have been assigned successfully.",
          "Error": "Could not assign subsequent positions"
        }
      },
      "CashJournalTransaction": {
        "RevenueTitle": "Create revenue",
        "ExpenseTitle": "Create expense",
        "EditExpenseTitle": "Edit expense",
        "EditRevenueTitle": "Edit revenue",
        "Date": "Date",
        "Template": "Template",
        "Amount": "Amount",
        "Tax": "Tax",
        "TaxAmount": "Tax amount",
        "Preview": "Cash balance preview",
        "Add": "Add"
      },
      "Template": {
        "CreateTitle": "Create template",
        "EditTitle": "Edit template",
        "Type": "Type",
        "Description": "Description",
        "Tax": "Tax",
        "Revenue": "Revenue",
        "Expense": "Expense"
      },
      "PaymentTerminal": {
        "Create": "Create Payment terminal",
        "Edit": "Edit Payment terminal",
        "Name": "Name",
        "IPAddress": "IP Address",
        "Port": "Port",
        "ActiveWorkstations": "Enable payment terminal on the following workstation",
        "ActivePaymentMethods": "Enable payment terminal for the following payment methods",
        "ProcessTip": "Explicitly request tip at the terminal",
        "ProcessTipInfo": "Some terminals require this option so the tip prompt appears on the terminal. On other terminals the manufacturer handles this itself – then the option is not needed. A tip entered on the terminal is applied in either case.",
        "Created": {
          "Title": "Payment terminal created",
          "Description": "Successfully created payment terminal.",
          "Error": "Error creating new payment terminal"
        },
        "Changed": {
          "Title": "Payment terminal changed",
          "Description": "Successfully changed payment terminal.",
          "Error": "Error changing the payment terminal"
        }
      },
      "DeactivatePaymentTerminal": {
        "Title": "Deactivate payment terminal",
        "Description": "Do you really want to deactivate the payment terminal <b>{0}</b>?",
        "Error": "Could not deactivate payment terminal",
        "Success": "Successfully deactivated payment terminal"
      },
      "COMPort": {
        "Title": "Assign COM port",
        "COMPort": "COM port",
        "Assign": "Assign"
      },
      "StartCashJournal": {
        "Title": "Start cash journal",
        "Start": "Start",
        "Date": "Start date",
        "Amount": "Opening balance",
        "Success": {
          "Title": "Started cash journal",
          "Description": "Cash journal has started successfully."
        },
        "Error": "Could not start cash journal"
      },
      "AsaSoapSetting": {
        "Title": "Change setting",
        "Changed": {
          "Title": "Changed setting",
          "Description": "The setting <b>{0}</b> has been changed successfully.",
          "Error": "Could not change setting"
        }
      },
      "PreOrder": {
        "RequireTable": "Table required",
        "LayoutProfile": "Layout group",
        "PersonTypes": "Person types",
        "PersonTypePlaceholder": "Name, e.g. adults",
        "AddPersonType": "Person type",
        "NoPersonTypes": "No person types have been created.",
        "MaxPersonTypes": "Only {0} person types are allowed.",
        "PersonTypeCount": "{0} person types",
        "PersonTypeWithoutName": "Every person type needs a name."
      },
      "DailyAccountingPrinterSetting": {
        "Hint": "5 minutes after the change of day for statistics, the POS prints the daily accounting of the finished day on this printer. If the POS was switched off at that time, it prints on the next start. \"-\" = no automatic printing."
      },
        "ScaleSetting": {
          "Title": "Change setting",
          "Changed": {
            "Title": "Setting changed",
            "Description": "The setting <b>{0}</b> was changed successfully.",
            "Error": "Setting could not be changed"
          }
        },
      "LippPmsSetting": {
        "Title": "Change setting",
        "Changed": {
          "Title": "Setting changed",
          "Description": "The setting <b>{0}</b> was changed successfully.",
          "Error": "The setting could not be changed"
        }
      },
      "BookInSetting": {
        "Title": "Change setting",
        "Changed": {
          "Title": "Setting changed",
          "Description": "The setting <b>{0}</b> was changed successfully.",
          "Error": "The setting could not be changed"
        }
      },
      "ApaleoSetting": {
        "Title": "Change setting",
        "SecretUnchanged": "Stored – leave empty to keep it",
        "Changed": {
          "Title": "Setting changed",
          "Description": "The setting <b>{0}</b> was changed successfully.",
          "Error": "The setting could not be changed"
        }
      }
    },
    "OnlineStatus": {
      "Online": "Live data",
      "Offline": "Offline",
      "LastSyncOn": "Data was last synchronized on {0} at {1}",
      "Error": "Could not load online status"
    },
    "SyncStatus": {
      "TransFullActive": "Transaction data syncing ({0}%)",
      "TransFullActiveWithoutTotal": "Transaction data syncing ({0} table(s) uploaded)",
      "TransFullPending": "Transaction data will be synced shortly",
      "FiscalFullActive": "Fiscal data syncing ({0}/{1})",
      "FiscalFullActiveWithoutTotal": "Fiscal data syncing ({0} table(s) uploaded)",
      "FiscalFullPending": "Fiscal data will be synced shortly",
      "TableProgress": "<b>{0}</b> {1} of {2}",
      "TableCompleted": "<b>{0}</b> ✓ ({1})",
      "TableEmpty": "<b>{0}</b> -",
      "Tables": {
        "Booking": "Bookings",
        "Invoice": "Invoices",
        "DeliveryNote": "Delivery notes",
        "InvoicePayment": "Payments",
        "InvoiceCardPayment": "Card payments",
        "ATRKSVDEP": "RKSV signatures",
        "DETSETransaction": "TSE transactions",
        "PMSTransfer": "PMS transfers"
      }
    },
    "Syncing": {
      "Title": "Master data is being synchronized",
      "Description": "The master data of this station is currently being uploaded to the cloud. Please wait until the process is complete.",
      "Progress": "{0} of {1} tables uploaded",
      "ProgressWithoutTotal": "{0} table(s) uploaded",
      "PowerHint": "If the POS is switched off, please turn it on and keep it on so the synchronization can finish."
    },
    "AsaSoap": {
      "Title": "ASA-SOAP",
      "CommunicationService": {
        "Title": "Communication service",
        "ErrorLoadingCommunicationServices": "Could not load communication services",
        "ErrorLoadingSelectedCommunicationService": "Could not load selected communication service",
        "Changed": {
          "Success": {
            "Title": "Selected communication service",
            "Description": "The communication service <b>{0}</b> has been selected successfully."
          },
          "Error": "Could not select communication service"
        }
      },
      "Settings": {
        "Title": "Settings",
        "Name": "Name",
        "Value": "Value",
        "Identifiers": {
          "ASASOAP_URL": "Service URL",
          "ASASOAP_USERNAME": "Username",
          "ASASOAP_PASSWORD": "Password",
          "ASASOAP_SYSTEMID": "System ID",
          "INVOICECARRIERFORGUESTS": "Auto-create PMS invoice carriers",
          "SENDDAILYREVENUEAUTOMATIC": "Send daily revenue automatically",
          "SENDDAILYREVENUESTARTDATE": "Send daily revenue automatically - Start date",
          "SENDDAILYREVENUETIME": "Send daily revenue automatically - Time"
        },
        "InvoiceCarrierOptions": {
          "0": "No",
          "1": "Yes - PMS room number = Lipp POS table number",
          "2": "Yes - PMS table number = Lipp POS table number"
        }
      }
    },
      "Scale": {
        "Title": "Scale",
        "CommunicationService": {
          "Title": "Communication server",
          "Hint": "The scale is attached to the computer running this communication server — the COM port applies there. A second counter is a second installation with its own scale.",
          "ErrorLoadingCommunicationServices": "Communication servers could not be loaded",
          "ErrorLoadingSelectedCommunicationService": "Selected communication server could not be loaded",
          "Changed": {
            "Success": {
              "Title": "Communication server selected",
              "Description": "The communication server <b>{0}</b> was selected successfully."
            },
            "Error": "Communication server could not be selected"
          }
        },
        "Settings": {
          "Title": "Settings",
          "Name": "Name",
          "Value": "Value",
          "MissingSerialNo": "Without a serial number the interface does not start, even when it is switched on: a weighing could otherwise not be tied to a verified device.",
          "Placeholders": {
            "SCALE_SERIALNO": "Serial number from the scale's rating plate"
          },
          "Identifiers": {
            "SCALE_COMMANDSETVERSION": "Command set",
            "SCALE_CHECKSUMUSERANDOM": "Scramble checksum with random number",
            "SCALE_SENDARTICLETEXT": "Send article text to the scale",
            "SCALE_BASEPRICEDIGITS": "Digits of the base price field",
            "SCALE_RECEIVEWEIGHTDECIMALS": "Decimal places of the received weight",
            "SCALE_SERIALNO": "Serial number of the scale",
            "SCALE_TIMEOUTMS": "Response timeout (ms)",
            "SCALE_RETRYCOUNT": "Retries after a rejection",
            "SCALE_POLLINTERVALMS": "Interval between weight requests (ms)",
            "SCALE_PROTOCOLLEVEL": "Logging",
            "SCALE_CONNECTIONTYPE": "Connection type",
            "SCALE_IPADDRESS": "IP address",
            "SCALE_PORT": "Network port",
            "COMPORT": "COM port",
            "SCALE_BAUDRATE": "Baud rate",
            "SCALE_PARITY": "Parity",
            "SCALE_DATABITS": "Data bits",
            "SCALE_STOPBITS": "Stop bits",
            "SCALE_HANDSHAKE": "Flow control",
            "SCALE_RTSENABLE": "Assert RTS line",
            "SCALE_DTRENABLE": "Assert DTR line",
            "SCALE_ENCODINGCODEPAGE": "Character set (code page)"
          },
          "Hints": {
            "SCALE_COMMANDSETVERSION": "Command set 1 is the documented protocol of the Mettler-Toledo Ariva. Command set 2 adds the Bizerba extension, where the scale also reports its own tare — only for scales that support it.",
            "SCALE_CHECKSUMUSERANDOM": "The scale asks for the checksum of the legally relevant POS software and scrambles it with a random number. Some devices (Digi DS782) require the variant without it.",
            "SCALE_SENDARTICLETEXT": "Passes the article name to the scale so that it appears on its display. The scale takes 13 characters.",
            "SCALE_BASEPRICEDIGITS": "Width of the price field in the telegram. If the base price does not fit, the weighing is rejected instead of booking a truncated price.",
            "SCALE_RECEIVEWEIGHTDECIMALS": "Command set 2 only: decimal places of the weight in kilograms, usually 3 — that is whole grams. With command set 1 the scale reports the decimals itself. Prices always use 2 decimal places per kilogram; the scale must be set up that way.",
            "SCALE_SERIALNO": "Appears in the scale log of every weighing and identifies the verified device. Mandatory: without it the interface does not start.",
            "SCALE_TIMEOUTMS": "How long the POS waits for a response before cancelling the weighing. Clamped to 2500–10000 ms.",
            "SCALE_RETRYCOUNT": "How often the same telegram is repeated when the scale rejects it. After that the POS asks for its status message and shows the reason.",
            "SCALE_POLLINTERVALMS": "Waiting time before asking for the weight again while the scale is still in motion or nothing is on it.",
            "SCALE_PROTOCOLLEVEL": "At the highest level the POS writes every telegram in both directions to the log. Intended for diagnosis, not for permanent operation.",
            "SCALE_CONNECTIONTYPE": "Serial is the normal case. Network is for a serial network adapter when the scale is not next to the computer.",
            "SCALE_IPADDRESS": "Network connection only: address of the serial network adapter.",
            "SCALE_PORT": "Network connection only: port of the serial network adapter.",
            "COMPORT": "Number of the serial port on the computer of the communication server selected above.",
            "SCALE_BAUDRATE": "Must match the setting on the scale. The Ariva's default is 9600.",
            "SCALE_PARITY": "Must match the setting on the scale. The Ariva's default is odd.",
            "SCALE_DATABITS": "Must match the setting on the scale. The Ariva's default is 7.",
            "SCALE_STOPBITS": "Must match the setting on the scale. The Ariva's default is 1.",
            "SCALE_HANDSHAKE": "The default is none. Change it only if the scale explicitly requires it.",
            "SCALE_RTSENABLE": "Asserts the RTS line of the serial port. Only for cables that draw their power from it.",
            "SCALE_DTRENABLE": "Asserts the DTR line of the serial port. Only for cables that draw their power from it.",
            "SCALE_ENCODINGCODEPAGE": "Character set of the telegrams. The default 28591 (Latin-1) keeps umlauts in the article text intact."
          },
          "Options": {
            "SCALE_COMMANDSETVERSION": {
              "1": "1 — Dialog 06 (Mettler-Toledo)",
              "2": "2 — with Bizerba extension"
            },
            "SCALE_PROTOCOLLEVEL": {
              "1": "Errors only",
              "3": "All telegrams (diagnosis)"
            },
            "SCALE_CONNECTIONTYPE": {
              "Serial": "Serial (COM)",
              "Tcp": "Network (serial over TCP)"
            },
            "SCALE_PARITY": {
              "None": "none",
              "Odd": "odd",
              "Even": "even"
            },
            "SCALE_STOPBITS": {
              "One": "1",
              "Two": "2"
            },
            "SCALE_HANDSHAKE": {
              "None": "none",
              "XOnXOff": "XON/XOFF",
              "RequestToSend": "RTS/CTS",
              "RequestToSendXOnXOff": "RTS/CTS and XON/XOFF"
            }
          }
        }
      },
    "LippPms": {
      "Title": "Lipp PMS",
      "CommunicationService": {
        "Title": "Communication server",
        "ErrorLoadingCommunicationServices": "Communication servers could not be loaded",
        "ErrorLoadingSelectedCommunicationService": "The selected communication server could not be loaded",
        "Changed": {
          "Success": {
            "Title": "Communication server selected",
            "Description": "The communication server <b>{0}</b> was selected successfully."
          },
          "Error": "The communication server could not be selected"
        }
      },
      "Settings": {
        "Title": "Settings",
        "Name": "Name",
        "Value": "Value",
        "Identifiers": {
          "LIPPPMS_URL": "Lipp PMS address",
          "LIPPPMS_WORKSTATIONID": "Workstation for room charges from the PMS",
          "LIPPPMS_USERID": "User for room charges from the PMS",
          "SENDDAILYREVENUEAUTOMATIC": "Send daily revenue automatically",
          "SENDDAILYREVENUESTARTDATE": "Send daily revenue automatically - start date",
          "SENDDAILYREVENUETIME": "Send daily revenue automatically - time"
        },
        "Automatic": "automatic",
        "AutomaticPlaceholder": "empty = automatic",
        "Hints": {
          "LIPPPMS_URL": "The same for every property: https://pms-api.lipp.cloud. The PMS identifies the property from the till itself. From Lipp POS 1.38.0 the till sets the address on its own.",
          "LIPPPMS_URL_AUTOMATIC": "Leave empty, the till sets the address itself. Only enter one to test against a different PMS.",
          "LIPPPMS_WORKSTATIONID": "When reception triggers “Charge to room” in the hotel system, nobody is logged in at the till. The invoice is created and signed under this workstation — it determines the register ID and receipt number range.",
          "LIPPPMS_USERID": "This user appears on invoices triggered from the hotel system. A dedicated user such as “Reception” is recommended so the receipt still shows who charged."
        }
      }
    },
    "BookIn": {
      "Title": "book-in",
      "CommunicationService": {
        "Title": "Communication server",
        "ErrorLoadingCommunicationServices": "Communication servers could not be loaded",
        "ErrorLoadingSelectedCommunicationService": "The selected communication server could not be loaded",
        "Changed": {
          "Success": {
            "Title": "Communication server selected",
            "Description": "The communication server <b>{0}</b> was selected successfully."
          },
          "Error": "The communication server could not be selected"
        }
      },
      "Settings": {
        "Title": "Settings",
        "Name": "Name",
        "Value": "Value",
        "Identifiers": {
          "BOOKIN_URL": "Interface address",
          "BOOKIN_HOTELID": "Hotel ID",
          "BOOKIN_COMPANYCODE": "Company code",
          "INVOICECARRIERFORGUESTS": "Create PMS invoice carrier automatically"
        },
        "InvoiceCarrierOptions": {
          "0": "No",
          "1": "Yes - PMS room number = Lipp POS table number",
          "2": "Yes - PMS table number = Lipp POS table number"
        },
        "Hints": {
          "BOOKIN_URL": "Base address without the hotel ID, e.g. https://server02.book-in.eu/pos/hotelmaestro",
          "BOOKIN_HOTELID": "The property's hotel ID at book-in",
          "BOOKIN_COMPANYCODE": "Access code from book-in – confidential"
        }
      }
    },
    "Apaleo": {
      "Title": "Apaleo",
      "CommunicationService": {
        "Title": "Communication server",
        "ErrorLoadingCommunicationServices": "Communication servers could not be loaded",
        "ErrorLoadingSelectedCommunicationService": "The selected communication server could not be loaded",
        "Changed": {
          "Success": {
            "Title": "Communication server selected",
            "Description": "The communication server <b>{0}</b> was selected successfully."
          },
          "Error": "The communication server could not be selected"
        }
      },
      "Settings": {
        "Title": "Settings",
        "Name": "Name",
        "Value": "Value",
        "Identifiers": {
          "APALEO_CLIENTID": "Client ID",
          "APALEO_CLIENTSECRET": "Client secret",
          "APALEO_PROPERTYID": "Property ID (hotel)",
          "INVOICECARRIERFORGUESTS": "Create PMS invoice carrier automatically"
        },
        "InvoiceCarrierOptions": {
          "0": "No",
          "1": "Yes - PMS room number = Lipp POS table number",
          "2": "Yes - PMS table number = Lipp POS table number"
        },
        "Hints": {
          "APALEO_CLIENTID": "Client ID of the custom app in the hotel's Apaleo account (Apps → Connected apps)",
          "APALEO_CLIENTSECRET": "Secret of this app – confidential",
          "APALEO_PROPERTYID": "Code of the hotel in Apaleo, e.g. VIE"
        }
      }
    },
    "FoodNotify": {
      "Title": "FoodNotify",
      "Settings": {
        "Title": "Settings",
        "Hint": "You get the location ID and API key from FoodNotify. Once the integration is activated, articles and sales are sent to FoodNotify from the time of activation.",
        "AccountIdentifier": "FoodNotify location ID",
        "ApiKey": "API key",
        "SaveBeforeActivating": "Save the FoodNotify location ID and the API key first.",
        "ErrorLoading": "Settings could not be loaded",
        "ErrorChanging": "Settings could not be changed",
        "Changed": {
          "Title": "Settings changed",
          "Description": "The settings have been changed successfully."
        }
      },
      "ShrinkageReasons": {
        "Title": "Cancellation reasons",
        "Hint": "If a cancellation reason is marked as shrinkage, goods cancelled with it count as consumed in FoodNotify: for a cancelled invoice they are not returned to stock, a cancellation at the table is reported as consumption without revenue. The marking applies to cancellations from the moment it is saved. By default, no reason counts as shrinkage.",
        "Shrinkage": "Shrinkage in FoodNotify",
        "ErrorChanging": "Cancellation reasons could not be changed",
        "Changed": {
          "Title": "Cancellation reasons changed",
          "Description": "The cancellation reasons have been changed successfully."
        }
      }
    }
  },
  "Download": {
    "Error": "Download failed"
  },
  "Users": {
    "Title": "Users",
    "User": "User",
    "Email": "Email",
    "Confirmed": "Confirmed",
    "NotConfirmed": "Not confirmed",
    "SendConfirmationLink": {
      "Title": "Send confirmation link",
      "Success": {
        "Title": "Email sent",
        "Description": "Email for confirming user <b>{0}</b> has been sent."
      },
      "Error": "Email could not be sent"
    },
    "ResetPassword": {
      "Title": "Reset password",
      "Success": {
        "Title": "Email sent",
        "Description": "Email for resetting the password for the user <b>{0}</b> has been sent."
      },
      "Error": "Password could not be reset"
    },
    "Name": "Name",
    "Language": "Language",
    "Enterprises": "Enterprises",
    "ActiveInactive": "Active/Inactive",
    "Activated": {
      "Success": {
        "Title": "Activated user",
        "Description": "The user <b>{0}</b> has been activated successfully."
      },
      "Error": "Could not activate user"
    }
  },
  "DeactivateUserDialog": {
    "Title": "Deactivate user",
    "Description": "Do you really want to deactivate the user <b>{0}</b>?",
    "Success": {
      "Title": "Deactivated user",
      "Description": "The user <b>{0}</b> has been deactivated successfully."
    },
    "Error": "Could not deactivate user"
  },
  "Tutorials": {
    "Categories": {
      "Title": "Categories",
      "All": "All"
    },
    "Title": "Tutorials",
    "Tutorial": "Tutorial",
    "SearchBarPlaceholder": "Search videos...",
    "ErrorLoading": "Tutorials could not be loaded",
    "Views": "Views"
  },
  "DeleteTutorialDialog": {
    "Title": "Delete tutorial",
    "Description": "Do you really want to delete the tutorial <b>{0}</b>?",
    "Success": {
      "Title": "Deleted tutorial",
      "Description": "The tutorial <b>{0}</b> has been deleted successfully."
    },
    "Error": "Could not delete tutorial"
  },
  "TutorialDialog": {
    "Title": {
      "Create": "Create tutorial",
      "Edit": "Edit tutorial"
    },
    "Create": {
      "Success": {
        "Title": "Created tutorial",
        "Description": "The tutorial <b>{0}</b> has been created successfully."
      },
      "Error": "Could not create tutorial",
      "UploadVideo": "Upload video",
      "UploadThumbnail": "Add thumbnail"
    },
    "Edit": {
      "Success": {
        "Title": "Changed tutorial",
        "Description": "The tutorial <b>{0}</b> has been changed successfully."
      },
      "Error": "Could not change tutorial",
      "RemoveThumbnail": "Remove thumbnail"
    },
    "UploadVideo": "Upload video",
    "UploadFailed": "Could not upload tutorial",
    "Category": "Category",
    "VideoTitle": "Title",
    "Description": "Description"
  },
  "LippPOSDialog": {
    "Title": "Subscribe to Lipp POS",
    "StartTitle": "Start Lipp POS",
    "ExpandTitle": "Expand Lipp POS",
    "ReduceTitle": "Reduce Lipp POS",
    "ExpandAction": "Expand",
    "ReduceAction": "Reduce",
    "Tabs": {
      "Workstations": "Workstations",
      "Extensions": "Extensions",
      "Integrations": "Integrations"
    },
    "Addons": {
      "Title": "Addons",
      "Total": "Addons {0} / month",
      "BasePrice": "Base price",
      "AdditionalWorkstations": "Additional Lipp POS workstations",
      "Integrations": "Integrations",
      "Extensions": "Extensions",
      "Additional": "Additional",
      "Services": {
        "1": "POS for restaurants and retail",
        "2": "Cloud backup",
        "3": "Tutorials",
        "4": "365 days of customer support",
        "5": "Initial on-site installation"
      },
      "IntegrationsInUse": "Deactivate active integrations first.",
      "ExtensionsInUse": "Deactivate active extensions first."
    },
    "LippCare": {
      "Title": "Lipp Care",
      "Total": "Lipp Care {0} / month"
    },
    "Summary": {
      "Title": "Summary",
      "Total": "Total {0} / month",
      "TotalLabel": "Total",
      "Before": "Before",
      "After": "After",
      "CountWithPrice": "{0}x — {1} / month"
    },
    "Workstations": {
      "Title": "Workstations & Licenses",
      "ActiveOfTarget": "{0} of {1} licenses active",
      "OverflowHint": "Deactivate one or more licenses first to proceed with the reduction."
    },
    "Extensions": {
      "Title": "Active Extensions",
      "Name": "Extension",
      "Active": "Active",
      "ActiveOfTarget": "{0} of {1} extensions active",
      "ToggleError": "Could not toggle extension"
    },
    "Integrations": {
      "Title": "Active Integrations",
      "Name": "Integration",
      "Active": "Active",
      "ActiveOfTarget": "{0} of {1} integrations active",
      "ToggleError": "Could not toggle integration"
    },
    "PricePerMonth": "{0} / month",
    "PaymentStart": "Payment start",
    "Prepare": {
      "Success": {
        "Title": "Subscribed Lipp POS",
        "Description": "Lipp POS has been subscribed successfully."
      },
      "Error": "Could not subscribe Lipp POS"
    },
    "Update": {
      "Success": {
        "Title": "Updated Lipp POS",
        "Description": "Lipp POS has been updated successfully."
      },
      "Error": "Could not update Lipp POS"
    },
    "Activate": {
      "Success": {
        "Title": "Activated Lipp POS",
        "Description": "Lipp POS has been activated successfully."
      },
      "Error": "Could not activate Lipp POS"
    }
  },
  "LippPMSDialog": {
    "Title": "Subscribe to Lipp PMS",
    "StartTitle": "Start Lipp PMS",
    "ExpandTitle": "Change Lipp PMS",
    "UpdateAction": "Change",
    "Tabs": {
      "Rooms": "Rooms",
      "Integrations": "Integrations and extensions",
      "Summary": "Summary"
    },
    "Rooms": {
      "Title": "Rooms",
      "ActiveInPms": "Active in PMS: {0}",
      "ActiveInPmsUnavailable": "Active rooms in the PMS cannot be retrieved right now, so reducing is locked.",
      "ActiveInPmsLoading": "Loading active rooms in the PMS …"
    },
    "Integrations": {
      "Title": "Integration slots",
      "InUse": "{0} slots are in use. Release integrations first to reduce."
    },
    "Extensions": {
      "Title": "Extension slots",
      "InUse": "{0} slots are in use. Release extensions first to reduce."
    },
    "BasePrice": "Lipp PMS base software",
    "PricePerRoom": "{0} per room and month",
    "PricePerSlot": "{0} per slot and month",
    "PricePerMonth": "{0} / month",
    "Included": {
      "Title": "Included in the base price",
      "Backup": "Cloud backup",
      "Videos": "Tutorial videos",
      "Support": "365 days customer service",
      "Installation": "Initial installation",
      "Fiscal": "RKSV or TSE"
    },
    "Summary": {
      "Total": "Total {0} / month",
      "TotalLabel": "Total",
      "Before": "Before",
      "After": "After",
      "CountWithPrice": "{0}x, {1} / month"
    },
    "Prepare": {
      "Success": {
        "Title": "Subscribed Lipp PMS",
        "Description": "Lipp PMS has been subscribed successfully."
      },
      "Error": "Could not subscribe Lipp PMS"
    },
    "Update": {
      "Success": {
        "Title": "Updated Lipp PMS",
        "Description": "Lipp PMS has been updated successfully."
      },
      "Error": "Could not update Lipp PMS"
    },
    "Activate": {
      "Success": {
        "Title": "Activated Lipp PMS",
        "Description": "Lipp PMS has been activated successfully."
      },
      "Error": "Could not activate Lipp PMS"
    }
  },
  "LippPOSPaymentDialog": {
    "Title": "Subscribe to Lipp POS",
    "BasePrice": "Base price",
    "PricePerMonth": " {0} € / month",
    "AdditionalWorkstations": "More Lipp POS workstations",
    "Rksv2017": "§ RKSV 2017 (Signature)",
    "AllInCarefreePackage": "All-in-carefree-package",
    "ChoosePaymentInterval": "Choose payment interval",
    "Yearly": "yearly",
    "ThreeYearsBinding": "(3 years commitment)",
    "FiveYearsBinding": "(5 years commitment)",
    "PaymentStart": "Payment start",
    "SubscribeWithCosts": "Subscribe with costs"
  },
  "LippCare": {
    "Devices": {
      "Title": "Devices",
      "CashSystems": "Cash systems",
      "Printers": "Printers",
      "MobileDevices": "Mobile devices",
      "ArticleNumber": "Article No.",
      "Name": "Name",
      "SerialNumber": "SN",
      "Return": "Return",
      "NextReplacement": "Next 5-year exchange",
      "ErrorLoading": "Could not load devices"
    },
    "History": {
      "Title": "History",
      "Balance": "Balance",
      "5YearReturn": "5-year exchange",
      "ErrorLoading": "Could not load history",
      "ErrorLoadingInvoice": "Could not load invoice"
    },
    "Dialogs": {
      "ReturnDevice": {
        "Title": "Return device",
        "Description": "Do you really want to return the device <b>{0}</b> with the serial number <b>{1}</b>?",
        "Return": "Return",
        "Success": {
          "Title": "Returned device",
          "Description": "The device <b>{0}</b> with the serial number <b>{1}</b> has been returned successfully."
        },
        "Error": "Could not return device"
      },
      "LippCareSelection": {
        "Title": "Lipp Care selection",
        "ExpandTitle": "Expand Lipp Care",
        "ReduceTitle": "Reduce Lipp Care",
        "ExpandAction": "Expand",
        "ReduceAction": "Reduce",
        "ErrorLoadingProducts": "Could not load products",
        "PosSystems": "POS systems/kitchen & bar monitors",
        "Printer": "Printer",
        "Handhelds": "Handhelds",
        "SumPerMonth": "Sum {0} / month",
        "Discount": "Discount",
        "PricePerMonth": "{0} / month",
        "Confirm": "Confirm",
        "SelectedCountPrice": "{0} selected {1} / month",
        "DefaultPrice": "{0} / month per device",
        "Tabs": {
          "CashSystem": "POS systems",
          "Printer": "Printer",
          "Mobile": "Handhelds",
          "Summary": "Summary"
        },
        "Summary": {
          "Before": "Before",
          "After": "After",
          "CountWithPrice": "{0}x — {1} / month",
          "TotalLabel": "Total"
        },
        "Devices": {
          "Title": "Devices",
          "ArticleNumber": "Article number",
          "ArticleDescription": "Description",
          "SerialNumber": "Serial number",
          "MarkForReturn": "Mark for return",
          "MarkedForReturn": "Marked for return",
          "MarkedInCategory": "{0} marked for return"
        },
        "Success": {
          "ActivationTitle": "Lipp Care prepared",
          "ActivationSubject": "Lipp Care has been prepared successfully.",
          "UpdateTitle": "Lipp Care changed",
          "UpdateSubject": "Lipp Care has been successfully changed.",
          "ReduceTitle": "Lipp Care reduced",
          "ReduceSubject": "{0} device(s) have been submitted for return."
        },
        "Error": {
          "Title": "Could not subscribe Lipp Care"
        }
      },
      "LippCareSubscription": {
        "Title": "Subscribe to Lipp Care",
        "AllInCarefreePackage": "All-in-carefree-Package",
        "PricePerMonth": " {0} / month",
        "ChoosePaymentInterval": "Choose payment interval",
        "PaymentStart": "Payment start",
        "SubscribeWithCosts": "Subscribe with costs",
        "Yearly": "Yearly",
        "ThreeYearsBinding": "(3 years binding)",
        "FiveYearsBinding": "(5 years binding)",
        "BasePrice": "{0}x baseprice",
        "FurtherWorkstations": "{0}x further Lipp POS workstations",
        "RKSV": "{0}x § RKSV 2017 (Singature)",
        "Success": {
          "Title": "Lipp Care subscribed",
          "Description": "Lipp Care has been subscribed successfully."
        },
        "Error": {
          "Title": "Could not subscribe Lipp Care"
        }
      }
    },
    "EnterpriseNotAllowedForTests": {
      "Title": "Enterprise not allowed for Lipp Care",
      "Description": "Only Enterprises with customer number <b>{0}</b> are allowed for tests in Dev & Staging."
    },
    "Errors": {
      "ErrorLoadingLippCareDevices": "Error when loading Lipp Care devices."
    }
  },
  "RKSVDialog": {
    "Title": "Subscribe to RKSV 2017",
    "Basic": "Basic",
    "Advanced": "Advanced",
    "Premium": "Premium",
    "Per5Years": "{0} € / 5 Years",
    "BasicDescription": "Up to 10,000 signatures / year",
    "AdvancedDescription": "Up to 30,000 signatures / year",
    "PremiumDescription": "Unlimited signatures",
    "SelectPaymentInterval": "Select payment interval",
    "OneTimePayment": "One-time (for the next 5 years)",
    "SubscribeWithCosts": "Subscribe with costs"
  },
  "CreateVersion": {
    "Title": "Create update",
    "UpdateTitle": "Update version",
    "VersionTitle": "Title",
    "Headline": "Headline",
    "Description": "Description",
    "CreateEntry": "Create entry",
    "SelectType": "Select type",
    "News": "News",
    "BugFix": "Bug fix",
    "Info": "Information",
    "Button": "Button",
    "ButtonSettings": "Button settings",
    "ButtonText": "Button text",
    "ButtonLink": "Button link",
    "PublishNow": "Publish now",
    "Create": "Create",
    "Edit": "Edit",
    "Category": "Category",
    "Version": "Version",
    "FromVersion": "From 0.0.0",
    "StorjKey": "Storj Key",
    "File": "File",
    "Type": "Type",
    "Discover": "Discover",
    "ExplanatoryVideo": "Explanatory video",
    "Link": "Link"
  },
  "DeleteVersionDialog": {
    "Title": "Delete version",
    "Description": "Do you really want to delete the version <b>{0}</b>?",
    "Delete": "Delete"
  },
  "VersionOverview": {
    "Title": "There are news!",
    "UpdateHistory": "Update history",
    "Ready": "Ready, set, go!"
  },
  "Updates": {
    "CreateUpdate": "Create update",
    "Updates": "Updates",
    "NewsAndImprovements": "News & Improvements",
    "PublishUpdate": "Publish update",
    "LoadingError": "Could not load versions.",
    "Discover": "Discover",
    "ExplanatoryVideo": "Explanatory video"
  },
  "InputPlaceholders": {
    "CharsPlaceholder": "{0}-{1} Characters",
    "MinCharsPlaceholder": "min. {0} Characters"
  },
  "Marketplace": {
    "Subscriptions": {
      "Title": "Subscriptions",
      "Subscription": "Subscription",
      "Quantity": "Quantity",
      "Module": "Subscription",
      "Description": "Description",
      "TotalPriceNet": "Total price net",
      "PriceInfo": "Price info",
      "PaymentInterval": "Payment interval",
      "PaymentMethod": "Payment method",
      "Note": "Note",
      "ErrorLoading": "Error loading subscriptions",
      "ChangeLicenceQuantityDisabledTooltip": "To change the licence quantity, the subscription must fist be canceled and licenced again",
      "PaymentIntervals": {
        "Once": "once",
        "Daily": "daily",
        "Monthly": "monthly",
        "Yearly": "yearly",
        "YearsCommitment": "yearly ({0} years commitment)",
        "SeasonalWithMonths": "seasonal ({0} months)"
      },
      "FromDate": "from {0}",
      "PerUnit": "per {0}",
      "Units": {
        "Hour": "Hour",
        "SMS": "SMS",
        "Report": "Report",
        "POS": "POS",
        "Device": "Device",
        "5Years": "5 Years",
        "Station": "Station"
      },
      "TrialUntil": "Trial until {0}",
      "AvailableUntil": "{0}x {1} available until {2}",
      "DeactivationOn": "Deactivation on {0}",
      "ActivationOn": "Activation on {0}",
      "CertificateRenewedOn": "Certificate will be renewed on {0}",
      "PaymentPending": "Payment pending",
      "WaitingForPaymentReceipt": "Waiting for payment receipt",
      "PaymentBy": "Payment by {0}",
      "PaymentMethods": {
        "0": "Unknown",
        "1": "Credit card",
        "2": "S€PA",
        "3": "Hogast",
        "9999": "manual debit"
      },
      "PrepareForActivation": "Ready for payment",
      "Scheduled": "Scheduled",
      "PendingDeactivation": "Deactivation pending",
      "PaymentFailed": "Payment failed",
      "Deactivated": "Deactivated",
      "Suspended": "Suspended",
      "Expired": "Expired",
      "SwitchToManualPayment": "Switch to manual payment",
      "SwitchedToManualPayment": {
        "Success": {
          "Title": "Switched payment",
          "Description": "The payment has been sucessfully switched to manual payment."
        },
        "Error": "Could not switch payment"
      },
      "AddPaymentMethodTooltip": "Please add a payment method!",
      "ErrorLoadingPaymentMethods": "Could not load payment methods",
      "AddPaymentMethod": "Please add a <u>payment method</u>!",
      "ErrorRedirectingToCheckout": "Could not redirect to checkout",
      "CancelSubscriptions": "Cancel subscriptions",
      "Device": "{0} Device",
      "Devices": "{0} Devices"
    },
    "Log": {
      "Title": "Log",
      "ModuleName": "Subscription",
      "Description": "Description",
      "InternalNotes": "Internal notes",
      "User": "User",
      "DateTime": "Date/Time"
    },
    "Lipp": {
      "Title": "Lipp"
    },
    "Integrations": {
      "Title": "Integrations",
      "ManageLicences": "Manage licences",
      "NoLicenseRequired": "Does not require an integration license",
      "Categories": {
        "All": "All",
        "Accounting": "Accounting",
        "Vouchers": "Voucher management",
        "HotelSoftware": "Hotel software",
        "CardPayment": "Card payment",
        "CashDrawer": "Cash drawer",
        "WaiterLock": "Waiter lock",
        "CustomerDisplay": "Customer display",
        "CustomerCards": "Customer cards",
        "DispensingSystem": "Dispensing system",
        "InventoryManagement": "Inventory management",
        "ChannelManager": "Channel manager",
        "GuestLoyalty": "Guest loyalty",
        "POS": "POS system",
        "Correspondence": "Correspondence",
        "GuestRegistration": "Guest registration",
        "RevenueManagement": "Revenue management",
        "AccessControl": "Access control"
      },
      "LippPMS": {
        "Title": "Lipp PMS",
        "SlotsInUseSingular": "{0} of {1} slot in use",
        "SlotsInUsePlural": "{0} of {1} slots in use",
        "ManageSlots": "Manage slots",
        "NotBookedTitle": "These integrations need Lipp PMS.",
        "NotBookedDescription": "The integrations for your hotel belong to the Lipp PMS subscription. Once Lipp PMS is booked, you can activate them here.",
        "Book": "Book Lipp PMS",
        "RequiresBase": "Requires Lipp PMS",
        "NotAvailableTitle": "Lipp PMS not available",
        "NotAvailableDescription": "Lipp PMS cannot be booked for this station right now. Please contact Lipp support."
      }
    },
    "Extensions": {
      "Title": "Extensions",
      "ManageLicences": "Manage licences",
      "LippPMS": {
        "Title": "Lipp PMS",
        "NotBookedTitle": "These extensions need Lipp PMS.",
        "NotBookedDescription": "The extensions for your hotel belong to the Lipp PMS subscription. Once Lipp PMS is booked, you can activate them here."
      }
    },
    "SetupRequired": {
      "Title": "Lipp POS has to be setup.",
      "DescriptionExtensions": "Once the setup of your Lipp POS is completed, you will see all extensions available for your version here.",
      "DescriptionIntegrations": "Once the setup of your Lipp POS is completed, you will see all integrations available for your version here.",
      "GoToSetup": "Go to setup"
    },
    "Shop": {
      "Title": "Shop"
    }
  },
  "CancelSubscriptionsDialog": {
    "Title": "Cancel subscriptions",
    "Warning": "The content of canceled subscriptions can no longer be accessed!",
    "Error": "Could not cancel subscriptions",
    "Cancel": "Cancel",
    "CancellationDate": "as of {0}"
  },
  "UnsavedChanges": {
    "Title": "Leave page?",
    "Description": "You have unsaved changes. Do you really want to leave the page?"
  },
  "CrossEnterpriseVouchers": {
    "Title": "Voucher management",
    "StationName": "Location",
    "CustomerName": "Customer",
    "NoVoucherGroup": "None of your locations belongs to a group with shared voucher management.",
    "ErrorLoading": "Could not load the voucher groups.",
    "NoShopStation": "None of your locations in this group has voucher management active – online vouchers are only available there.",
    "ShopVersion": "Online voucher sales require Lipp POS 1.38.0 or newer at “{0}” (reported: {1}).",
    "VersionUnknown": "unknown"
  },
  "CrossEnterpriseUsers": {
    "NotAvailableYet": "Users can be assigned to locations here after the next Lipp Connect update.",
    "NoEntries": "No entries",
    "Active": "Active",
    "PermissionRoleDiffers": "different",
    "AddToStation": "Create at this location",
    "ActiveAt": "Active at: {0}",
    "InactiveEverywhere": "Not active at any location",
    "SearchPlaceholder": "Search...",
    "NotUnique": "Not unique – can only be maintained on the location's page",
    "NotUniqueIn": "more than once in {0}",
    "ErrorLoading": "The users of the locations could not be loaded.",
    "ErrorLoadingRetry": "The users of the locations could not be loaded. Assigning is possible again after “Refresh”.",
    "ErrorSaving": "The assignment could not be saved.",
    "SavePartlyFailed": "Not saved at all locations",
    "Dialog": {
      "Title": "Assign locations – {0}",
      "ConfirmTitle": "Apply assignment – {0}",
      "Station": "Location",
      "NotCreated": "not created",
      "WillBeCreated": "will be created",
      "ConfirmDescription": "Applying changes the following per location:",
      "NoChanges": "Nothing to change – the locations are already set this way.",
      "Created": "Will be created, permission role {0}",
      "Activated": "Will be active",
      "Deactivated": "Will be inactive",
      "RoleChanged": "Permission role {0} → {1}",
      "WaiterLockHint": "Assign the waiter key once at the POS of this location.",
      "Apply": "Apply"
    }
  },
  "CrossEnterpriseArticles": {
    "HasDeviations": "The locations differ for this article, e.g. in price or printers.",
    "MixedIsActive": "Differs between the locations. A click activates it everywhere.",
    "OtherArticles": {
      "NotEditable": "Articles not the same in all locations (type, commodity group, number, name): {0} – not editable here",
      "NotSelectable": "Articles not the same in all locations (type, commodity group, number, name): {0} – not selectable",
      "Show": "Show",
      "Hide": "Hide"
    },
    "MoreNotShown": "… and {0} more – narrow down with the search",
    "MoreCount": "… and {0} more",
    "ImageNumber": "Image {0}",
    "ArticleNotInAllStations": "This article is not the same in all selected locations. It can only be edited on the location's page.",
    "ErrorLoadingRetry": "The comparison of the locations could not be loaded. Editing is possible again after “Refresh”.",
    "Reload": "Reload",
    "MissingIn": "missing in",
    "DifferentIn": "differs in",
    "DifferentValue": "{0} \"{1}\"",
    "DifferentTypeOrTax": "type or tax rate/revenue group of the commodity group",
    "LockedAddon": "This article is not the same in all locations. The subsequent position stays as it is in each location, including sequence and order.",
    "LockedPackageItem": "Contains an article that is not the same in all locations and therefore stays as it is in each location. It can only be changed on the location's page.",
    "ErrorLoading": "Could not load the articles of the locations.",
    "ErrorChangingIsActive": "Could not change the article in all locations.",
    "SavePartlyFailed": "Not saved in all locations",
    "Layout": {
      "Deviations": "The locations differ. Saving gives all locations this profile:",
      "OnlyInOtherStations": "{0}: only in {1}, stays unchanged there",
      "DeleteInAllStations": "It will be deleted in all selected locations: {0}",
      "ProfilesNotInAllStations": "Not selectable because not present exactly once in every location: {0}. If a layout group is missing in a location, create it with \"+\" next to the layout group under the same name; if it exists twice there, rename one of them on that location's page.",
      "ProfileConcerns": "affects: {0}"
    },
    "Dialog": {
      "Deviations": "The locations differ. Saving gives all locations the values from this dialog.",
      "DeviationsDetails": "Differences (overwritten when saving)",
      "NotInAllStationsDetails": "Not available in all locations (stays unchanged per location)",
      "NotInAllStations": "Not all commodity groups, courses, printers and price lists exist in every location; those cannot be selected."
    },
    "Confirm": {
      "Title": "Apply to all locations?",
      "Description": "Saving changes the following per location:",
      "NoChanges": "no change",
      "Apply": "Apply"
    },
    "Fields": {
      "Name": "Name",
      "Number": "Art. no.",
      "Description": "Description",
      "Image": "Image",
      "CommodityGroup": "Commodity group",
      "PriceGross": "Price",
      "PriceLists": "Price lists",
      "Costs": "Purchase price",
      "MarkupPercent": "Markup",
      "IsNegative": "Sign",
      "Course": "Course",
      "Printers": "Printers",
      "Barcodes": "Barcodes",
      "TextEntryForBooking": "Text entry when booking",
      "PriceEntryForBooking": "Price entry when booking",
      "ExternalDocumentNumberEntryForBooking": "External document number when booking",
      "IsDiscountable": "Discountable",
      "IsIncludedInParentPrice": "Included in the main article's price",
      "Addons": "Subsequent positions",
      "Package": "Package components",
      "ProductionTimes": "Preparation times",
      "Deposit": "Deposit",
      "Weight": "Weight",
      "IsActive": "Active",
      "LayoutItems": "Tiles in the booking screen",
      "LayoutGroupCreated": "Main group added",
      "LayoutGroupChanged": "Main group overwritten",
      "LayoutGroupDeleted": "Main group deleted",
      "LayoutTilesEmpty": "Tiles without a matching or active article (stay empty)",
      "LayoutTilesReplaced": "Tiles only this location has (will be replaced or removed)"
    }
  },
  "CrossEnterpriseLippPOS": {
    "SelectEnterprise": "Select enterprise",
    "Stations": "Stations",
    "All": "All",
    "Lists": {
      "NoCommonReport": "No template is available at all selected stations.",
      "StationsWithoutReport": "Not selectable, no template found for this list: {0}",
      "StationsWithoutMatch": "No matches for the criteria, not in the document: {0}",
      "ErrorLoadingCriteria": "Could not load criteria"
    },
    "BMDExport": {
      "Title": "Export",
      "Export": "Export",
      "Error": "Could not create BMD export",
      "ErrorLoadingSettings": "Could not load settings",
      "NoSettingsSavedYet": "No BMD ettings have been saved for the stations <b>{0}</b> yet.",
      "LatestExportInfo": "Last exported by <b>{0}</b> on <b>{1}</b> at <b>{2}</b>"
    }
  },
  "Vouchers": {
    "Title": "Vouchers",
    "CreateVoucher": "Create voucher",
    "Status": {
      "Active": "Active",
      "Open": "Open",
      "Redeemed": "Redeemed",
      "Canceled": "Canceled"
    },
    "Grid": {
      "Description": "Description",
      "Number": "Number",
      "Date": "Date",
      "Creator": "Creator",
      "Amount": "Amount",
      "RemainingAmount": "Remaining",
      "Status": "Status"
    },
    "Templates": {
      "Title": "Voucher templates",
      "Grid": {
        "Name": "Name",
        "IsActive": "Active"
      }
    },
    "ErrorLoading": "Could not load vouchers",
    "ErrorLoadingTemplates": "Could not load voucher templates"
  },
  "Stripe": {
    "Error": "Error with payment provider",
    "ErrorLoading": "Could not load Stripe.",
    "NotInitialized": "Stripe has not been initialized."
  },
  "CancellationReasons": {
    "0": "Requested by customer",
    "1": "Contract termination",
    "2": "Duplicate",
    "3": "Not satisfied by product",
    "4": "Order changed",
    "5": "Fraudulent",
    "6": "Dispute",
    "99": "Other"
  },
  "Lipp": {
    "Abstractions": {
      "Messages": {
        "NoQuantityChangeMessage": "Quantity has not been changed.",
        "EnterpriseAdministrationNotPermittedMessage": "You are not permitted to administer the enterprise {0}.",
        "SeasonalRequiresStripeProductMessage": "Seasonal subscription requires a linked Stripe product on module {0}.",
        "SeasonalRequiresMonthlyBasePriceMessage": "Seasonal subscription requires a monthly base price on module {0}.",
        "SeasonRangeMismatchMessage": "Active months ({0}) do not match the season range {1}–{2} (computed: {3}).",
        "SeasonalFieldsMissingMessage": "Seasonal subscription requires active months, season start and season end.",
        "SeasonalFieldsOutOfRangeMessage": "Active months (1–11), season start and season end (1–12) must be valid. Start must differ from end."
      }
    }
  }
}
